// export const CHARS = {
// 	...{
// 		A: [
// 			{
// 				id: "nYznTDH-nafpRmXTHOFh5",
// 				type: "freedraw",
// 				x: 879.0293554771021,
// 				y: 198.42765608943984,
// 				width: 59.01411333661963,
// 				height: 83.35135606340194,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 19594954,
// 				version: 44,
// 				versionNonce: 1338272010,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146763067,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, 1.6281213639984458],
// 					[0.5539841524254143, 1.6281213639984458],
// 					[0.5539841524254143, 0],
// 					[0, -3.2520138413372024],
// 					[-1.0614505515937935, -7.578164894247379],
// 					[-2.169418856444736, -12.458300099583084],
// 					[-4.338837712889358, -19.482480841404993],
// 					[-5.95427241690868, -25.98227963741968],
// 					[-9.189370711607012, -36.25847422057882],
// 					[-11.912773720477048, -43.316486055678666],
// 					[-13.52820842449637, -49.270758472587346],
// 					[-15.143643128515691, -56.29493921440928],
// 					[-17.313061984960314, -64.42708826108213],
// 					[-19.48670972806474, -71.4512690029041],
// 					[-20.548160279658646, -75.7774200558143],
// 					[-22.2058838502752, -80.10357110872451],
// 					[-23.82554744095421, -81.72323469940349],
// 					[-24.33724272678228, -81.72323469940349],
// 					[-25.440982144973418, -81.72323469940349],
// 					[-26.5066615832269, -81.72323469940349],
// 					[-28.676080439671637, -81.72323469940349],
// 					[-30.291515143690958, -81.20308164025593],
// 					[-33.568902304986636, -77.39708364649329],
// 					[-35.73832116143126, -73.07093259358308],
// 					[-37.35375586545058, -69.2733923731399],
// 					[-39.523174721895316, -64.42708826108213],
// 					[-41.69259357833994, -59.546953055746485],
// 					[-43.31225716901895, -53.04292537307208],
// 					[-44.92769187303816, -46.538897690397704],
// 					[-45.99337131129175, -39.51048806191602],
// 					[-47.60880601531096, -33.00646037924162],
// 					[-49.26652958592763, -25.432524371653955],
// 					[-51.94764372820043, -16.78445115249326],
// 					[-53.05561203305126, -12.458300099583084],
// 					[-54.67104673707058, -10.276194583159167],
// 					[-56.28648144108979, -8.13214904667285],
// 					[-57.35216087934339, -5.950043530248934],
// 					[-57.9061450317688, -3.8059979937626736],
// 					[-58.460129184194216, -0.5539841524254712],
// 					[-58.460129184194216, 0],
// 					[-56.840465593515205, -2.6980296889117312],
// 					[-54.11706258464517, -7.578164894247379],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.03921568766236305, 0.027450980618596077,
// 					0.08235294371843338, 0.10588235408067703, 0.125490203499794, 0.1411764770746231,
// 					0.16078431904315948, 0.16862745583057404, 0.18431372940540314,
// 					0.1921568661928177, 0.20000000298023224, 0.20000000298023224,
// 					0.20000000298023224, 0.20000000298023224, 0.20000000298023224,
// 					0.20392157137393951, 0.20000000298023224, 0.20000000298023224,
// 					0.20392157137393951, 0.20392157137393951, 0.20392157137393951,
// 					0.2078431397676468, 0.21176470816135406, 0.21568627655506134,
// 					0.21960784494876862, 0.21960784494876862, 0.21960784494876862,
// 					0.21960784494876862, 0.21960784494876862, 0.21176470816135406,
// 					0.2078431397676468, 0.20392157137393951, 0.20000000298023224,
// 					0.19607843458652496, 0.20000000298023224, 0.19607843458652496,
// 					0.19607843458652496, 0.1882352977991104, 0.16862745583057404,
// 					0.15294118225574493, 0.08627451211214066, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-54.11706258464517, -7.578164894247379],
// 			},
// 			{
// 				id: "9TkiJYZS_oZ09hih4x3OI",
// 				type: "freedraw",
// 				x: 860.0966299014627,
// 				y: 160.54106050486254,
// 				width: 30.845499296116373,
// 				height: 1.6238924773387282,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 714670550,
// 				version: 9,
// 				versionNonce: 1266339274,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146763390,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.5116952858280683, -1.074137211573003],
// 					[-1.6154347040193215, -1.6238924773387282],
// 					[-10.847094282223566, -1.6238924773387282],
// 					[-18.421030289811256, -1.6238924773387282],
// 					[-25.994966297398832, -0.5539841524254427],
// 					[-30.333804010288304, -0.5539841524254427],
// 					[-30.333804010288304, -0.5539841524254427],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.054901961237192154, 0.14509804546833038,
// 					0.1882352977991104, 0.18431372940540314, 0.14509804546833038,
// 					0.09803921729326248, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-30.333804010288304, -0.5539841524254427],
// 			},
// 		],
// 		B: [
// 			{
// 				id: "VLJ-K3FEGPmJpaPZyQCaf",
// 				type: "freedraw",
// 				x: 841.6755996116515,
// 				y: 194.1015050365296,
// 				width: 42.758273016593535,
// 				height: 72.0010242686698,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 4547402,
// 				version: 55,
// 				versionNonce: 1145984150,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146765667,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.553984152425528, 0],
// 					[0.553984152425528, -4.880135205335648],
// 					[0, -10.27619458315911],
// 					[-2.169418856444736, -20.581991372936443],
// 					[-3.789082447123633, -32.48630732009403],
// 					[-4.338837712889358, -42.21274663748747],
// 					[-4.338837712889358, -49.27075847258732],
// 					[-3.2350982946982185, -54.66681785041078],
// 					[-1.6196635906790107, -61.72060079885091],
// 					[-0.5116952858279546, -65.49699658599539],
// 					[0.553984152425528, -68.19925516156687],
// 					[2.723403008870264, -70.37290290467132],
// 					[4.892821865315, -70.92688705709676],
// 					[8.677675425778943, -72.0010242686698],
// 					[11.358789568051634, -72.0010242686698],
// 					[14.636176729347312, -72.0010242686698],
// 					[17.317290871620116, -71.45126900290407],
// 					[20.040693880490267, -70.37290290467132],
// 					[22.759868002700614, -68.74478154067285],
// 					[24.891226879207807, -66.04675185176112],
// 					[26.54895044982436, -63.348722162849356],
// 					[27.610401001418268, -58.472815844173454],
// 					[28.16438515384357, -55.774786155261694],
// 					[27.060645735652542, -51.96878816149905],
// 					[24.379531593379625, -47.64263710858884],
// 					[20.040693880490267, -43.8366391148262],
// 					[15.14787201517538, -41.13860942591444],
// 					[9.743354864032426, -39.51048806191599],
// 					[5.404517151142954, -38.99033500276843],
// 					[2.723403008870264, -37.886595584577265],
// 					[2.169418856444736, -37.886595584577265],
// 					[2.723403008870264, -37.366442525429704],
// 					[4.892821865315, -36.81245837300423],
// 					[9.189370711606898, -36.25847422057879],
// 					[13.52820842449637, -36.25847422057879],
// 					[18.421030289811256, -35.73832116143123],
// 					[23.82554744095421, -34.63458174324006],
// 					[29.230064592097165, -32.48630732009403],
// 					[34.12288645741205, -29.234293478756854],
// 					[37.35375586545058, -24.90814242584662],
// 					[38.41943530370418, -20.036464993830464],
// 					[38.41943530370418, -17.32997753159924],
// 					[37.35375586545058, -13.528208424496313],
// 					[33.56890230498652, -9.202057371586136],
// 					[28.16438515384357, -5.950043530248934],
// 					[21.656128584509588, -3.2520138413371455],
// 					[15.14787201517538, -1.0741372115729746],
// 					[10.297339016457954, -0.5539841524254143],
// 					[5.95427241690868, -0.5539841524254143],
// 					[3.7848535604639437, -0.5539841524254143],
// 					[2.723403008870264, -1.6238924773386998],
// 					[0, 0],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.11372549086809158, 0.13725490868091583,
// 					0.14901961386203766, 0.1568627506494522, 0.1764705926179886,
// 					0.18039216101169586, 0.1921568661928177, 0.1882352977991104, 0.1921568661928177,
// 					0.1882352977991104, 0.1882352977991104, 0.1882352977991104, 0.1921568661928177,
// 					0.20000000298023224, 0.2078431397676468, 0.2078431397676468,
// 					0.20392157137393951, 0.20392157137393951, 0.2078431397676468,
// 					0.21176470816135406, 0.21568627655506134, 0.21568627655506134,
// 					0.21960784494876862, 0.21960784494876862, 0.21568627655506134,
// 					0.21568627655506134, 0.21568627655506134, 0.21176470816135406,
// 					0.20392157137393951, 0.20000000298023224, 0.19607843458652496,
// 					0.20000000298023224, 0.20000000298023224, 0.20000000298023224,
// 					0.1921568661928177, 0.1882352977991104, 0.18431372940540314,
// 					0.18039216101169586, 0.18039216101169586, 0.19607843458652496,
// 					0.20000000298023224, 0.21176470816135406, 0.21176470816135406,
// 					0.21568627655506134, 0.21568627655506134, 0.21960784494876862,
// 					0.21960784494876862, 0.21568627655506134, 0.19607843458652496,
// 					0.14901961386203766, 0.062745101749897, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [2.723403008870264, -2.6980296889117312],
// 			},
// 		],
// 		C: [
// 			{
// 				id: "b8e16vMDqKTA4FCp8PiG7",
// 				type: "freedraw",
// 				x: 865.5011470526057,
// 				y: 117.77855860160935,
// 				width: 48.16279016773649,
// 				height: 70.92688705709676,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1856415510,
// 				version: 31,
// 				versionNonce: 1816817930,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146767860,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.0656794382535963, -0.5539841524254427],
// 					[1.0656794382535963, -1.6281213639984742],
// 					[0, -2.702258575571477],
// 					[-2.72340300887015, -3.25624272799692],
// 					[-5.958501303568369, -3.25624272799692],
// 					[-11.358789568051634, -1.074137211573003],
// 					[-18.93272557563921, 4.321922166250459],
// 					[-27.06064573565243, 12.974224272070899],
// 					[-30.295744030350647, 17.8501305907468],
// 					[-32.46516288679538, 23.280021061848203],
// 					[-35.18856589566553, 28.68030932633141],
// 					[-37.35798475211027, 35.184337009005816],
// 					[-38.97341945612948, 41.13860942591447],
// 					[-40.03909889438307, 46.53466880373796],
// 					[-40.5888541601488, 52.48894122064664],
// 					[-40.5888541601488, 54.112833697985366],
// 					[-39.52740360855489, 56.84046559351526],
// 					[-36.80400059968474, 60.092479434852464],
// 					[-34.08059759081459, 62.24075385799847],
// 					[-29.78404874452258, 65.49276769933567],
// 					[-25.44521103163322, 67.12088906333412],
// 					[-20.55238916631822, 67.67064432909984],
// 					[-14.636176729347312, 67.67064432909984],
// 					[-8.67767542577883, 67.12088906333412],
// 					[-4.892821865314886, 66.04675185176114],
// 					[-1.0656794382535963, 65.49276769933567],
// 					[2.169418856444736, 63.86464633533723],
// 					[6.508256569334094, 60.612632494000025],
// 					[7.57393600758769, 60.092479434852464],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.09019608050584793, 0.11372549086809158,
// 					0.1411764770746231, 0.1725490242242813, 0.1921568661928177, 0.20392157137393951,
// 					0.20000000298023224, 0.20000000298023224, 0.18431372940540314,
// 					0.18431372940540314, 0.18431372940540314, 0.18431372940540314,
// 					0.18431372940540314, 0.18039216101169586, 0.18039216101169586,
// 					0.20000000298023224, 0.20392157137393951, 0.21176470816135406,
// 					0.21960784494876862, 0.2235294133424759, 0.2235294133424759, 0.2235294133424759,
// 					0.22745098173618317, 0.2235294133424759, 0.21960784494876862,
// 					0.20000000298023224, 0.14509804546833038, 0.04313725605607033, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [7.57393600758769, 60.092479434852464],
// 			},
// 		],
// 		D: [
// 			{
// 				id: "sKD3-7THJGVjDDhCNqd58",
// 				type: "freedraw",
// 				x: 836.2710824605085,
// 				y: 190.84949119519246,
// 				width: 54.12129147130486,
// 				height: 80.6533263744902,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1987234262,
// 				version: 47,
// 				versionNonce: 490398550,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146776594,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, 1.6281213639984458],
// 					[0, 2.177876629764171],
// 					[0, 1.0741372115729746],
// 					[0, -2.177876629764228],
// 					[0, -8.132149046672907],
// 					[-0.5539841524254143, -16.230467000067847],
// 					[-1.6154347040192079, -28.16015626718388],
// 					[-3.2350982946982185, -41.138609425914495],
// 					[-4.850532998717426, -53.59690952549755],
// 					[-5.958501303568369, -60.09670832151221],
// 					[-6.508256569334094, -64.42285937442242],
// 					[-7.019951855162162, -68.74901042733265],
// 					[-7.019951855162162, -70.89728485047866],
// 					[-7.573936007587577, -74.14506980515611],
// 					[-8.127920160013105, -76.32717532158003],
// 					[-8.127920160013105, -75.77319116915459],
// 					[-7.573936007587577, -75.77319116915459],
// 					[-6.508256569334094, -75.25303811000703],
// 					[-5.404517151142954, -74.69905395758158],
// 					[-3.7848535604639437, -74.14506980515611],
// 					[-1.6154347040192079, -73.07093259358311],
// 					[1.6154347040193215, -71.44704011624438],
// 					[7.57393600758769, -69.29876569309835],
// 					[16.251611433366634, -66.04675185176114],
// 					[28.16438515384357, -59.54695305574651],
// 					[34.080597590814705, -54.66681785041084],
// 					[40.5888541601488, -49.790911531734906],
// 					[44.93192075969796, -42.76673078991297],
// 					[45.481676025463685, -38.960732796150324],
// 					[45.99337131129175, -34.11442868409256],
// 					[43.82395245484713, -28.16015626718388],
// 					[41.69682246499974, -24.354158273421234],
// 					[36.804000599684855, -18.958098895597743],
// 					[33.56890230498652, -14.602345636069401],
// 					[27.614629888077843, -8.652302105820468],
// 					[23.82554744095421, -5.400288264483265],
// 					[17.317290871620116, -0.5539841524254712],
// 					[11.358789568051634, 2.177876629764171],
// 					[5.958501303568482, 3.772166900484706],
// 					[2.169418856444736, 4.326151052910177],
// 					[1.0656794382535963, 4.326151052910177],
// 					[0.553984152425528, 4.326151052910177],
// 					[0.553984152425528, 2.6980296889117312],
// 					[0, 0],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.05882352963089943, 0.09803921729326248,
// 					0.13725490868091583, 0.16078431904315948, 0.18431372940540314,
// 					0.20392157137393951, 0.23137255012989044, 0.24705882370471954,
// 					0.2549019753932953, 0.24705882370471954, 0.24313725531101227, 0.250980406999588,
// 					0.2549019753932953, 0.25882354378700256, 0.250980406999588, 0.3137255012989044,
// 					0.3176470696926117, 0.32156863808631897, 0.32549020648002625,
// 					0.3294117748737335, 0.32549020648002625, 0.32156863808631897,
// 					0.30980393290519714, 0.29411765933036804, 0.29019609093666077,
// 					0.29019609093666077, 0.2980392277240753, 0.3019607961177826,
// 					0.30588236451148987, 0.29411765933036804, 0.2705882489681244,
// 					0.26274511218070984, 0.250980406999588, 0.24705882370471954,
// 					0.23137255012989044, 0.22745098173618317, 0.23137255012989044,
// 					0.23137255012989044, 0.2235294133424759, 0.21568627655506134,
// 					0.20000000298023224, 0.15294118225574493, 0.03529411926865578, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [1.6154347040193215, 2.177876629764171],
// 			},
// 		],
// 		E: [
// 			{
// 				id: "mSVoqCef3kf7wNF0zI7bV",
// 				type: "freedraw",
// 				x: 878.4796002113363,
// 				y: 115.59645308518543,
// 				width: 56.29071032774948,
// 				height: 68.74901042733262,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 2001634774,
// 				version: 42,
// 				versionNonce: 1856215114,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146780290,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.6154347040193215, 0],
// 					[2.169418856444622, 0.5539841524254427],
// 					[1.6154347040193215, 0.5539841524254427],
// 					[-4.300777732951815, 0],
// 					[-8.127920160013105, 0],
// 					[-17.87127502404553, 1.6281213639984742],
// 					[-29.741759877925233, 2.727631895529896],
// 					[-41.14283831257421, 2.727631895529896],
// 					[-48.16701905439618, 2.182105516423917],
// 					[-52.505856767285536, 2.182105516423917],
// 					[-54.12129147130486, 2.727631895529896],
// 					[-54.12129147130486, 4.35575325952837],
// 					[-53.01755205311372, 6.504027682674376],
// 					[-50.886193176606525, 10.305796789777304],
// 					[-49.22846960598997, 14.63194784268751],
// 					[-48.16701905439618, 22.210112736934917],
// 					[-48.16701905439618, 27.090247942270565],
// 					[-49.22846960598997, 38.440579737002736],
// 					[-50.336437910840914, 46.018744631250144],
// 					[-51.95187261486012, 53.072527579690245],
// 					[-53.01755205311372, 57.92306057840773],
// 					[-53.56730731887944, 60.650692473937625],
// 					[-53.01755205311372, 61.724829685510656],
// 					[-50.886193176606525, 62.79473801042394],
// 					[-47.059050749545236, 63.34872216284941],
// 					[-42.762501903253224, 64.42285937442239],
// 					[-36.804000599684855, 66.04675185176114],
// 					[-29.230064592097165, 66.60073600418656],
// 					[-21.10637331874375, 66.60073600418656],
// 					[-15.147872015175267, 66.60073600418656],
// 					[-9.743354864032312, 66.60073600418656],
// 					[-6.470196589396551, 67.12088906333412],
// 					[-1.0656794382535963, 68.22885736818506],
// 					[1.1037394181911395, 68.74901042733262],
// 					[2.169418856444622, 68.22885736818506],
// 					[2.169418856444622, 67.67487321575959],
// 					[2.169418856444622, 66.04675185176114],
// 					[2.169418856444622, 63.87310410865666],
// 					[2.169418856444622, 62.79473801042394],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.06666667014360428, 0.07058823853731155,
// 					0.10980392247438431, 0.14509804546833038, 0.16470588743686676,
// 					0.1921568661928177, 0.1882352977991104, 0.18039216101169586,
// 					0.16862745583057404, 0.14901961386203766, 0.12941177189350128,
// 					0.13725490868091583, 0.14901961386203766, 0.16862745583057404,
// 					0.18431372940540314, 0.19607843458652496, 0.1882352977991104,
// 					0.1764705926179886, 0.16470588743686676, 0.16862745583057404,
// 					0.1725490242242813, 0.1882352977991104, 0.20000000298023224, 0.2078431397676468,
// 					0.21960784494876862, 0.22745098173618317, 0.23137255012989044,
// 					0.23137255012989044, 0.23137255012989044, 0.24313725531101227,
// 					0.239215686917305, 0.24313725531101227, 0.22745098173618317,
// 					0.21568627655506134, 0.16862745583057404, 0.1568627506494522,
// 					0.08235294371843338, 0.007843137718737125, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [2.169418856444622, 62.79473801042394],
// 			},
// 			{
// 				id: "3jEznze7IV0xda2EZ_N8s",
// 				type: "freedraw",
// 				x: 875.244501916638,
// 				y: 149.1568976168525,
// 				width: 46.547355463717054,
// 				height: 5.95427241690868,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 139251350,
// 				version: 14,
// 				versionNonce: 1110339274,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146781078,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[-2.169418856444622, 0],
// 					[-3.2350982946982185, 0],
// 					[-8.677675425778716, 0],
// 					[-15.701856167600681, 1.107968304850914],
// 					[-23.27156328852857, 2.182105516423917],
// 					[-32.46516288679527, 3.8059979937626736],
// 					[-40.03909889438296, 5.434119357761119],
// 					[-43.8239524548469, 5.95427241690868],
// 					[-45.99337131129164, 5.95427241690868],
// 					[-46.547355463717054, 5.95427241690868],
// 					[-45.48167602546357, 5.434119357761119],
// 					[-44.37793660727243, 4.880135205335677],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.09803921729326248,
// 					0.11764705926179886, 0.13333334028720856, 0.1411764770746231,
// 					0.14509804546833038, 0.13725490868091583, 0.125490203499794,
// 					0.11764705926179886, 0.0941176488995552, 0.019607843831181526, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-44.37793660727243, 4.880135205335677],
// 			},
// 		],
// 		F: [
// 			{
// 				id: "gmxLIY2-QLz4Mwzc2MgES",
// 				type: "freedraw",
// 				x: 837.8865171645278,
// 				y: 196.7995347254414,
// 				width: 48.71677432016179,
// 				height: 83.38518715667988,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1836690186,
// 				version: 38,
// 				versionNonce: 1634803350,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146789881,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.5539841524254143, 1.0741372115729746],
// 					[0.5539841524254143, 2.182105516423917],
// 					[1.1079683048509423, 2.182105516423917],
// 					[1.1079683048509423, 0],
// 					[1.1079683048509423, -4.875906318675959],
// 					[1.1079683048509423, -11.900087060497924],
// 					[1.1079683048509423, -23.28002106184823],
// 					[0.5539841524254143, -37.882366697917575],
// 					[-1.0614505515937935, -51.968788161499106],
// 					[-2.169418856444736, -61.17084553308524],
// 					[-2.681114142272804, -66.04675185176114],
// 					[-3.2308694080385294, -70.37290290467135],
// 					[-3.2308694080385294, -73.62491674600855],
// 					[-3.2308694080385294, -75.76896228249484],
// 					[-3.2308694080385294, -77.39708364649331],
// 					[-3.2308694080385294, -78.47544974472606],
// 					[-3.7848535604639437, -79.02097612383204],
// 					[-3.7848535604639437, -79.57496027625749],
// 					[-3.7848535604639437, -80.09511333540505],
// 					[-3.7848535604639437, -80.64909748783052],
// 					[-3.2308694080385294, -80.64909748783052],
// 					[-2.681114142272804, -80.64909748783052],
// 					[-1.0614505515937935, -80.64909748783052],
// 					[1.619663590678897, -80.09511333540505],
// 					[5.958501303568369, -79.57496027625749],
// 					[12.978453158730531, -78.47544974472606],
// 					[21.10637331874375, -78.47544974472606],
// 					[29.230064592097165, -78.47544974472606],
// 					[36.804000599684855, -79.02097612383204],
// 					[41.69682246499963, -79.57496027625749],
// 					[43.86624132144436, -79.57496027625749],
// 					[44.37793660727243, -79.57496027625749],
// 					[44.37793660727243, -80.09511333540505],
// 					[44.37793660727243, -81.20308164025596],
// 					[44.931920759697846, -81.20308164025596],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.0784313753247261, 0.0941176488995552,
// 					0.13333334028720856, 0.1568627506494522, 0.1882352977991104,
// 					0.21960784494876862, 0.24313725531101227, 0.2549019753932953, 0.250980406999588,
// 					0.250980406999588, 0.250980406999588, 0.2549019753932953, 0.2549019753932953,
// 					0.25882354378700256, 0.25882354378700256, 0.2549019753932953, 0.250980406999588,
// 					0.250980406999588, 0.250980406999588, 0.32156863808631897, 0.33725491166114807,
// 					0.3450980484485626, 0.3490196168422699, 0.33725491166114807, 0.3333333432674408,
// 					0.3294117748737335, 0.32549020648002625, 0.32156863808631897,
// 					0.3176470696926117, 0.2980392277240753, 0.23529411852359772,
// 					0.20392157137393951, 0.003921568859368563, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [44.931920759697846, -81.20308164025596],
// 			},
// 			{
// 				id: "QorjH65H7YLl3mLVAPZfK",
// 				type: "freedraw",
// 				x: 873.0750830601934,
// 				y: 156.7350625110999,
// 				width: 35.18856589566553,
// 				height: 1.6281213639984742,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 24114314,
// 				version: 15,
// 				versionNonce: 509496662,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146790707,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.6154347040193215, 0.5539841524254712],
// 					[2.169418856444622, 0.5539841524254712],
// 					[2.72340300887015, 0.5539841524254712],
// 					[2.169418856444622, 0.5539841524254712],
// 					[-1.6154347040193215, 0.5539841524254712],
// 					[-7.019951855162276, 0.5539841524254712],
// 					[-13.532437311156059, 0],
// 					[-20.040693880490267, 0],
// 					[-25.994966297398946, 0],
// 					[-29.78404874452258, 0],
// 					[-31.911178734369855, 0],
// 					[-32.46516288679538, -0.5201530591475603],
// 					[-31.911178734369855, -1.074137211573003],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.0784313753247261, 0.06666667014360428,
// 					0.10980392247438431, 0.1411764770746231, 0.1568627506494522,
// 					0.18039216101169586, 0.18039216101169586, 0.1411764770746231,
// 					0.09803921729326248, 0.062745101749897, 0, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-31.911178734369855, -1.074137211573003],
// 			},
// 		],
// 		G: [
// 			{
// 				id: "PVQiNS8S_P-amAd7sOAo9",
// 				type: "freedraw",
// 				x: 873.0750830601934,
// 				y: 123.17461797943284,
// 				width: 53.56730731887933,
// 				height: 64.94301243356998,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1151336266,
// 				version: 44,
// 				versionNonce: 1659127510,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146798611,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.1037394181911395, 0.5539841524254427],
// 					[1.6154347040193215, 1.103739418191168],
// 					[1.1037394181911395, 0.5539841524254427],
// 					[-3.789082447123633, -1.0741372115730314],
// 					[-9.189370711607012, -1.0741372115730314],
// 					[-16.25161143336652, 0],
// 					[-25.44521103163322, 4.880135205335648],
// 					[-33.568902304986636, 12.45407121292331],
// 					[-38.97341945612948, 20.032236107170718],
// 					[-42.20851775082781, 27.090247942270565],
// 					[-43.31225716901895, 33.0402914725195],
// 					[-44.37793660727243, 41.69259357833991],
// 					[-44.37793660727243, 47.09288184282315],
// 					[-40.5888541601488, 56.84469448017498],
// 					[-37.35798475211027, 60.09670832151218],
// 					[-30.295744030350647, 63.348722162849384],
// 					[-23.82554744095421, 63.868875221996944],
// 					[-19.48670972806474, 63.868875221996944],
// 					[-14.082192576921784, 61.72482968551063],
// 					[-11.358789568051634, 59.02257110993915],
// 					[-9.189370711607012, 56.294939214409254],
// 					[-7.57393600758769, 51.44440621569177],
// 					[-5.958501303568369, 45.49436268544284],
// 					[-5.958501303568369, 42.76673078991294],
// 					[-5.958501303568369, 38.99456388942818],
// 					[-5.958501303568369, 36.81245837300426],
// 					[-5.958501303568369, 36.2923053138567],
// 					[-4.338837712889358, 35.742550048090976],
// 					[-1.6154347040193215, 35.742550048090976],
// 					[2.72340300887015, 35.742550048090976],
// 					[5.95427241690868, 35.742550048090976],
// 					[7.573936007587577, 35.742550048090976],
// 					[9.189370711606898, 35.18856589566553],
// 					[8.127920160013105, 34.66841283651797],
// 					[4.892821865314886, 34.66841283651797],
// 					[-2.169418856444736, 35.18856589566553],
// 					[-10.29733901645784, 36.2923053138567],
// 					[-18.3829703098736, 37.920426677855176],
// 					[-20.55238916631822, 38.440579737002736],
// 					[-22.210112736935002, 38.440579737002736],
// 					[-18.932725575639324, 37.920426677855176],
// 					[-17.87127502404553, 36.81245837300426],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.07450980693101883, 0.07450980693101883,
// 					0.10196078568696976, 0.1725490242242813, 0.1921568661928177,
// 					0.21176470816135406, 0.2235294133424759, 0.2235294133424759,
// 					0.23137255012989044, 0.23137255012989044, 0.23529411852359772,
// 					0.239215686917305, 0.23529411852359772, 0.21568627655506134,
// 					0.21176470816135406, 0.21176470816135406, 0.21176470816135406,
// 					0.2235294133424759, 0.2235294133424759, 0.2235294133424759, 0.2078431397676468,
// 					0.1882352977991104, 0.18039216101169586, 0.1725490242242813,
// 					0.16470588743686676, 0.16078431904315948, 0.16078431904315948,
// 					0.1725490242242813, 0.1882352977991104, 0.21568627655506134,
// 					0.23137255012989044, 0.23529411852359772, 0.2549019753932953,
// 					0.27450981736183167, 0.29411765933036804, 0.30980393290519714,
// 					0.3137255012989044, 0.2705882489681244, 0.24705882370471954,
// 					0.18431372940540314, 0.054901961237192154, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-17.87127502404553, 36.81245837300426],
// 			},
// 		],
// 		H: [
// 			{
// 				id: "oT-nxJfYR5VhU9LXsPXyD",
// 				type: "freedraw",
// 				x: 872.521098907768,
// 				y: 117.2245744491839,
// 				width: 4.338837712889358,
// 				height: 73.62491674600852,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 492036362,
// 				version: 17,
// 				versionNonce: 611646294,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146807458,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.1079683048508286, -0.5201530591475603],
// 					[1.6577235706165538, -1.0741372115730314],
// 					[2.169418856444736, -1.6281213639984742],
// 					[2.7234030088700365, -1.6281213639984742],
// 					[2.7234030088700365, 0.5539841524254427],
// 					[2.7234030088700365, 7.578164894247408],
// 					[2.7234030088700365, 18.958098895597715],
// 					[2.7234030088700365, 34.1144286840925],
// 					[3.789082447123633, 49.27075847258732],
// 					[4.338837712889358, 59.54695305574646],
// 					[4.338837712889358, 67.12088906333415],
// 					[4.338837712889358, 70.92688705709676],
// 					[3.789082447123633, 71.99679538201005],
// 					[3.2773871612955645, 71.99679538201005],
// 					[3.2773871612955645, 71.99679538201005],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.09019608050584793,
// 					0.12156862765550613, 0.18039216101169586, 0.2078431397676468,
// 					0.23529411852359772, 0.23137255012989044, 0.2235294133424759,
// 					0.21960784494876862, 0.21960784494876862, 0.21960784494876862,
// 					0.1882352977991104, 0.14509804546833038, 0.08235294371843338, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [3.2773871612955645, 71.99679538201005],
// 			},
// 			{
// 				id: "iRMYiGAwJUh_VRnWykHYF",
// 				type: "freedraw",
// 				x: 834.6556477564893,
// 				y: 122.65023603362553,
// 				width: 2.719174122210461,
// 				height: 80.65332637449023,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1491246550,
// 				version: 18,
// 				versionNonce: 2101608074,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146808131,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, -1.099510531531422],
// 					[-0.5539841524254143, -2.1736477431044534],
// 					[-1.1079683048509423, -3.2477849546774564],
// 					[-1.1079683048509423, -3.801769107102899],
// 					[-1.6196635906790107, -3.801769107102899],
// 					[-2.169418856444736, 1.078366098232749],
// 					[-2.169418856444736, 11.904315947157613],
// 					[-2.169418856444736, 27.06064573565243],
// 					[-2.169418856444736, 43.84509688814569],
// 					[-1.1079683048509423, 57.92306057840776],
// 					[-0.5539841524254143, 67.64527100914145],
// 					[-0.5539841524254143, 75.22343590338883],
// 					[-1.1079683048509423, 76.85155726738734],
// 					[-1.1079683048509423, 75.7774200558143],
// 					[-1.1079683048509423, 73.07939036690257],
// 					[0.5497552657657252, 70.3771317913311],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.06666667014360428,
// 					0.10196078568696976, 0.125490203499794, 0.1568627506494522, 0.21176470816135406,
// 					0.22745098173618317, 0.23137255012989044, 0.22745098173618317,
// 					0.23137255012989044, 0.23529411852359772, 0.239215686917305,
// 					0.23137255012989044, 0.14509804546833038, 0.08235294371843338, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [0.5497552657657252, 70.3771317913311],
// 			},
// 			{
// 				id: "RX6FL99pezCpLrrMSHXsF",
// 				type: "freedraw",
// 				x: 877.9679049255083,
// 				y: 156.7350625110999,
// 				width: 43.86624132144436,
// 				height: 3.2181827480592915,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1991455830,
// 				version: 11,
// 				versionNonce: 1818061002,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146808548,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[-0.553984152425528, -1.6238924773387282],
// 					[-2.169418856444736, -2.1440455364862885],
// 					[-9.231659578204244, -2.6980296889117312],
// 					[-20.59467803291568, -3.2181827480592915],
// 					[-31.399483448541787, -2.6980296889117312],
// 					[-40.08138776098042, -2.6980296889117312],
// 					[-43.31225716901895, -2.6980296889117312],
// 					[-43.86624132144436, -2.6980296889117312],
// 					[-43.86624132144436, -2.6980296889117312],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.10980392247438431, 0.1411764770746231,
// 					0.21960784494876862, 0.24705882370471954, 0.26274511218070984,
// 					0.23137255012989044, 0.16470588743686676, 0.11372549086809158, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-43.86624132144436, -2.6980296889117312],
// 			},
// 		],
// 		I: [
// 			{
// 				id: "cHR75KYymSgPcH0acJU98",
// 				type: "freedraw",
// 				x: 851.4189544756839,
// 				y: 119.40245107894808,
// 				width: 1.6577235706167812,
// 				height: 79.57918916291723,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1452467466,
// 				version: 26,
// 				versionNonce: 1851516566,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146812583,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.553984152425528, -1.078366098232749],
// 					[1.1037394181912532, -1.078366098232749],
// 					[1.1037394181912532, -2.177876629764171],
// 					[1.1037394181912532, -2.6980296889117312],
// 					[1.1037394181912532, -3.2520138413372024],
// 					[0.553984152425528, -0.5539841524254427],
// 					[0, 7.024180741821965],
// 					[0, 15.706085054260512],
// 					[0, 32.486307320094056],
// 					[0.553984152425528, 44.39062326725167],
// 					[0.553984152425528, 53.04292537307208],
// 					[0.553984152425528, 60.61686138065974],
// 					[0.553984152425528, 66.04675185176112],
// 					[0.553984152425528, 68.74901042733259],
// 					[0.553984152425528, 69.26916348648015],
// 					[0, 69.81891875224588],
// 					[-0.553984152425528, 70.89305596381891],
// 					[-0.553984152425528, 73.07516148024283],
// 					[-0.553984152425528, 74.69905395758153],
// 					[-0.553984152425528, 76.32717532158003],
// 					[-0.553984152425528, 75.77319116915456],
// 					[-0.553984152425528, 75.21920701672909],
// 					[-0.553984152425528, 74.14506980515611],
// 					[0.553984152425528, 73.07516148024283],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0941176488995552, 0.10588235408067703, 0.1568627506494522,
// 					0.16470588743686676, 0.21568627655506134, 0.23529411852359772,
// 					0.2549019753932953, 0.2666666805744171, 0.2549019753932953, 0.250980406999588,
// 					0.250980406999588, 0.250980406999588, 0.23529411852359772, 0.22745098173618317,
// 					0.22745098173618317, 0.2235294133424759, 0.21960784494876862,
// 					0.21176470816135406, 0.20000000298023224, 0.18039216101169586,
// 					0.08235294371843338, 0.07058823853731155, 0.04313725605607033, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [0.553984152425528, 73.07516148024283],
// 			},
// 		],
// 		J: [
// 			{
// 				id: "YnvsmRFd3eINHMgvEnaYR",
// 				type: "freedraw",
// 				x: 879.5833396295275,
// 				y: 119.40245107894808,
// 				width: 51.44017732903205,
// 				height: 1.6281213639984742,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1263307594,
// 				version: 15,
// 				versionNonce: 1500576406,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146815232,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.6196635906790107, 0.5497552657657252],
// 					[2.169418856444736, 0.5497552657657252],
// 					[1.6196635906790107, 0.5497552657657252],
// 					[-2.169418856444736, 0.5497552657657252],
// 					[-10.297339016457727, 0],
// 					[-21.65612858450936, 0],
// 					[-34.12288645741205, 0],
// 					[-42.75827301659342, -0.5539841524254427],
// 					[-47.09711072948289, -0.5539841524254427],
// 					[-49.27075847258732, -1.078366098232749],
// 					[-48.7167743201619, -0.5539841524254427],
// 					[-47.09711072948289, 0],
// 					[-44.92769187303816, 0.5497552657657252],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.0784313753247261, 0.1725490242242813,
// 					0.20000000298023224, 0.2235294133424759, 0.24705882370471954,
// 					0.2549019753932953, 0.23137255012989044, 0.2078431397676468, 0.1921568661928177,
// 					0.11764705926179886, 0.054901961237192154, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-44.92769187303816, 0.5497552657657252],
// 			},
// 			{
// 				id: "8m4nQ8Ea3_d4YcvTxsI7V",
// 				type: "freedraw",
// 				x: 854.6921127503198,
// 				y: 121.03057244294655,
// 				width: 37.35798475211027,
// 				height: 61.16661664642544,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 500127882,
// 				version: 20,
// 				versionNonce: 516887446,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146815742,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, 1.6196635906789822],
// 					[0, 2.6980296889117312],
// 					[0, 7.024180741821937],
// 					[1.6196635906790107, 16.222009226748355],
// 					[5.404517151142954, 28.12632517390594],
// 					[9.193599598266587, 37.33261143215182],
// 					[12.978453158730645, 48.16279016773643],
// 					[13.532437311156059, 52.48894122064661],
// 					[11.363018454711323, 57.36061865266282],
// 					[2.131358876507079, 60.612632494000025],
// 					[-1.1037394181911395, 61.16661664642544],
// 					[-9.743354864032312, 61.16661664642544],
// 					[-17.867046137385728, 60.612632494000025],
// 					[-21.656128584509474, 60.612632494000025],
// 					[-23.271563288528682, 59.54272416908674],
// 					[-23.82554744095421, 57.36061865266282],
// 					[-22.2058838502752, 54.112833697985366],
// 					[-21.656128584509474, 52.48894122064661],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.20000000298023224, 0.2078431397676468,
// 					0.23137255012989044, 0.239215686917305, 0.22745098173618317,
// 					0.23529411852359772, 0.26274511218070984, 0.2666666805744171,
// 					0.29019609093666077, 0.29019609093666077, 0.2862745225429535,
// 					0.2862745225429535, 0.27843138575553894, 0.25882354378700256,
// 					0.21568627655506134, 0.13333334028720856, 0.04313725605607033, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-21.656128584509474, 52.48894122064661],
// 			},
// 		],
// 		K: [
// 			{
// 				id: "KOsiOUhmjVd8bXxVdajpD",
// 				type: "freedraw",
// 				x: 837.8865171645278,
// 				y: 120.47658829052108,
// 				width: 47.10133961614258,
// 				height: 74.15352757847558,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1431466838,
// 				version: 56,
// 				versionNonce: 1644817430,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146819695,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, 1.0741372115730314],
// 					[0, 2.6980296889117596],
// 					[0, 7.578164894247408],
// 					[0, 20.58199137293647],
// 					[1.1079683048509423, 34.63458174324009],
// 					[2.169418856444622, 43.83663911482623],
// 					[2.72340300887015, 55.770557268601976],
// 					[3.277387161295678, 61.166616646425496],
// 					[3.277387161295678, 64.97261464018811],
// 					[3.277387161295678, 67.12088906333418],
// 					[3.277387161295678, 68.74478154067288],
// 					[3.277387161295678, 67.67487321575959],
// 					[3.277387161295678, 65.49276769933567],
// 					[3.277387161295678, 61.72060079885091],
// 					[3.789082447123633, 57.91460280508829],
// 					[3.789082447123633, 54.66681785041084],
// 					[4.343066599549161, 48.1923923743546],
// 					[4.343066599549161, 41.138609425914495],
// 					[5.958501303568369, 32.486307320094085],
// 					[7.573936007587577, 25.98227963741968],
// 					[11.363018454711323, 19.478251954745303],
// 					[17.317290871620003, 13.523979537836624],
// 					[25.99919518405852, 6.499798796014659],
// 					[33.0191470392208, 2.6980296889117596],
// 					[38.97341945612948, 0.5539841524254712],
// 					[42.76250190325311, -1.074137211573003],
// 					[43.86624132144436, -1.6281213639984458],
// 					[44.37793660727243, -2.152503309805752],
// 					[44.931920759697846, -2.152503309805752],
// 					[44.37793660727243, -2.152503309805752],
// 					[41.69682246499963, -1.6281213639984458],
// 					[37.357984752110156, 0],
// 					[31.9534676009672, 2.6980296889117596],
// 					[23.275792175188485, 8.127920160013133],
// 					[17.317290871620003, 13.523979537836624],
// 					[12.978453158730531, 18.958098895597743],
// 					[8.681904312438633, 23.28424994850795],
// 					[6.512485455993897, 27.056416848992683],
// 					[5.958501303568369, 29.788277631182325],
// 					[7.062240721759622, 31.932323167668613],
// 					[12.466757872902576, 36.81245837300429],
// 					[18.425259176470945, 41.69259357833994],
// 					[23.8297763276139, 47.64263710858887],
// 					[30.849728182776175, 55.770557268601976],
// 					[33.57313119164621, 58.468586957513764],
// 					[39.52740360855489, 63.34872216284941],
// 					[42.20851775082781, 66.5669049109087],
// 					[43.31648605567864, 68.74478154067288],
// 					[44.37793660727243, 69.8189187522459],
// 					[45.485904912123374, 71.44704011624435],
// 					[46.03988906454879, 71.44704011624435],
// 					[46.54735546371717, 72.00102426866982],
// 					[47.10133961614258, 70.37290290467138],
// 					[47.10133961614258, 69.8189187522459],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.16862745583057404, 0.1764705926179886, 0.1882352977991104,
// 					0.16078431904315948, 0.14509804546833038, 0.14509804546833038,
// 					0.14901961386203766, 0.16470588743686676, 0.1764705926179886,
// 					0.1725490242242813, 0.1725490242242813, 0.16470588743686676,
// 					0.16470588743686676, 0.18039216101169586, 0.1921568661928177,
// 					0.20000000298023224, 0.2235294133424759, 0.23137255012989044, 0.239215686917305,
// 					0.24313725531101227, 0.250980406999588, 0.2549019753932953, 0.25882354378700256,
// 					0.2705882489681244, 0.27450981736183167, 0.27843138575553894,
// 					0.27843138575553894, 0.2705882489681244, 0.2666666805744171,
// 					0.24705882370471954, 0.2666666805744171, 0.2705882489681244,
// 					0.26274511218070984, 0.2549019753932953, 0.250980406999588, 0.24705882370471954,
// 					0.24705882370471954, 0.24313725531101227, 0.24313725531101227,
// 					0.24705882370471954, 0.239215686917305, 0.23529411852359772, 0.239215686917305,
// 					0.24313725531101227, 0.250980406999588, 0.2705882489681244, 0.2705882489681244,
// 					0.25882354378700256, 0.24313725531101227, 0.21176470816135406,
// 					0.1725490242242813, 0.12156862765550613, 0.007843137718737125, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [47.10133961614258, 69.8189187522459],
// 			},
// 		],
// 		L: [
// 			{
// 				id: "LzKk19XN1Z6rhnSJ5L3Yz",
// 				type: "freedraw",
// 				x: 833.0359841658103,
// 				y: 113.9725606078467,
// 				width: 67.64949989580111,
// 				height: 79.57496027625746,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 698751958,
// 				version: 38,
// 				versionNonce: 788297610,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146824523,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, -1.5942902707205633],
// 					[0, -2.1482744231460345],
// 					[0.5116952858280683, -3.2224116347190375],
// 					[0.5116952858280683, -3.7721669004847627],
// 					[0.5116952858280683, -4.326151052910205],
// 					[0.5116952858280683, -3.2224116347190375],
// 					[0, 1.6238924773387282],
// 					[-1.1037394181911395, 9.202057371586136],
// 					[-2.169418856444736, 19.50785416136344],
// 					[-3.7848535604639437, 30.858185956095582],
// 					[-4.338837712889358, 39.544319155193904],
// 					[-5.442577131080498, 50.3406667975006],
// 					[-7.062240721759508, 56.29493921440928],
// 					[-9.231659578204244, 61.17084553308521],
// 					[-10.293110129798038, 64.41863048776267],
// 					[-10.847094282223452, 67.67064432909987],
// 					[-11.912773720477048, 70.37290290467135],
// 					[-11.912773720477048, 73.07093259358308],
// 					[-11.912773720477048, 74.17890089843397],
// 					[-11.358789568051634, 75.24880922334725],
// 					[-7.57393600758769, 75.24880922334725],
// 					[-3.2731582746358754, 75.24880922334725],
// 					[2.681114142272804, 75.24880922334725],
// 					[9.193599598266701, 75.24880922334725],
// 					[17.317290871620116, 74.69905395758153],
// 					[27.06064573565243, 73.07093259358308],
// 					[36.80400059968474, 71.47664232286249],
// 					[43.82395245484702, 70.92688705709676],
// 					[48.7167743201619, 70.92688705709676],
// 					[50.89042206326633, 70.92688705709676],
// 					[52.51008565394534, 70.92688705709676],
// 					[54.12129147130486, 70.37290290467135],
// 					[55.18697090955834, 69.85274984552379],
// 					[55.736726175324065, 69.29876569309832],
// 					[55.736726175324065, 68.22462848152529],
// 					[55.18697090955834, 67.67064432909987],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.07450980693101883, 0.08627451211214066,
// 					0.10980392247438431, 0.13333334028720856, 0.1764705926179886,
// 					0.19607843458652496, 0.21568627655506134, 0.21176470816135406,
// 					0.21176470816135406, 0.19607843458652496, 0.20000000298023224,
// 					0.20000000298023224, 0.20000000298023224, 0.20000000298023224,
// 					0.20392157137393951, 0.2078431397676468, 0.2078431397676468,
// 					0.21568627655506134, 0.21568627655506134, 0.22745098173618317,
// 					0.2549019753932953, 0.25882354378700256, 0.27450981736183167,
// 					0.29019609093666077, 0.2980392277240753, 0.3019607961177826, 0.3019607961177826,
// 					0.3176470696926117, 0.32549020648002625, 0.32156863808631897,
// 					0.3137255012989044, 0.30588236451148987, 0.29411765933036804,
// 					0.2862745225429535, 0.0470588244497776, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [55.18697090955834, 67.67064432909987],
// 			},
// 		],
// 		M: [
// 			{
// 				id: "Kg0X0O0QhYPXwHfLkk7NS",
// 				type: "freedraw",
// 				x: 879.0293554771021,
// 				y: 195.17564224810263,
// 				width: 50.33220902418111,
// 				height: 74.178900898434,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 123998358,
// 				version: 50,
// 				versionNonce: 700795350,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146828692,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, 0.5539841524254712],
// 					[0, -0.5539841524254712],
// 					[-0.5497552657657252, -4.880135205335648],
// 					[-1.0614505515937935, -9.206286258245882],
// 					[-2.719174122210461, -17.854359477406547],
// 					[-4.338837712889358, -29.234293478756854],
// 					[-6.508256569334094, -40.064472214341464],
// 					[-8.67767542577883, -50.86504874330791],
// 					[-9.189370711607012, -58.44321363755532],
// 					[-9.743354864032312, -65.49699658599542],
// 					[-9.743354864032312, -69.2733923731399],
// 					[-9.743354864032312, -73.07516148024283],
// 					[-9.743354864032312, -73.62491674600852],
// 					[-10.293110129798038, -73.62491674600852],
// 					[-10.80480541562622, -73.07516148024283],
// 					[-11.912773720477048, -72.0010242686698],
// 					[-14.593887862749966, -68.74901042733259],
// 					[-16.76330671919459, -63.31911995623122],
// 					[-18.421030289811256, -57.92306057840773],
// 					[-20.548160279658646, -50.86504874330791],
// 					[-21.656128584509474, -45.46476047882467],
// 					[-23.271563288528682, -41.13860942591447],
// 					[-25.440982144973418, -38.440579737002736],
// 					[-27.610401001418154, -37.33261143215182],
// 					[-29.77981985786289, -37.33261143215182],
// 					[-33.01491815256111, -39.51471694857574],
// 					[-35.184337009005844, -43.2868838490605],
// 					[-38.41943530370406, -48.16279016773643],
// 					[-41.14283831257421, -53.04292537307208],
// 					[-44.37370772061274, -57.369076425982286],
// 					[-47.09711072948289, -60.067106114894045],
// 					[-48.7167743201619, -62.24921163131796],
// 					[-49.7782248717557, -63.31911995623122],
// 					[-49.7782248717557, -62.79473801042394],
// 					[-49.7782248717557, -61.69522747889249],
// 					[-49.7782248717557, -60.067106114894045],
// 					[-50.33220902418111, -55.74095506198381],
// 					[-49.7782248717557, -49.27075847258732],
// 					[-48.16279016773649, -37.886595584577265],
// 					[-47.09711072948289, -30.862414842755328],
// 					[-45.99337131129175, -21.656128584509474],
// 					[-45.99337131129175, -14.602345636069344],
// 					[-45.99337131129175, -10.276194583159167],
// 					[-47.09711072948289, -8.13214904667285],
// 					[-47.09711072948289, -7.578164894247379],
// 					[-47.60880601531096, -7.578164894247379],
// 					[-47.60880601531096, -8.13214904667285],
// 					[-47.60880601531096, -9.206286258245882],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.12156862765550613, 0.1411764770746231,
// 					0.16862745583057404, 0.1882352977991104, 0.22745098173618317,
// 					0.24705882370471954, 0.2705882489681244, 0.27843138575553894,
// 					0.27843138575553894, 0.2823529541492462, 0.2823529541492462,
// 					0.29019609093666077, 0.29019609093666077, 0.29019609093666077,
// 					0.2823529541492462, 0.2980392277240753, 0.2980392277240753, 0.29411765933036804,
// 					0.29019609093666077, 0.2862745225429535, 0.2823529541492462, 0.2823529541492462,
// 					0.2823529541492462, 0.2862745225429535, 0.27843138575553894, 0.2666666805744171,
// 					0.2549019753932953, 0.2549019753932953, 0.2549019753932953, 0.26274511218070984,
// 					0.24705882370471954, 0.239215686917305, 0.23137255012989044,
// 					0.27450981736183167, 0.2823529541492462, 0.2823529541492462,
// 					0.27450981736183167, 0.2549019753932953, 0.2549019753932953, 0.2549019753932953,
// 					0.25882354378700256, 0.26274511218070984, 0.25882354378700256,
// 					0.24705882370471954, 0.24313725531101227, 0.22745098173618317,
// 					0.0235294122248888, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-47.60880601531096, -9.206286258245882],
// 			},
// 		],
// 		N: [
// 			{
// 				id: "VFuZRqD1Zm-gVCXFq0F3L",
// 				type: "freedraw",
// 				x: 879.5833396295275,
// 				y: 117.77855860160935,
// 				width: 50.84390431000929,
// 				height: 76.88115947400547,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1702415370,
// 				version: 51,
// 				versionNonce: 415001302,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146831941,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.511695285828182, -1.074137211573003],
// 					[0.511695285828182, -1.6281213639984742],
// 					[0.511695285828182, -2.182105516423917],
// 					[0, -1.074137211573003],
// 					[0, 3.2520138413372024],
// 					[-0.5539841524254143, 14.602345636069344],
// 					[-0.5539841524254143, 22.72603690942273],
// 					[-0.5539841524254143, 33.56044453166706],
// 					[-0.5539841524254143, 45.460531592164955],
// 					[-0.5539841524254143, 50.89042206326633],
// 					[-0.5539841524254143, 60.612632494000025],
// 					[-0.5539841524254143, 66.04675185176114],
// 					[-1.1037394181911395, 70.37290290467132],
// 					[-1.6154347040192079, 73.07093259358311],
// 					[-1.6154347040192079, 73.62491674600852],
// 					[-2.169418856444736, 73.62491674600852],
// 					[-2.72340300887015, 73.07093259358311],
// 					[-3.2731582746358754, 73.07093259358311],
// 					[-3.7848535604639437, 72.51694844115764],
// 					[-5.404517151142954, 70.89305596381888],
// 					[-8.123691273353415, 67.12088906333412],
// 					[-11.912773720477048, 61.166616646425496],
// 					[-17.867046137385728, 51.96878816149908],
// 					[-24.891226879207693, 41.13860942591447],
// 					[-31.399483448541787, 30.858185956095582],
// 					[-38.41943530370395, 22.176281643657035],
// 					[-43.31225716901895, 15.701856167600795],
// 					[-46.0356601778891, 10.825949848924864],
// 					[-47.65109488190831, 8.648073219160693],
// 					[-48.162790167736375, 7.578164894247408],
// 					[-48.162790167736375, 8.648073219160693],
// 					[-48.162790167736375, 10.276194583159139],
// 					[-48.7167743201619, 11.900087060497867],
// 					[-48.7167743201619, 12.974224272070899],
// 					[-48.7167743201619, 14.077963690262067],
// 					[-48.7167743201619, 16.775993379173798],
// 					[-48.7167743201619, 21.102144432084003],
// 					[-48.7167743201619, 28.68030932633141],
// 					[-48.7167743201619, 38.43635085034299],
// 					[-48.162790167736375, 48.716774320161875],
// 					[-48.162790167736375, 57.91460280508829],
// 					[-48.162790167736375, 65.49276769933567],
// 					[-48.7167743201619, 70.89305596381888],
// 					[-49.82051373835304, 74.14506980515608],
// 					[-49.82051373835304, 74.69905395758155],
// 					[-50.33220902418111, 74.14506980515608],
// 					[-50.33220902418111, 72.51694844115764],
// 					[-50.33220902418111, 70.37290290467132],
// 					[-49.82051373835304, 69.8189187522459],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.09803921729326248, 0.13333334028720856,
// 					0.1411764770746231, 0.20000000298023224, 0.21568627655506134,
// 					0.21568627655506134, 0.21568627655506134, 0.21176470816135406,
// 					0.21568627655506134, 0.21568627655506134, 0.21176470816135406,
// 					0.21176470816135406, 0.21176470816135406, 0.21960784494876862,
// 					0.2235294133424759, 0.22745098173618317, 0.21176470816135406,
// 					0.20392157137393951, 0.20392157137393951, 0.20392157137393951,
// 					0.21568627655506134, 0.21960784494876862, 0.2235294133424759,
// 					0.2235294133424759, 0.2235294133424759, 0.21176470816135406,
// 					0.20392157137393951, 0.20392157137393951, 0.20392157137393951,
// 					0.20392157137393951, 0.25882354378700256, 0.2549019753932953,
// 					0.24705882370471954, 0.24705882370471954, 0.24313725531101227,
// 					0.24313725531101227, 0.23529411852359772, 0.23529411852359772,
// 					0.23137255012989044, 0.23137255012989044, 0.23529411852359772,
// 					0.24313725531101227, 0.24705882370471954, 0.24313725531101227,
// 					0.23529411852359772, 0.1882352977991104, 0.13333334028720856,
// 					0.03529411926865578, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-49.82051373835304, 69.8189187522459],
// 			},
// 		],
// 		O: [
// 			{
// 				id: "3RU-p5BIbQy1qC45UubvS",
// 				type: "freedraw",
// 				x: 867.6705659090504,
// 				y: 185.96935598985675,
// 				width: 63.906935201934516,
// 				height: 77.95106779891876,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1504711318,
// 				version: 50,
// 				versionNonce: 1022692310,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146835474,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.5539841524254143, 1.0741372115730314],
// 					[1.0656794382535963, 1.0741372115730314],
// 					[2.681114142272804, -0.5201530591475603],
// 					[4.85053299871754, -2.14404553648626],
// 					[8.639615445841173, -7.024180741821908],
// 					[11.912773720477048, -12.449842326263592],
// 					[14.593887862749853, -18.404114743172244],
// 					[15.701856167600795, -24.354158273421177],
// 					[16.25584032002621, -29.234293478756854],
// 					[16.25584032002621, -34.630352856580345],
// 					[15.701856167600795, -40.064472214341436],
// 					[14.593887862749853, -45.46476047882467],
// 					[13.532437311156059, -49.78668264507513],
// 					[12.42446900630523, -53.58845175217806],
// 					[9.743354864032312, -57.36484753932254],
// 					[6.508256569334094, -60.06710611489402],
// 					[2.169418856444622, -62.24075385799847],
// 					[-2.72340300887015, -64.41863048776264],
// 					[-8.127920160013105, -66.56690491090868],
// 					[-13.52820842449637, -68.74478154067285],
// 					[-18.421030289811256, -70.89305596381888],
// 					[-22.210112736935002, -70.89305596381888],
// 					[-27.614629888077957, -69.81891875224588],
// 					[-30.845499296116373, -67.12088906333412],
// 					[-35.73832116143126, -61.690998592232745],
// 					[-36.25001644725933, -60.612632493999996],
// 					[-40.07715887432062, -55.216573116176505],
// 					[-42.758273016593535, -48.716774320161846],
// 					[-45.48167602546357, -42.208517750827724],
// 					[-47.10133961614258, -35.18433700900579],
// 					[-47.65109488190831, -28.680309326331383],
// 					[-47.65109488190831, -22.176281643657006],
// 					[-47.10133961614258, -16.222009226748327],
// 					[-44.92769187303816, -11.350331794732142],
// 					[-40.5888541601488, -5.3960593778234625],
// 					[-37.35798475211027, -2.6980296889117312],
// 					[-33.01491815256111, 1.0741372115730314],
// 					[-28.676080439671637, 4.326151052910234],
// 					[-26.5066615832269, 5.434119357761119],
// 					[-17.87127502404553, 7.058011835099876],
// 					[-10.847094282223566, 6.508256569334151],
// 					[-4.338837712889358, 4.326151052910234],
// 					[1.0656794382535963, 1.0741372115730314],
// 					[4.85053299871754, -2.14404553648626],
// 					[8.127920160013105, -6.499798796014659],
// 					[9.743354864032312, -11.350331794732142],
// 					[10.29733901645784, -17.300375324981076],
// 					[10.29733901645784, -18.92849668897955],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.08627451211214066, 0.10588235408067703, 0.125490203499794,
// 					0.13725490868091583, 0.16078431904315948, 0.1764705926179886,
// 					0.1882352977991104, 0.2078431397676468, 0.21176470816135406,
// 					0.21960784494876862, 0.22745098173618317, 0.23529411852359772,
// 					0.24313725531101227, 0.250980406999588, 0.2549019753932953, 0.2549019753932953,
// 					0.250980406999588, 0.24313725531101227, 0.24705882370471954,
// 					0.24705882370471954, 0.24705882370471954, 0.24705882370471954,
// 					0.25882354378700256, 0.26274511218070984, 0.27843138575553894,
// 					0.2823529541492462, 0.27843138575553894, 0.27843138575553894,
// 					0.27450981736183167, 0.2666666805744171, 0.2705882489681244, 0.2666666805744171,
// 					0.26274511218070984, 0.250980406999588, 0.239215686917305, 0.23529411852359772,
// 					0.23529411852359772, 0.239215686917305, 0.24705882370471954,
// 					0.26274511218070984, 0.26274511218070984, 0.26274511218070984,
// 					0.25882354378700256, 0.2549019753932953, 0.22745098173618317,
// 					0.16862745583057404, 0.07450980693101883, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [10.29733901645784, -18.92849668897955],
// 			},
// 		],
// 		P: [
// 			{
// 				id: "DZwu5KykB95Ud0CBUfeQP",
// 				type: "freedraw",
// 				x: 839.5061807552067,
// 				y: 190.29550704276699,
// 				width: 47.09711072948289,
// 				height: 75.21920701672911,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1348381194,
// 				version: 34,
// 				versionNonce: 55475094,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146838941,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, -1.6238924773387566],
// 					[-0.5116952858279546, -4.846304112057794],
// 					[-1.0656794382534827, -9.722210430733696],
// 					[-2.169418856444622, -20.028007220511],
// 					[-4.850532998717426, -36.77862727972638],
// 					[-5.958501303568369, -46.53466880373796],
// 					[-7.573936007587577, -58.43898475089557],
// 					[-7.573936007587577, -64.39325716780425],
// 					[-7.573936007587577, -67.64527100914145],
// 					[-5.958501303568369, -69.8189187522459],
// 					[-4.300777732951701, -71.44704011624435],
// 					[-2.169418856444622, -73.07093259358308],
// 					[1.1037394181912532, -74.69905395758155],
// 					[5.442577131080725, -75.21920701672911],
// 					[10.84709428222368, -74.69905395758155],
// 					[15.185931995113037, -73.59108565273064],
// 					[21.656128584509588, -71.44704011624435],
// 					[27.610401001418268, -68.74478154067288],
// 					[33.01491815256122, -66.01714964514298],
// 					[37.907740017875994, -62.2407538579985],
// 					[39.523174721895316, -58.99296890332104],
// 					[39.523174721895316, -56.29493921440928],
// 					[37.35375586545058, -53.04292537307208],
// 					[31.953467600967315, -49.790911531734906],
// 					[25.994966297398946, -46.53466880373796],
// 					[21.10214443208406, -44.39062326725167],
// 					[15.185931995113037, -42.2127466374875],
// 					[12.46675787290269, -41.658762485062056],
// 					[11.912773720477162, -41.658762485062056],
// 					[11.358789568051634, -42.2127466374875],
// 					[10.293110129798151, -42.2127466374875],
// 					[9.743354864032426, -42.762501903253224],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.16862745583057404, 0.20392157137393951,
// 					0.22745098173618317, 0.25882354378700256, 0.29411765933036804,
// 					0.2980392277240753, 0.29411765933036804, 0.2980392277240753,
// 					0.27843138575553894, 0.2823529541492462, 0.29019609093666077,
// 					0.3019607961177826, 0.30588236451148987, 0.30588236451148987,
// 					0.30588236451148987, 0.3019607961177826, 0.2980392277240753, 0.2980392277240753,
// 					0.30588236451148987, 0.3137255012989044, 0.32549020648002625,
// 					0.32549020648002625, 0.32156863808631897, 0.30980393290519714,
// 					0.3019607961177826, 0.29411765933036804, 0.25882354378700256,
// 					0.22745098173618317, 0.16862745583057404, 0.07058823853731155, 0, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [9.743354864032426, -42.762501903253224],
// 			},
// 		],
// 		Q: [
// 			{
// 				id: "1DVC-l0A76kqPeZRhHye1",
// 				type: "freedraw",
// 				x: 861.7162934921417,
// 				y: 178.39119109560937,
// 				width: 53.60959618547679,
// 				height: 64.42285937442242,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1378540374,
// 				version: 32,
// 				versionNonce: 42808854,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146842507,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.0614505515937935, 0.5539841524254712],
// 					[2.169418856444622, 0.5539841524254712],
// 					[3.7848535604639437, -1.0699083249132855],
// 					[5.400288264483265, -3.2477849546774564],
// 					[10.293110129798038, -8.643844332500947],
// 					[15.697627280940992, -15.15210090183507],
// 					[20.036464993830464, -23.280021061848203],
// 					[21.656128584509474, -31.932323167668613],
// 					[21.102144432083946, -40.064472214341464],
// 					[18.37874142321391, -48.16279016773643],
// 					[13.528208424496256, -56.290710327749565],
// 					[5.95427241690868, -61.68676970557303],
// 					[-2.173647743104425, -63.868875221996944],
// 					[-12.978453158730645, -62.2407538579985],
// 					[-20.55238916631822, -58.988740016661296],
// 					[-27.614629888077843, -52.48894122064664],
// 					[-30.849728182776175, -45.4647604788247],
// 					[-31.953467600967315, -37.33261143215182],
// 					[-31.40371233520159, -28.68030932633141],
// 					[-28.16861404050337, -18.924267802319832],
// 					[-23.275792175188485, -10.825949848924864],
// 					[-17.317290871620003, -5.396059377823491],
// 					[-9.193599598266587, -1.6196635906790107],
// 					[-2.72340300887015, 0],
// 					[2.7191741222103474, -0.5201530591475603],
// 					[5.400288264483265, -1.6196635906790107],
// 					[8.635386559181484, -3.7721669004847627],
// 					[10.293110129798038, -6.499798796014659],
// 					[11.358789568051634, -9.19782848492639],
// 					[11.358789568051634, -9.722210430733696],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.08627451211214066,
// 					0.12941177189350128, 0.14901961386203766, 0.1764705926179886,
// 					0.20000000298023224, 0.21568627655506134, 0.22745098173618317,
// 					0.24313725531101227, 0.250980406999588, 0.2549019753932953, 0.239215686917305,
// 					0.22745098173618317, 0.21960784494876862, 0.2235294133424759,
// 					0.22745098173618317, 0.23137255012989044, 0.23529411852359772,
// 					0.23529411852359772, 0.22745098173618317, 0.2235294133424759,
// 					0.2235294133424759, 0.21960784494876862, 0.23137255012989044, 0.239215686917305,
// 					0.23137255012989044, 0.1921568661928177, 0.12156862765550613,
// 					0.0313725508749485, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [11.358789568051634, -9.722210430733696],
// 			},
// 			{
// 				id: "lVUD7mN45PX3VLKvpqPKE",
// 				type: "freedraw",
// 				x: 856.8234716268269,
// 				y: 149.71088176927796,
// 				width: 18.97501444223667,
// 				height: 49.790911531734906,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1730872586,
// 				version: 12,
// 				versionNonce: 1997636886,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146842873,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.5497552657657252, 1.074137211573003],
// 					[1.1037394181912532, 2.177876629764171],
// 					[3.7848535604639437, 9.206286258245854],
// 					[9.231659578204244, 24.354158273421177],
// 					[13.016513138668188, 34.11442868409253],
// 					[16.805595585791934, 44.39062326725164],
// 					[18.97501444223667, 49.270758472587346],
// 					[18.97501444223667, 49.790911531734906],
// 					[18.97501444223667, 46.018744631250144],
// 					[18.97501444223667, 44.39062326725164],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.14509804546833038, 0.16862745583057404,
// 					0.19607843458652496, 0.23137255012989044, 0.2549019753932953,
// 					0.2705882489681244, 0.2705882489681244, 0.22745098173618317,
// 					0.07058823853731155, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [18.97501444223667, 44.39062326725164],
// 			},
// 		],
// 		R: [
// 			{
// 				id: "tBfTBHiDotY1VyudhCJy4",
// 				type: "freedraw",
// 				x: 834.1016636040639,
// 				y: 190.29550704276699,
// 				width: 54.67527562373027,
// 				height: 72.51694844115764,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 477213898,
// 				version: 45,
// 				versionNonce: 393506250,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146846687,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.5539841524254143, 0],
// 					[0.5539841524254143, -2.144045536486317],
// 					[0.5539841524254143, -8.65230210582041],
// 					[-1.0656794382535963, -18.404114743172272],
// 					[-2.169418856444736, -30.828583749477446],
// 					[-3.235098294698332, -43.83663911482623],
// 					[-3.7890824471237465, -55.1869709095584],
// 					[-3.235098294698332, -64.93878354691023],
// 					[-1.6154347040193215, -70.34330069805318],
// 					[0.5539841524254143, -71.97142206205166],
// 					[3.7848535604639437, -72.51694844115764],
// 					[9.743354864032312, -72.51694844115764],
// 					[16.25161143336652, -71.97142206205166],
// 					[21.656128584509474, -70.34330069805318],
// 					[25.440982144973418, -69.26493459982044],
// 					[27.06064573565243, -68.19502627490718],
// 					[28.676080439671637, -66.01714964514298],
// 					[29.230064592097165, -63.868875221996944],
// 					[28.676080439671637, -61.14124332646705],
// 					[26.5066615832269, -58.43898475089557],
// 					[19.48670972806474, -52.48894122064664],
// 					[12.466757872902576, -48.716774320161875],
// 					[7.062240721759622, -45.4647604788247],
// 					[4.338837712889358, -43.83663911482623],
// 					[3.7848535604639437, -42.762501903253224],
// 					[3.2350982946982185, -42.2127466374875],
// 					[3.7848535604639437, -42.2127466374875],
// 					[4.892821865314886, -41.658762485062056],
// 					[7.062240721759622, -40.584625273489024],
// 					[10.29733901645784, -38.95650390949058],
// 					[17.87127502404553, -35.184337009005816],
// 					[25.440982144973418, -30.308430690329885],
// 					[32.46516288679538, -23.800174120995763],
// 					[39.52740360855489, -16.230467000067847],
// 					[44.37793660727243, -10.276194583159167],
// 					[47.10133961614258, -7.578164894247436],
// 					[48.162790167736375, -6.470196589396494],
// 					[48.71677432016179, -6.470196589396494],
// 					[49.27075847258732, -6.470196589396494],
// 					[49.82474262501273, -6.470196589396494],
// 					[50.33220902418111, -6.470196589396494],
// 					[50.886193176606525, -6.470196589396494],
// 					[50.886193176606525, -7.024180741821965],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.09803921729326248, 0.125490203499794, 0.16078431904315948,
// 					0.20000000298023224, 0.23137255012989044, 0.2549019753932953,
// 					0.25882354378700256, 0.27450981736183167, 0.26274511218070984,
// 					0.26274511218070984, 0.27450981736183167, 0.27843138575553894,
// 					0.2823529541492462, 0.2823529541492462, 0.27843138575553894, 0.2823529541492462,
// 					0.2862745225429535, 0.2862745225429535, 0.27843138575553894,
// 					0.26274511218070984, 0.26274511218070984, 0.25882354378700256,
// 					0.2549019753932953, 0.2549019753932953, 0.25882354378700256,
// 					0.25882354378700256, 0.2549019753932953, 0.24705882370471954,
// 					0.24313725531101227, 0.24705882370471954, 0.250980406999588, 0.2666666805744171,
// 					0.27450981736183167, 0.2862745225429535, 0.2980392277240753,
// 					0.30588236451148987, 0.30980393290519714, 0.30980393290519714,
// 					0.27843138575553894, 0.2235294133424759, 0.14509804546833038,
// 					0.07450980693101883, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [50.886193176606525, -7.024180741821965],
// 			},
// 		],
// 		S: [
// 			{
// 				id: "SxvIexlZpBzvXwQI27gGa",
// 				type: "freedraw",
// 				x: 871.4596483561741,
// 				y: 124.278357397624,
// 				width: 44.8896318931005,
// 				height: 63.868875221996944,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 621096534,
// 				version: 32,
// 				versionNonce: 678029590,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146850600,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[2.169418856444736, -0.5497552657657252],
// 					[3.230869408038643, -1.103739418191168],
// 					[4.338837712889472, -2.727631895529896],
// 					[4.85053299871754, -5.429890471101373],
// 					[2.169418856444736, -7.573936007587662],
// 					[-1.1079683048508286, -8.127920160013133],
// 					[-7.024180741821965, -8.127920160013133],
// 					[-14.636176729347198, -6.499798796014659],
// 					[-23.8297763276139, -3.2477849546774564],
// 					[-31.953467600967315, 2.1482744231460345],
// 					[-35.74255004809095, 7.578164894247408],
// 					[-36.254245333919016, 12.974224272070899],
// 					[-34.12288645741194, 17.300375324981104],
// 					[-29.23006459209705, 20.552389166318278],
// 					[-21.660357471169164, 23.254647741889755],
// 					[-13.532437311155945, 26.506661583226958],
// 					[-5.404517151142954, 29.75867542456416],
// 					[1.0614505515939072, 34.084826477474365],
// 					[4.338837712889472, 38.960732796150296],
// 					[4.338837712889472, 43.840868001485944],
// 					[1.6154347040193215, 46.538897690397704],
// 					[-4.892821865314772, 50.3406667975006],
// 					[-12.466757872902463, 53.04292537307208],
// 					[-21.106373318743636, 54.112833697985366],
// 					[-30.84972818277606, 55.191199796218086],
// 					[-35.18856589566553, 55.74095506198381],
// 					[-38.97341945612948, 55.74095506198381],
// 					[-40.03909889438296, 55.74095506198381],
// 					[-40.03909889438296, 53.592680638837805],
// 					[-39.52740360855489, 52.493170107306355],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.08627451211214066,
// 					0.11764705926179886, 0.14509804546833038, 0.1725490242242813,
// 					0.20000000298023224, 0.21568627655506134, 0.21568627655506134,
// 					0.21176470816135406, 0.21176470816135406, 0.20392157137393951,
// 					0.21568627655506134, 0.21960784494876862, 0.2235294133424759,
// 					0.22745098173618317, 0.22745098173618317, 0.239215686917305, 0.2549019753932953,
// 					0.27843138575553894, 0.2862745225429535, 0.2862745225429535,
// 					0.27843138575553894, 0.2705882489681244, 0.26274511218070984,
// 					0.2549019753932953, 0.23529411852359772, 0.19607843458652496,
// 					0.0941176488995552, 0.03921568766236305, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-39.52740360855489, 52.493170107306355],
// 			},
// 		],
// 		T: [
// 			{
// 				id: "_UVbzvQ8q4N9cWYcgAUn8",
// 				type: "freedraw",
// 				x: 879.5833396295275,
// 				y: 115.59645308518543,
// 				width: 64.96838575352831,
// 				height: 5.434119357761119,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1358598346,
// 				version: 18,
// 				versionNonce: 1379701642,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146854283,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[-1.6154347040192079, 0],
// 					[-2.169418856444736, 0],
// 					[-7.57393600758769, 0],
// 					[-18.421030289811142, 0],
// 					[-29.78404874452258, 0],
// 					[-41.69682246499963, 1.107968304850914],
// 					[-50.886193176606525, 1.6281213639984742],
// 					[-58.460129184194216, 2.727631895529896],
// 					[-63.3529510495091, 3.805997993762645],
// 					[-64.4144016011029, 3.805997993762645],
// 					[-64.96838575352831, 4.35575325952837],
// 					[-64.4144016011029, 4.35575325952837],
// 					[-63.86464633533717, 4.35575325952837],
// 					[-62.79896689708369, 4.880135205335648],
// 					[-61.737516345489894, 4.880135205335648],
// 					[-59.01411333661963, 5.434119357761119],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.1411764770746231, 0.15294118225574493,
// 					0.18039216101169586, 0.20000000298023224, 0.21960784494876862,
// 					0.21960784494876862, 0.2078431397676468, 0.21176470816135406,
// 					0.19607843458652496, 0.1882352977991104, 0.1764705926179886, 0.1725490242242813,
// 					0.1411764770746231, 0.0941176488995552, 0.04313725605607033, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-59.01411333661963, 5.434119357761119],
// 			},
// 			{
// 				id: "h5i1suoGUcfLczSpaoAED",
// 				type: "freedraw",
// 				x: 847.6298720285602,
// 				y: 121.55072550209411,
// 				width: 5.404517151142954,
// 				height: 62.79473801042394,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 73076566,
// 				version: 16,
// 				versionNonce: 2044673930,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146854709,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.1079683048509423, 0],
// 					[1.1079683048509423, 0.5497552657656968],
// 					[1.6196635906790107, 1.099510531531422],
// 					[1.6196635906790107, 4.351524372868624],
// 					[1.6196635906790107, 11.929689267116032],
// 					[1.6196635906790107, 24.90814242584665],
// 					[2.723403008870264, 38.43635085034299],
// 					[4.3430665995492745, 49.8162848516933],
// 					[4.3430665995492745, 57.91883169174798],
// 					[3.7890824471237465, 61.72060079885091],
// 					[3.2350982946982185, 62.79473801042394],
// 					[3.2350982946982185, 62.27458495127638],
// 					[4.892821865315, 60.092479434852464],
// 					[5.404517151142954, 59.546953055746485],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.08627451211214066, 0.12156862765550613,
// 					0.16862745583057404, 0.18431372940540314, 0.1921568661928177,
// 					0.19607843458652496, 0.18039216101169586, 0.1764705926179886,
// 					0.18039216101169586, 0.1725490242242813, 0.14901961386203766, 0.062745101749897,
// 					0.003921568859368563, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [5.404517151142954, 59.546953055746485],
// 			},
// 		],
// 		U: [
// 			{
// 				id: "EbEkYxNIOZviYRH4SMYVh",
// 				type: "freedraw",
// 				x: 874.1788224783845,
// 				y: 123.17461797943284,
// 				width: 49.7782248717557,
// 				height: 74.69905395758153,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 2073190678,
// 				version: 38,
// 				versionNonce: 58312266,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146864084,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.0656794382534827, -0.5243819458073062],
// 					[1.6196635906790107, -0.5243819458073062],
// 					[1.6196635906790107, 3.2520138413372024],
// 					[1.6196635906790107, 7.578164894247408],
// 					[1.6196635906790107, 15.706085054260512],
// 					[2.131358876507079, 24.90814242584665],
// 					[2.681114142272804, 34.66841283651797],
// 					[2.131358876507079, 42.24657773076538],
// 					[0.511695285828182, 46.572728783675586],
// 					[-1.6577235706165538, 50.8904220632663],
// 					[-5.442577131080498, 54.14666479126325],
// 					[-8.67767542577883, 57.92306057840776],
// 					[-11.912773720477048, 61.17084553308521],
// 					[-15.185931995112924, 65.49699658599539],
// 					[-16.805595585791934, 67.67487321575962],
// 					[-18.97501444223667, 68.74901042733259],
// 					[-22.759868002700614, 68.74901042733259],
// 					[-27.098705715590086, 66.60073600418659],
// 					[-31.399483448541787, 63.348722162849384],
// 					[-35.18433700900573, 59.54272416908671],
// 					[-37.907740017875994, 55.770557268602005],
// 					[-39.5231747218952, 49.27075847258732],
// 					[-40.07715887432062, 44.39062326725167],
// 					[-40.631143026746145, 39.51471694857574],
// 					[-42.24657773076535, 34.11442868409253],
// 					[-43.31225716901895, 26.536263789845123],
// 					[-44.41599658721009, 22.210112736934917],
// 					[-44.92769187303816, 16.260069206685984],
// 					[-44.92769187303816, 10.305796789777304],
// 					[-45.48167602546357, 5.429890471101373],
// 					[-45.48167602546357, 0],
// 					[-46.0356601778891, -2.6980296889117596],
// 					[-46.0356601778891, -4.850532998717512],
// 					[-46.58541544365471, -5.950043530248934],
// 					[-46.58541544365471, -5.396059377823491],
// 					[-47.09711072948289, -4.850532998717512],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.062745101749897, 0.10980392247438431, 0.125490203499794,
// 					0.12156862765550613, 0.125490203499794, 0.12156862765550613,
// 					0.11764705926179886, 0.13725490868091583, 0.14509804546833038,
// 					0.15294118225574493, 0.15294118225574493, 0.1568627506494522,
// 					0.16078431904315948, 0.16078431904315948, 0.16470588743686676,
// 					0.1725490242242813, 0.18431372940540314, 0.1882352977991104, 0.1921568661928177,
// 					0.19607843458652496, 0.19607843458652496, 0.20000000298023224,
// 					0.20000000298023224, 0.21960784494876862, 0.21960784494876862,
// 					0.21960784494876862, 0.21176470816135406, 0.21176470816135406,
// 					0.21568627655506134, 0.21568627655506134, 0.23137255012989044,
// 					0.23137255012989044, 0.23529411852359772, 0.23137255012989044,
// 					0.18039216101169586, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-47.09711072948289, -4.850532998717512],
// 			},
// 		],
// 		V: [
// 			{
// 				id: "FUx7cr5h561sZ_p7OU9HT",
// 				type: "freedraw",
// 				x: 882.2644537718003,
// 				y: 125.35672349585676,
// 				width: 65.48008103935649,
// 				height: 73.07516148024283,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1774829014,
// 				version: 33,
// 				versionNonce: 79467466,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146867324,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, 0.5455263791059792],
// 					[-1.0614505515937935, 1.6196635906789822],
// 					[-3.7848535604639437, 5.396059377823491],
// 					[-7.573936007587577, 13.523979537836595],
// 					[-12.42446900630523, 24.90814242584665],
// 					[-15.697627280940992, 35.73832116143126],
// 					[-17.317290871620003, 44.91077632639923],
// 					[-18.93272557563921, 53.58845175217809],
// 					[-21.102144432083946, 60.612632493999996],
// 					[-22.721808022762957, 66.56690491090868],
// 					[-24.891226879207693, 69.81891875224588],
// 					[-25.952677430801486, 70.89305596381891],
// 					[-27.06064573565243, 70.37290290467135],
// 					[-28.122096287246222, 67.12088906333415],
// 					[-29.74175987792512, 62.79473801042391],
// 					[-32.46516288679538, 57.360618652662794],
// 					[-36.25001644725933, 49.78668264507516],
// 					[-41.65453359840228, 40.584625273489024],
// 					[-48.162790167736375, 30.858185956095582],
// 					[-53.56730731887933, 21.656128584509446],
// 					[-57.35216087934339, 15.147872015175324],
// 					[-60.07556388821342, 10.825949848924864],
// 					[-61.14124332646702, 8.123691273353387],
// 					[-62.24498274465816, 5.396059377823491],
// 					[-62.75667803048634, 3.2477849546774564],
// 					[-63.86464633533717, 1.6196635906789822],
// 					[-64.4186304877627, 0.5455263791059792],
// 					[-65.48008103935649, -0.5539841524254427],
// 					[-65.48008103935649, -1.078366098232749],
// 					[-64.92609688693096, -1.6281213639984742],
// 					[-64.4186304877627, -2.182105516423917],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.15294118225574493, 0.18431372940540314,
// 					0.20392157137393951, 0.20392157137393951, 0.20000000298023224,
// 					0.1921568661928177, 0.1764705926179886, 0.16470588743686676,
// 					0.16470588743686676, 0.16078431904315948, 0.1568627506494522,
// 					0.16078431904315948, 0.15294118225574493, 0.1568627506494522,
// 					0.1725490242242813, 0.1921568661928177, 0.21568627655506134,
// 					0.23529411852359772, 0.250980406999588, 0.239215686917305, 0.23137255012989044,
// 					0.2235294133424759, 0.2235294133424759, 0.2235294133424759, 0.22745098173618317,
// 					0.23137255012989044, 0.22745098173618317, 0.2078431397676468,
// 					0.12156862765550613, 0.003921568859368563, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-64.4186304877627, -2.182105516423917],
// 			},
// 		],
// 		W: [
// 			{
// 				id: "nT6WwYKLYLDkBK82Yoc3a",
// 				type: "freedraw",
// 				x: 884.433872628245,
// 				y: 119.40245107894808,
// 				width: 73.05401704694418,
// 				height: 80.6533263744902,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1008594954,
// 				version: 61,
// 				versionNonce: 570528598,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146870665,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.5539841524254143, -1.078366098232749],
// 					[1.1121971915106315, -2.177876629764171],
// 					[1.6196635906790107, -4.326151052910205],
// 					[1.6196635906790107, -4.880135205335648],
// 					[0.5539841524254143, -3.2520138413372024],
// 					[-0.5074663991683792, 1.074137211573003],
// 					[-2.169418856444736, 7.573936007587662],
// 					[-3.7848535604640574, 15.706085054260512],
// 					[-4.85053299871754, 27.056416848992683],
// 					[-5.95427241690868, 38.440579737002736],
// 					[-7.019951855162276, 48.16279016773643],
// 					[-8.123691273353415, 55.74095506198384],
// 					[-8.635386559181484, 62.79473801042391],
// 					[-10.255050149860494, 68.19502627490718],
// 					[-10.80480541562622, 68.19502627490718],
// 					[-11.358789568051634, 68.19502627490718],
// 					[-12.42446900630523, 68.19502627490718],
// 					[-12.974224272070956, 68.19502627490718],
// 					[-13.52820842449637, 67.64104212248171],
// 					[-14.082192576921784, 66.04675185176112],
// 					[-15.147872015175267, 62.2407538579985],
// 					[-16.209322566769174, 58.988740016661296],
// 					[-18.932725575639324, 51.414804009073634],
// 					[-21.102144432083946, 46.018744631250144],
// 					[-23.82554744095421, 37.88659558457729],
// 					[-26.5066615832269, 27.056416848992683],
// 					[-28.122096287246222, 19.478251954745275],
// 					[-29.741759877925233, 12.978453158730616],
// 					[-30.291515143690958, 9.751812637351861],
// 					[-30.845499296116373, 7.024180741821965],
// 					[-30.845499296116373, 7.573936007587662],
// 					[-30.845499296116373, 9.202057371586136],
// 					[-31.911178734369855, 12.978453158730616],
// 					[-33.01491815256111, 17.85013059074683],
// 					[-34.08059759081459, 22.730265796082477],
// 					[-35.69603229483391, 29.234293478756854],
// 					[-37.865451151278535, 40.064472214341464],
// 					[-38.97341945612959, 47.638408221929126],
// 					[-40.5888541601488, 57.369076425982286],
// 					[-42.758273016593535, 66.04675185176112],
// 					[-44.92769187303827, 73.62491674600855],
// 					[-45.99337131129175, 75.77319116915456],
// 					[-47.09711072948289, 75.77319116915456],
// 					[-47.60880601531096, 73.62491674600855],
// 					[-49.22846960598997, 68.74901042733259],
// 					[-50.33220902418111, 64.42285937442242],
// 					[-52.50162788062585, 57.91883169174801],
// 					[-55.18274202289865, 49.2665295859276],
// 					[-58.9718244700224, 38.960732796150296],
// 					[-63.86464633533717, 24.90814242584665],
// 					[-66.58804934420743, 16.780222265833544],
// 					[-67.64949989580123, 12.978453158730616],
// 					[-68.20348404822664, 8.127920160013133],
// 					[-69.81891875224585, 2.1482744231460345],
// 					[-70.37713179133107, -1.078366098232749],
// 					[-71.43435345626517, -2.6980296889117312],
// 					[-71.43435345626517, -1.6238924773387282],
// 					[-71.43435345626517, -1.078366098232749],
// 					[-69.81891875224585, 0.5497552657657252],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.0784313753247261, 0.08627451211214066,
// 					0.10980392247438431, 0.16470588743686676, 0.18431372940540314,
// 					0.18431372940540314, 0.18039216101169586, 0.1764705926179886,
// 					0.16862745583057404, 0.1568627506494522, 0.1568627506494522, 0.1568627506494522,
// 					0.1568627506494522, 0.16470588743686676, 0.16470588743686676,
// 					0.16470588743686676, 0.16470588743686676, 0.16078431904315948,
// 					0.1725490242242813, 0.18039216101169586, 0.19607843458652496,
// 					0.20392157137393951, 0.21176470816135406, 0.21568627655506134,
// 					0.21960784494876862, 0.2235294133424759, 0.22745098173618317,
// 					0.22745098173618317, 0.22745098173618317, 0.26274511218070984,
// 					0.2705882489681244, 0.27450981736183167, 0.27450981736183167,
// 					0.26274511218070984, 0.239215686917305, 0.2235294133424759, 0.21568627655506134,
// 					0.20392157137393951, 0.20000000298023224, 0.1882352977991104,
// 					0.18039216101169586, 0.16862745583057404, 0.16470588743686676,
// 					0.1725490242242813, 0.18431372940540314, 0.20392157137393951,
// 					0.21176470816135406, 0.25882354378700256, 0.27450981736183167,
// 					0.2705882489681244, 0.26274511218070984, 0.25882354378700256,
// 					0.2705882489681244, 0.27450981736183167, 0.2666666805744171,
// 					0.23137255012989044, 0.16078431904315948, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-69.81891875224585, 0.5497552657657252],
// 			},
// 		],
// 		X: [
// 			{
// 				id: "7aMMeBmuTo92dJBIfpA0k",
// 				type: "freedraw",
// 				x: 879.0293554771021,
// 				y: 117.77855860160935,
// 				width: 69.82314763890565,
// 				height: 76.84732838072756,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1718618902,
// 				version: 22,
// 				versionNonce: 1632104790,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146874441,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.5539841524254143, -1.6281213639984742],
// 					[0.5539841524254143, -2.182105516423917],
// 					[1.0656794382535963, -4.326151052910205],
// 					[0.5539841524254143, -5.95427241690868],
// 					[-1.6154347040193215, -5.95427241690868],
// 					[-4.85053299871754, -3.25624272799692],
// 					[-11.358789568051634, 3.7721669004847627],
// 					[-19.48670972806474, 14.077963690262067],
// 					[-27.610401001418154, 24.90814242584665],
// 					[-36.79977171302505, 34.110199797432784],
// 					[-44.92769187303816, 42.762501903253195],
// 					[-51.43594844237225, 50.3406667975006],
// 					[-58.460129184194216, 57.36484753932257],
// 					[-63.86041744867748, 63.31911995623125],
// 					[-67.0955157433757, 67.67064432909984],
// 					[-68.20348404822664, 69.8189187522459],
// 					[-68.75746820065206, 70.89305596381888],
// 					[-67.64949989580123, 69.8189187522459],
// 					[-64.4144016011029, 68.1907973882474],
// 					[-63.310662182911756, 67.67064432909984],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.05882352963089943, 0.03921568766236305,
// 					0.09803921729326248, 0.125490203499794, 0.13725490868091583,
// 					0.16078431904315948, 0.1764705926179886, 0.18039216101169586,
// 					0.1882352977991104, 0.18431372940540314, 0.1725490242242813,
// 					0.16470588743686676, 0.1568627506494522, 0.13333334028720856,
// 					0.12941177189350128, 0.12941177189350128, 0.12941177189350128,
// 					0.062745101749897, 0.003921568859368563, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-63.310662182911756, 67.67064432909984],
// 			},
// 			{
// 				id: "3A8Wy2C-PXILtRuQxhCop",
// 				type: "freedraw",
// 				x: 871.4596483561741,
// 				y: 193.5475208841042,
// 				width: 50.886193176606525,
// 				height: 71.44704011624438,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1590396362,
// 				version: 17,
// 				versionNonce: 56650390,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146874897,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.5497552657657252, 0],
// 					[0, -1.0699083249132855],
// 					[-3.789082447123633, -5.396059377823519],
// 					[-10.297339016457727, -15.156329788494816],
// 					[-20.040693880490153, -28.68030932633144],
// 					[-30.84972818277606, -41.658762485062056],
// 					[-38.42366419036375, -53.04292537307211],
// 					[-43.31648605567864, -62.244982744658245],
// 					[-47.655323768567996, -67.12088906333415],
// 					[-49.270758472587204, -69.26916348648018],
// 					[-49.782453758415386, -69.26916348648018],
// 					[-49.782453758415386, -69.8189187522459],
// 					[-50.3364379108408, -70.37290290467135],
// 					[-50.3364379108408, -70.89728485047866],
// 					[-50.3364379108408, -71.44704011624438],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.09019608050584793,
// 					0.15294118225574493, 0.19607843458652496, 0.22745098173618317,
// 					0.250980406999588, 0.250980406999588, 0.21568627655506134, 0.1921568661928177,
// 					0.1764705926179886, 0.1725490242242813, 0.16862745583057404,
// 					0.11764705926179886, 0.062745101749897, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-50.3364379108408, -71.44704011624438],
// 			},
// 		],
// 		Y: [
// 			{
// 				id: "JbB8W4EZfIVT8vLJTr-yq",
// 				type: "freedraw",
// 				x: 871.4596483561741,
// 				y: 115.07630002603787,
// 				width: 36.80400059968474,
// 				height: 36.25847422057882,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1283671882,
// 				version: 24,
// 				versionNonce: 2146665942,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146877692,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, 1.6281213639984742],
// 					[-1.1079683048508286, 9.202057371586136],
// 					[-3.2350982946982185, 18.404114743172272],
// 					[-5.404517151142954, 25.98227963741968],
// 					[-8.681904312438519, 29.234293478756854],
// 					[-11.917002607136737, 29.754446537904414],
// 					[-16.25584032002621, 29.754446537904414],
// 					[-21.106373318743636, 28.684538212991157],
// 					[-26.51089046988659, 25.98227963741968],
// 					[-30.84972818277606, 22.176281643657035],
// 					[-33.57313119164621, 16.780222265833544],
// 					[-34.634581743240005, 10.280423469818885],
// 					[-35.74255004809095, 4.875906318675931],
// 					[-36.254245333919016, 0.5201530591475603],
// 					[-36.254245333919016, -1.6238924773387282],
// 					[-36.80400059968474, -3.2520138413372024],
// 					[-36.80400059968474, -4.875906318675931],
// 					[-36.80400059968474, -5.950043530248934],
// 					[-36.80400059968474, -6.504027682674405],
// 					[-36.80400059968474, -5.950043530248934],
// 					[-36.254245333919016, -3.805997993762645],
// 					[-35.74255004809095, -2.6980296889117312],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.12941177189350128, 0.1411764770746231,
// 					0.15294118225574493, 0.16078431904315948, 0.16862745583057404,
// 					0.1764705926179886, 0.18431372940540314, 0.1921568661928177,
// 					0.18431372940540314, 0.1921568661928177, 0.19607843458652496,
// 					0.20392157137393951, 0.21176470816135406, 0.2078431397676468,
// 					0.21176470816135406, 0.2078431397676468, 0.2078431397676468,
// 					0.19607843458652496, 0.1882352977991104, 0.11764705926179886,
// 					0.0235294122248888, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-35.74255004809095, -2.6980296889117312],
// 			},
// 			{
// 				id: "3kqL_Hca4Q20ly4bEc5Is",
// 				type: "freedraw",
// 				x: 849.7992908850049,
// 				y: 142.13271687503055,
// 				width: 3.7890824471237465,
// 				height: 55.22080200283625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 665258314,
// 				version: 15,
// 				versionNonce: 1053170838,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146878099,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.553984152425528, 1.074137211573003],
// 					[1.0656794382534827, 2.6980296889117312],
// 					[2.1736477431045387, 5.400288264483208],
// 					[2.1736477431045387, 9.756041524011579],
// 					[2.1736477431045387, 16.23046700006782],
// 					[2.1736477431045387, 24.36261604674067],
// 					[1.6196635906790107, 35.18856589566553],
// 					[1.6196635906790107, 44.91077632639923],
// 					[1.6196635906790107, 50.894650949926074],
// 					[1.6196635906790107, 54.66681785041084],
// 					[1.6196635906790107, 55.22080200283625],
// 					[2.1736477431045387, 54.11706258464511],
// 					[3.7890824471237465, 51.414804009073634],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.08627451211214066,
// 					0.10980392247438431, 0.1411764770746231, 0.16862745583057404,
// 					0.18039216101169586, 0.18039216101169586, 0.1725490242242813,
// 					0.16470588743686676, 0.13725490868091583, 0.10980392247438431,
// 					0.05882352963089943, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [3.7890824471237465, 51.414804009073634],
// 			},
// 		],
// 		Z: [
// 			{
// 				id: "yM-99b-CXjU-tN0-Dr43c",
// 				type: "freedraw",
// 				x: 821.1232104453333,
// 				y: 115.07630002603787,
// 				width: 59.01411333661963,
// 				height: 79.02520501049173,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 769268822,
// 				version: 39,
// 				versionNonce: 935824342,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751146881669,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.0656794382535963, 0.5201530591475603],
// 					[1.0656794382535963, 1.074137211573003],
// 					[2.169418856444736, 1.074137211573003],
// 					[3.789082447123633, 1.074137211573003],
// 					[7.57393600758769, 1.6281213639984742],
// 					[13.532437311156059, 2.1482744231460345],
// 					[21.656128584509474, 2.702258575571477],
// 					[31.911178734369855, 2.702258575571477],
// 					[41.14283831257421, 2.702258575571477],
// 					[48.16279016773649, 2.702258575571477],
// 					[53.05561203305126, 3.7721669004847627],
// 					[54.67527562373027, 4.875906318675931],
// 					[55.736726175324065, 5.95427241690868],
// 					[55.736726175324065, 6.47442547605624],
// 					[54.67527562373027, 7.573936007587662],
// 					[51.95187261486012, 10.825949848924864],
// 					[46.54735546371717, 16.226238113408073],
// 					[39.485114741957545, 24.35838716008095],
// 					[31.3994834485419, 33.56044453166706],
// 					[23.82554744095421, 41.13860942591447],
// 					[11.912773720477048, 53.592680638837805],
// 					[9.189370711606898, 57.369076425982286],
// 					[2.169418856444736, 66.5669049109087],
// 					[-1.6154347040193215, 71.44704011624435],
// 					[-2.72340300887015, 74.14506980515608],
// 					[-1.6154347040193215, 74.69905395758155],
// 					[2.681114142272804, 75.21920701672911],
// 					[10.809034302285909, 75.77319116915459],
// 					[19.48670972806474, 76.84732838072756],
// 					[28.676080439671637, 77.95106779891876],
// 					[36.804000599684855, 79.02520501049173],
// 					[42.76250190325311, 79.02520501049173],
// 					[46.54735546371717, 79.02520501049173],
// 					[50.3364379108408, 79.02520501049173],
// 					[53.05561203305126, 79.02520501049173],
// 					[54.121291471304744, 79.02520501049173],
// 					[56.29071032774948, 78.47122085806632],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.07450980693101883, 0.12156862765550613,
// 					0.14509804546833038, 0.16078431904315948, 0.18431372940540314,
// 					0.19607843458652496, 0.21176470816135406, 0.21568627655506134,
// 					0.2235294133424759, 0.239215686917305, 0.2549019753932953, 0.2666666805744171,
// 					0.2705882489681244, 0.27450981736183167, 0.27450981736183167,
// 					0.2666666805744171, 0.2666666805744171, 0.2666666805744171, 0.25882354378700256,
// 					0.2549019753932953, 0.239215686917305, 0.239215686917305, 0.2235294133424759,
// 					0.21568627655506134, 0.21568627655506134, 0.23137255012989044,
// 					0.24705882370471954, 0.2666666805744171, 0.2705882489681244,
// 					0.27843138575553894, 0.29019609093666077, 0.29019609093666077,
// 					0.27843138575553894, 0.24705882370471954, 0.1764705926179886,
// 					0.14901961386203766, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [56.29071032774948, 78.47122085806632],
// 			},
// 		],
// 	},
// 	...{
// 		"0": [
// 			{
// 				id: "eo4QziTx8IUTZqWAcaHII",
// 				type: "freedraw",
// 				x: 458.2109375,
// 				y: 293.49609375,
// 				width: 38.4765625,
// 				height: 59,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1313199175,
// 				version: 32,
// 				versionNonce: 2078308841,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213083177,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.4921875, 0.51171875],
// 					[2.00390625, 0.51171875],
// 					[3.49609375, -0.51171875],
// 					[4.9921875, -3.99609375],
// 					[5.97265625, -6.48828125],
// 					[9, -16.4921875],
// 					[9.98046875, -24.00390625],
// 					[9.98046875, -28.9921875],
// 					[9.47265625, -34.00390625],
// 					[7.5078125, -42.5078125],
// 					[4.9921875, -47.4921875],
// 					[0.98046875, -51.48828125],
// 					[-4.51953125, -52.51171875],
// 					[-10.49609375, -51.0078125],
// 					[-15.99609375, -47.4921875],
// 					[-21.5, -42.98828125],
// 					[-25.5078125, -38.9921875],
// 					[-28.0234375, -33.01171875],
// 					[-28.49609375, -27.00390625],
// 					[-28.0234375, -14.51171875],
// 					[-24.5234375, -4.5078125],
// 					[-19.0234375, 3.515625],
// 					[-13.51953125, 6.48828125],
// 					[-8.01953125, 6.48828125],
// 					[-2.515625, 3.515625],
// 					[1.4921875, 0],
// 					[3.96875, -3.484375],
// 					[5.5, -7.51171875],
// 					[5.5, -10.515625],
// 					[5.97265625, -11.5078125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.09803921729326248, 0.10196078568696976,
// 					0.14901961386203766, 0.1764705926179886, 0.18039216101169586,
// 					0.23137255012989044, 0.250980406999588, 0.26274511218070984,
// 					0.27843138575553894, 0.25882354378700256, 0.250980406999588, 0.250980406999588,
// 					0.23529411852359772, 0.24313725531101227, 0.2549019753932953,
// 					0.26274511218070984, 0.26274511218070984, 0.25882354378700256,
// 					0.26274511218070984, 0.25882354378700256, 0.250980406999588, 0.239215686917305,
// 					0.250980406999588, 0.26274511218070984, 0.2666666805744171, 0.2666666805744171,
// 					0.2549019753932953, 0.1921568661928177, 0.08627451211214066, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [5.97265625, -11.5078125],
// 			},
// 		],
// 	},
// 	...{
// 		"1": [
// 			{
// 				id: "_-KxDgBfqBOiYYj9-78Jd",
// 				type: "freedraw",
// 				x: 431.68359375,
// 				y: 253.00390625,
// 				width: 24.01171875,
// 				height: 60.5,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 244831145,
// 				version: 25,
// 				versionNonce: 1187451719,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213085068,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, 1.5],
// 					[0, 1.98046875],
// 					[0.5078125, 2.4921875],
// 					[2.00390625, 2.4921875],
// 					[6.01171875, 0],
// 					[8.52734375, -2.015625],
// 					[17.52734375, -13.01171875],
// 					[22.51953125, -20.51953125],
// 					[23.5, -23.49609375],
// 					[24.01171875, -24.00390625],
// 					[24.01171875, -22.50390625],
// 					[23.5, -17.515625],
// 					[22.51953125, -9.49609375],
// 					[22.51953125, 0.48046875],
// 					[23.02734375, 11.984375],
// 					[23.5, 21.50390625],
// 					[23.5, 28.50390625],
// 					[23.5, 32.5],
// 					[23.02734375, 34.484375],
// 					[23.02734375, 34.99609375],
// 					[23.5, 35.50390625],
// 					[23.5, 35.984375],
// 					[24.01171875, 36.49609375],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.12941177189350128, 0.18039216101169586,
// 					0.21960784494876862, 0.24313725531101227, 0.2549019753932953,
// 					0.25882354378700256, 0.2666666805744171, 0.27450981736183167,
// 					0.27843138575553894, 0.29411765933036804, 0.3450980484485626,
// 					0.3490196168422699, 0.33725491166114807, 0.32549020648002625,
// 					0.3137255012989044, 0.32156863808631897, 0.32549020648002625,
// 					0.3294117748737335, 0.3176470696926117, 0.3019607961177826, 0.18039216101169586,
// 					0.11764705926179886, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [24.01171875, 36.49609375],
// 			},
// 		],
// 		"2": [
// 			{
// 				id: "a5J5iOcfcbiq6vehO207K",
// 				type: "freedraw",
// 				x: 443.1953125,
// 				y: 239.9921875,
// 				width: 42.484375,
// 				height: 59,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 336735623,
// 				version: 26,
// 				versionNonce: 1869244265,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213086945,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[-0.98046875, 0.51171875],
// 					[-2.00390625, 0.51171875],
// 					[-2.51171875, 0],
// 					[-2.51171875, -0.98828125],
// 					[0, -4.50390625],
// 					[2.515625, -6.48828125],
// 					[6.015625, -7],
// 					[8.4921875, -6.48828125],
// 					[14.50390625, 0.9921875],
// 					[15.015625, 4.5078125],
// 					[11.98828125, 14.51171875],
// 					[4.9921875, 22.50390625],
// 					[-2.51171875, 30.49609375],
// 					[-4.98828125, 34.515625],
// 					[-5.5, 41.515625],
// 					[-0.98046875, 47.015625],
// 					[2.0078125, 48.515625],
// 					[11.515625, 52],
// 					[18.51171875, 52],
// 					[27, 48.99609375],
// 					[34.51171875, 45.9921875],
// 					[36.515625, 45.51171875],
// 					[36.984375, 45.51171875],
// 					[36.984375, 45.51171875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.06666667014360428, 0.10980392247438431,
// 					0.16470588743686676, 0.18039216101169586, 0.21568627655506134,
// 					0.22745098173618317, 0.23529411852359772, 0.24313725531101227,
// 					0.24705882370471954, 0.2549019753932953, 0.26274511218070984,
// 					0.24705882370471954, 0.23137255012989044, 0.21176470816135406,
// 					0.2549019753932953, 0.29411765933036804, 0.3137255012989044, 0.364705890417099,
// 					0.37254902720451355, 0.32156863808631897, 0.2549019753932953,
// 					0.1882352977991104, 0.12156862765550613, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [36.984375, 45.51171875],
// 			},
// 		],
// 		"3": [
// 			{
// 				id: "Ilu8hjEVISiJPs1IlX4oT",
// 				type: "freedraw",
// 				x: 439.69921875,
// 				y: 233.50390625,
// 				width: 26.48828125,
// 				height: 53.50390625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1546412519,
// 				version: 28,
// 				versionNonce: 1947163337,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213089820,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, 0.48046875],
// 					[2.00390625, 0.48046875],
// 					[6.01171875, 0.9921875],
// 					[9.984375, 1.50390625],
// 					[15.484375, 3.99609375],
// 					[17.015625, 5.98046875],
// 					[15.99609375, 9.49609375],
// 					[9, 16.49609375],
// 					[6.484375, 18.5078125],
// 					[2.515625, 21.48046875],
// 					[1.4921875, 21.9921875],
// 					[6.01171875, 22.984375],
// 					[11.98828125, 24.484375],
// 					[15.99609375, 25.50390625],
// 					[18.984375, 26.5],
// 					[24.484375, 29.5],
// 					[24.99609375, 35.48046875],
// 					[22.9921875, 41.484375],
// 					[20.00390625, 45.48046875],
// 					[14.50390625, 50.5],
// 					[9.51171875, 52.9921875],
// 					[6.01171875, 53.50390625],
// 					[0.984375, 53.50390625],
// 					[-0.984375, 52.9921875],
// 					[-1.4921875, 52.9921875],
// 					[-1.4921875, 52.9921875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.239215686917305, 0.2666666805744171, 0.2666666805744171,
// 					0.2705882489681244, 0.30980393290519714, 0.3176470696926117,
// 					0.33725491166114807, 0.32549020648002625, 0.32156863808631897,
// 					0.29019609093666077, 0.29019609093666077, 0.2862745225429535,
// 					0.27843138575553894, 0.25882354378700256, 0.25882354378700256,
// 					0.27450981736183167, 0.30980393290519714, 0.3333333432674408,
// 					0.3450980484485626, 0.3490196168422699, 0.3490196168422699, 0.32549020648002625,
// 					0.2705882489681244, 0.16470588743686676, 0.10196078568696976, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-1.4921875, 52.9921875],
// 			},
// 		],
// 		"4": [
// 			{
// 				id: "Aj1PcEAk_pHWx2fYX5eq0",
// 				type: "freedraw",
// 				x: 445.7109375,
// 				y: 235.0078125,
// 				width: 34.9765625,
// 				height: 39.98046875,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1757850759,
// 				version: 20,
// 				versionNonce: 1042058025,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213091522,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.49609375, 0],
// 					[2.4765625, 0],
// 					[2.4765625, 1.5],
// 					[0, 6.48828125],
// 					[-5.5, 18.4765625],
// 					[-8.52734375, 27.48828125],
// 					[-9.5078125, 33.4921875],
// 					[-8.015625, 38.48046875],
// 					[-4.51953125, 39.5],
// 					[2.4765625, 39.98046875],
// 					[5.50390625, 39.98046875],
// 					[15.99609375, 36.49609375],
// 					[22.48046875, 33.9765625],
// 					[25, 33.4921875],
// 					[25.46875, 33.4921875],
// 					[25, 33.9765625],
// 					[23.9765625, 33.9765625],
// 					[23.5078125, 33.9765625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.07058823853731155, 0.09019608050584793,
// 					0.14509804546833038, 0.18039216101169586, 0.19607843458652496,
// 					0.21960784494876862, 0.23137255012989044, 0.29411765933036804,
// 					0.3137255012989044, 0.34117648005485535, 0.3450980484485626,
// 					0.32156863808631897, 0.2823529541492462, 0.21960784494876862,
// 					0.1764705926179886, 0.07450980693101883, 0.019607843831181526, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [23.5078125, 33.9765625],
// 			},
// 			{
// 				id: "XQB_Sb2ZOFpsxPrgXoOzd",
// 				type: "freedraw",
// 				x: 458.2109375,
// 				y: 260.00390625,
// 				width: 4.48046875,
// 				height: 35.50390625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 365839111,
// 				version: 11,
// 				versionNonce: 1271723721,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213091765,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.98046875, 1.49609375],
// 					[2.00390625, 3.484375],
// 					[2.00390625, 7.98828125],
// 					[2.00390625, 13.00390625],
// 					[2.00390625, 20.00390625],
// 					[2.00390625, 27.00390625],
// 					[2.984375, 34.00390625],
// 					[3.96875, 35.50390625],
// 					[4.48046875, 35.50390625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.08627451211214066, 0.08627451211214066,
// 					0.14901961386203766, 0.20392157137393951, 0.2549019753932953,
// 					0.24313725531101227, 0.16470588743686676, 0.0313725508749485, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [4.48046875, 35.50390625],
// 			},
// 		],
// 		"5": [
// 			{
// 				id: "TIWFn2bSaoTozuGpPSYJ4",
// 				type: "freedraw",
// 				x: 462.1796875,
// 				y: 229.98828125,
// 				width: 27,
// 				height: 57.01953125,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1936889993,
// 				version: 38,
// 				versionNonce: 1038285063,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213093639,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.0234375, 0],
// 					[2.00390625, 0.51171875],
// 					[2.515625, 0.51171875],
// 					[1.53125, 0.99609375],
// 					[-2.4765625, 0.99609375],
// 					[-7.9765625, 0.99609375],
// 					[-13.48046875, 2.015625],
// 					[-18, 3.00390625],
// 					[-20.98828125, 4.5078125],
// 					[-21.96875, 6.01171875],
// 					[-21.96875, 7],
// 					[-21.96875, 7.51171875],
// 					[-20.98828125, 9.015625],
// 					[-20.4765625, 10.515625],
// 					[-20.4765625, 14.51171875],
// 					[-20.98828125, 18.5078125],
// 					[-21.96875, 26.01953125],
// 					[-22.48046875, 30.49609375],
// 					[-22.48046875, 31.99609375],
// 					[-22.48046875, 31.51171875],
// 					[-20.4765625, 30.015625],
// 					[-17.48828125, 29.01953125],
// 					[-13.9921875, 28],
// 					[-7.9765625, 28],
// 					[-1.4921875, 29.50390625],
// 					[3.02734375, 33.5],
// 					[4.51953125, 38.99609375],
// 					[3.5390625, 45],
// 					[-0.47265625, 50.5],
// 					[-6.484375, 55.00390625],
// 					[-11.4765625, 56.5078125],
// 					[-15.99609375, 57.01953125],
// 					[-18, 57.01953125],
// 					[-18.984375, 55.99609375],
// 					[-19.4921875, 55.515625],
// 					[-19.96484375, 55.00390625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.10588235408067703,
// 					0.16470588743686676, 0.20392157137393951, 0.24313725531101227,
// 					0.250980406999588, 0.22745098173618317, 0.21568627655506134, 0.1921568661928177,
// 					0.1882352977991104, 0.20000000298023224, 0.21960784494876862,
// 					0.23137255012989044, 0.24705882370471954, 0.250980406999588,
// 					0.24313725531101227, 0.24313725531101227, 0.24313725531101227,
// 					0.2549019753932953, 0.250980406999588, 0.239215686917305, 0.239215686917305,
// 					0.23137255012989044, 0.250980406999588, 0.26274511218070984, 0.2980392277240753,
// 					0.32549020648002625, 0.34117648005485535, 0.3490196168422699,
// 					0.34117648005485535, 0.3294117748737335, 0.29019609093666077,
// 					0.24705882370471954, 0.16078431904315948, 0.10980392247438431, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-19.96484375, 55.00390625],
// 			},
// 		],
// 		"6": [
// 			{
// 				id: "cH9zWgB8q2rt7Q6dHzSCy",
// 				type: "freedraw",
// 				x: 461.1953125,
// 				y: 243.98828125,
// 				width: 29.98828125,
// 				height: 52.51171875,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1514120007,
// 				version: 27,
// 				versionNonce: 1865404553,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213095282,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[2.515625, -0.48046875],
// 					[3.5, -0.48046875],
// 					[4.01171875, -0.98828125],
// 					[3.5, -1.5],
// 					[-0.5078125, 0],
// 					[-7.50390625, 3.99609375],
// 					[-14.5, 9.49609375],
// 					[-21.49609375, 17.51171875],
// 					[-24.9921875, 24.99609375],
// 					[-25.9765625, 36.5],
// 					[-22.98828125, 44.01171875],
// 					[-17.48828125, 48.515625],
// 					[-11.51171875, 51.01171875],
// 					[-4.98828125, 49.5078125],
// 					[0.984375, 44.51953125],
// 					[3.5, 38.9921875],
// 					[3.5, 33.49609375],
// 					[-1.4921875, 30.51953125],
// 					[-9.5078125, 30.51953125],
// 					[-17.015625, 31.9921875],
// 					[-22.98828125, 34.515625],
// 					[-25.50390625, 36.5],
// 					[-25.50390625, 37.01171875],
// 					[-24.9921875, 37.01171875],
// 					[-24.01171875, 37.01171875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.07058823853731155, 0.07058823853731155,
// 					0.16078431904315948, 0.21960784494876862, 0.24705882370471954,
// 					0.2666666805744171, 0.27450981736183167, 0.26274511218070984, 0.250980406999588,
// 					0.24313725531101227, 0.24705882370471954, 0.25882354378700256,
// 					0.2549019753932953, 0.2549019753932953, 0.250980406999588, 0.24705882370471954,
// 					0.24705882370471954, 0.250980406999588, 0.2823529541492462, 0.2980392277240753,
// 					0.3019607961177826, 0.24705882370471954, 0.21176470816135406, 0.125490203499794,
// 					0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-24.01171875, 37.01171875],
// 			},
// 		],
// 		"7": [
// 			{
// 				id: "EW6zgGPRdZo6rch0Vs3Ts",
// 				type: "freedraw",
// 				x: 444.69140625,
// 				y: 288.5078125,
// 				width: 33.99609375,
// 				height: 48.00390625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 263848521,
// 				version: 22,
// 				versionNonce: 144365895,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213096925,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.51171875, 0.9921875],
// 					[1.4921875, 0],
// 					[3.0234375, -4.50390625],
// 					[4.51953125, -10.515625],
// 					[8.015625, -18.01953125],
// 					[13.0078125, -26.01171875],
// 					[17.48828125, -32.5],
// 					[19.01953125, -37.0078125],
// 					[19.01953125, -39.5],
// 					[17.48828125, -41.515625],
// 					[13.9921875, -42.50390625],
// 					[9.51171875, -42.50390625],
// 					[2.515625, -43.49609375],
// 					[-2.4765625, -44.51953125],
// 					[-7.98046875, -45.5078125],
// 					[-11.98828125, -47.01171875],
// 					[-14.50390625, -47.01171875],
// 					[-14.9765625, -46.5],
// 					[-14.50390625, -45.5078125],
// 					[-14.50390625, -44.51953125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.09019608050584793, 0.11372549086809158,
// 					0.14901961386203766, 0.19607843458652496, 0.21568627655506134,
// 					0.239215686917305, 0.239215686917305, 0.25882354378700256, 0.2666666805744171,
// 					0.2705882489681244, 0.27450981736183167, 0.27843138575553894,
// 					0.27843138575553894, 0.25882354378700256, 0.2235294133424759,
// 					0.19607843458652496, 0.13333334028720856, 0.05098039284348488,
// 					0.007843137718737125, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-14.50390625, -44.51953125],
// 			},
// 			{
// 				id: "dogzoDydbCnXdmd1jH_L2",
// 				type: "freedraw",
// 				x: 459.19140625,
// 				y: 267.9921875,
// 				width: 28.4921875,
// 				height: 0.5078125,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 205211017,
// 				version: 11,
// 				versionNonce: 352326567,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213097200,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.49609375, 0.5078125],
// 					[2.00390625, 0.5078125],
// 					[-0.98046875, 0.5078125],
// 					[-6.484375, 0],
// 					[-13.98828125, 0],
// 					[-20.984375, 0],
// 					[-23.5, 0],
// 					[-25.50390625, 0],
// 					[-26.48828125, 0],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.07450980693101883, 0.10588235408067703,
// 					0.16078431904315948, 0.21568627655506134, 0.23137255012989044,
// 					0.1882352977991104, 0.11372549086809158, 0, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-26.48828125, 0],
// 			},
// 		],
// 		"8": [
// 			{
// 				id: "Xy8OBCWy7Liy_SE456INN",
// 				type: "freedraw",
// 				x: 443.1953125,
// 				y: 246.9921875,
// 				width: 24.9921875,
// 				height: 61.01171875,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 2055804999,
// 				version: 35,
// 				versionNonce: 375714441,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213102351,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[2.515625, 0],
// 					[4.01171875, 0],
// 					[5.50390625, 0],
// 					[12.5, -4.50390625],
// 					[17.01953125, -10.484375],
// 					[18, -14.5078125],
// 					[15.99609375, -15.5],
// 					[11.0078125, -15.5],
// 					[4.51953125, -11.50390625],
// 					[-0.98046875, -7.5078125],
// 					[-4.98828125, -1.98046875],
// 					[-5.5, 5.01953125],
// 					[-1.4921875, 13.01171875],
// 					[4.51953125, 21],
// 					[10.49609375, 28.98828125],
// 					[15.015625, 34.99609375],
// 					[15.99609375, 40.015625],
// 					[13.9921875, 43.5],
// 					[9, 45],
// 					[2.98828125, 45.51171875],
// 					[-2.00390625, 43.01953125],
// 					[-6.01171875, 38.9921875],
// 					[-6.9921875, 34.515625],
// 					[-4.98828125, 28.5078125],
// 					[-2.51171875, 24.9921875],
// 					[5.50390625, 12.5],
// 					[9.984375, 6.01171875],
// 					[12.5, 2.49609375],
// 					[13.01171875, 0.9921875],
// 					[13.01171875, 0.51171875],
// 					[11.515625, -0.5078125],
// 					[11.0078125, -0.98828125],
// 					[9.984375, -1.5],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.10588235408067703,
// 					0.11764705926179886, 0.20000000298023224, 0.2235294133424759,
// 					0.24705882370471954, 0.2549019753932953, 0.24313725531101227,
// 					0.24313725531101227, 0.239215686917305, 0.2235294133424759, 0.23529411852359772,
// 					0.23529411852359772, 0.23137255012989044, 0.23529411852359772,
// 					0.26274511218070984, 0.2862745225429535, 0.3137255012989044,
// 					0.29411765933036804, 0.27450981736183167, 0.26274511218070984,
// 					0.23529411852359772, 0.23529411852359772, 0.23529411852359772,
// 					0.239215686917305, 0.239215686917305, 0.23137255012989044, 0.22745098173618317,
// 					0.20392157137393951, 0.13725490868091583, 0.05098039284348488,
// 					0.0313725508749485, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [9.984375, -1.5],
// 			},
// 		],
// 		"9": [
// 			{
// 				id: "mkLA0NkX21uDpqjnPId9-",
// 				type: "freedraw",
// 				x: 452.70703125,
// 				y: 242.48828125,
// 				width: 27.5078125,
// 				height: 56.4765625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 447034153,
// 				version: 39,
// 				versionNonce: 1415644039,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213105326,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.49609375, 0.51171875],
// 					[4.9921875, 1.01953125],
// 					[8.48828125, 0.51171875],
// 					[9.984375, -1.50390625],
// 					[9.984375, -3.484375],
// 					[5.9765625, -7.48046875],
// 					[-1.01953125, -7.48046875],
// 					[-7.50390625, -3.484375],
// 					[-10.01953125, -0.9921875],
// 					[-12.0234375, 10.00390625],
// 					[-8.52734375, 15.015625],
// 					[-3.49609375, 17.00390625],
// 					[2.4765625, 17.00390625],
// 					[7.5078125, 13.0078125],
// 					[9.984375, 7.51171875],
// 					[9.984375, 3.515625],
// 					[9, -0.48046875],
// 					[7.5078125, -1.50390625],
// 					[7.5078125, 0.51171875],
// 					[8.48828125, 3.00390625],
// 					[9.47265625, 7],
// 					[11.00390625, 11.50390625],
// 					[13.01171875, 17.515625],
// 					[14.50390625, 25.50390625],
// 					[15.484375, 33.4921875],
// 					[14.9765625, 40.01171875],
// 					[13.48046875, 42.50390625],
// 					[6.99609375, 47.5234375],
// 					[1.49609375, 48.99609375],
// 					[-4.0078125, 48.99609375],
// 					[-8.015625, 48.99609375],
// 					[-10.01953125, 48.00390625],
// 					[-11.515625, 47.5234375],
// 					[-11.515625, 47.01171875],
// 					[-11.515625, 45.51171875],
// 					[-11.515625, 45],
// 					[-11.515625, 44.0078125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.11372549086809158,
// 					0.15294118225574493, 0.1921568661928177, 0.20000000298023224,
// 					0.22745098173618317, 0.21568627655506134, 0.20392157137393951,
// 					0.20392157137393951, 0.2235294133424759, 0.239215686917305, 0.24705882370471954,
// 					0.250980406999588, 0.24313725531101227, 0.23137255012989044, 0.2235294133424759,
// 					0.21176470816135406, 0.21176470816135406, 0.2705882489681244,
// 					0.30588236451148987, 0.32549020648002625, 0.33725491166114807,
// 					0.34117648005485535, 0.33725491166114807, 0.3529411852359772, 0.364705890417099,
// 					0.37254902720451355, 0.3960784375667572, 0.3960784375667572, 0.3803921639919281,
// 					0.364705890417099, 0.3333333432674408, 0.2862745225429535, 0.18039216101169586,
// 					0.08627451211214066, 0, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-11.515625, 44.0078125],
// 			},
// 		],
// 		À: [
// 			{
// 				id: "2D__wyVcnpe_eV6xjKO1y",
// 				type: "freedraw",
// 				x: 473.18359375,
// 				y: 296.5,
// 				width: 47.00390625,
// 				height: 69.00390625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1945853191,
// 				version: 46,
// 				versionNonce: 1430012265,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751212959409,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.51171875, -2.01171875],
// 					[-0.46875, -7.9921875],
// 					[-1.4921875, -13.0078125],
// 					[-3.49609375, -20.51953125],
// 					[-5.5, -29.5],
// 					[-6.484375, -32.5],
// 					[-8.48828125, -38],
// 					[-10.4921875, -43.49609375],
// 					[-11.00390625, -45],
// 					[-11.98828125, -48.515625],
// 					[-13.48046875, -52.9921875],
// 					[-14.5, -55.515625],
// 					[-16.46875, -59.51171875],
// 					[-18, -62.99609375],
// 					[-18.98046875, -65.0078125],
// 					[-20.4765625, -66.51171875],
// 					[-20.98828125, -68.01171875],
// 					[-21.49609375, -68.4921875],
// 					[-22.48046875, -69.00390625],
// 					[-22.9921875, -69.00390625],
// 					[-23.5, -69.00390625],
// 					[-24.484375, -68.4921875],
// 					[-25.46875, -67.5],
// 					[-25.9765625, -66.51171875],
// 					[-26.48828125, -65.515625],
// 					[-27.47265625, -64.015625],
// 					[-27.98046875, -62.00390625],
// 					[-29.00390625, -58.51953125],
// 					[-30.49609375, -53.5],
// 					[-30.96875, -51.0078125],
// 					[-32.97265625, -45.51171875],
// 					[-36, -38],
// 					[-37.4921875, -34.515625],
// 					[-39.49609375, -30.0078125],
// 					[-40.9921875, -24.99609375],
// 					[-41.5, -23.01171875],
// 					[-43.46875, -17.99609375],
// 					[-44.48828125, -15.5],
// 					[-45.47265625, -12.015625],
// 					[-45.98046875, -10.00390625],
// 					[-46.4921875, -8.5],
// 					[-46.4921875, -7.9921875],
// 					[-46.4921875, -8.5],
// 					[-46.4921875, -8.5],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.11764705926179886, 0.1411764770746231,
// 					0.14901961386203766, 0.1568627506494522, 0.1568627506494522,
// 					0.16470588743686676, 0.16078431904315948, 0.15294118225574493,
// 					0.15294118225574493, 0.14509804546833038, 0.14509804546833038,
// 					0.14509804546833038, 0.14509804546833038, 0.1411764770746231,
// 					0.1411764770746231, 0.13333334028720856, 0.13333334028720856,
// 					0.13725490868091583, 0.13725490868091583, 0.14509804546833038,
// 					0.14509804546833038, 0.15294118225574493, 0.16078431904315948,
// 					0.16862745583057404, 0.1725490242242813, 0.18039216101169586,
// 					0.18431372940540314, 0.1882352977991104, 0.1921568661928177, 0.1921568661928177,
// 					0.19607843458652496, 0.1921568661928177, 0.1882352977991104, 0.1882352977991104,
// 					0.18431372940540314, 0.18431372940540314, 0.18039216101169586,
// 					0.18039216101169586, 0.1764705926179886, 0.1764705926179886, 0.1764705926179886,
// 					0.1725490242242813, 0.003921568859368563, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-46.4921875, -8.5],
// 			},
// 			{
// 				id: "7UEB-1PKbB3tNxDM63cc7",
// 				type: "freedraw",
// 				x: 465.20703125,
// 				y: 261.984375,
// 				width: 34.9765625,
// 				height: 1.01953125,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 450648263,
// 				version: 12,
// 				versionNonce: 960334825,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751212959950,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.98046875, 0.51171875],
// 					[-1.49609375, 0.51171875],
// 					[-5.50390625, 0.51171875],
// 					[-16.5078125, 0],
// 					[-21.5, 0],
// 					[-29.00390625, 0],
// 					[-31.9921875, 0],
// 					[-33.99609375, 1.01953125],
// 					[-33.5234375, 1.01953125],
// 					[-33.015625, 1.01953125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.05882352963089943, 0.10196078568696976,
// 					0.10980392247438431, 0.125490203499794, 0.125490203499794, 0.12156862765550613,
// 					0.11372549086809158, 0.10196078568696976, 0.027450980618596077, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-33.015625, 1.01953125],
// 			},
// 			{
// 				id: "ihlWowPigusMy3oxXeBLp",
// 				type: "freedraw",
// 				x: 448.1875,
// 				y: 204.0078125,
// 				width: 16.5078125,
// 				height: 17,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 228279879,
// 				version: 10,
// 				versionNonce: 348744873,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751212960577,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[2.00390625, 1.98046875],
// 					[4.0078125, 3.484375],
// 					[6.015625, 5.49609375],
// 					[8.52734375, 7.48046875],
// 					[12.5, 11.984375],
// 					[15.015625, 14.48046875],
// 					[15.99609375, 16.48828125],
// 					[16.5078125, 17],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.09803921729326248, 0.125490203499794, 0.1411764770746231,
// 					0.15294118225574493, 0.16470588743686676, 0.16078431904315948,
// 					0.09019608050584793, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [16.5078125, 17],
// 			},
// 		],
// 		È: [
// 			{
// 				id: "DOIO7BT5yLPceqSGHR0Yu",
// 				type: "freedraw",
// 				x: 470.1953125,
// 				y: 225.00390625,
// 				width: 40.0078125,
// 				height: 58.48828125,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1181947497,
// 				version: 38,
// 				versionNonce: 1232615719,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751212963111,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.984375, 0.98828125],
// 					[1.49609375, 1.5],
// 					[0.515625, 1.984375],
// 					[-4.0078125, 1.984375],
// 					[-9.98046875, 1.984375],
// 					[-18, 1.984375],
// 					[-25.50390625, 0.98828125],
// 					[-31.0078125, 0.484375],
// 					[-34.50390625, 0.98828125],
// 					[-37.4921875, 3.00390625],
// 					[-38.51171875, 5.49609375],
// 					[-38.51171875, 7.98828125],
// 					[-38.00390625, 8.98046875],
// 					[-36.98046875, 10.99609375],
// 					[-36.5078125, 12.9765625],
// 					[-34.9765625, 17.484375],
// 					[-34.50390625, 21],
// 					[-34.50390625, 28.98828125],
// 					[-35.48828125, 35.48046875],
// 					[-36.5078125, 41.00390625],
// 					[-36.98046875, 45],
// 					[-37.4921875, 47.4921875],
// 					[-37.4921875, 50.9765625],
// 					[-36.98046875, 52.98828125],
// 					[-35.48828125, 54.4921875],
// 					[-32.5, 55.99609375],
// 					[-27.98046875, 57.49609375],
// 					[-22.0078125, 57.9765625],
// 					[-16.50390625, 58.48828125],
// 					[-13.0078125, 58.48828125],
// 					[-8.015625, 57.49609375],
// 					[-2.984375, 57.49609375],
// 					[-0.5078125, 57.49609375],
// 					[0.515625, 57.49609375],
// 					[1.49609375, 57.49609375],
// 					[1.49609375, 57.49609375],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.08627451211214066, 0.10196078568696976,
// 					0.13725490868091583, 0.1882352977991104, 0.1921568661928177, 0.1725490242242813,
// 					0.16078431904315948, 0.14509804546833038, 0.12941177189350128,
// 					0.12941177189350128, 0.15294118225574493, 0.1764705926179886,
// 					0.18039216101169586, 0.20000000298023224, 0.20000000298023224,
// 					0.1882352977991104, 0.1921568661928177, 0.1921568661928177, 0.1921568661928177,
// 					0.20000000298023224, 0.21176470816135406, 0.21960784494876862,
// 					0.22745098173618317, 0.23137255012989044, 0.23529411852359772,
// 					0.24705882370471954, 0.2549019753932953, 0.26274511218070984,
// 					0.26274511218070984, 0.25882354378700256, 0.250980406999588,
// 					0.23529411852359772, 0.20000000298023224, 0.18431372940540314,
// 					0.10588235408067703, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [1.49609375, 57.49609375],
// 			},
// 			{
// 				id: "IQcMpHLtQTdZBne7vrkos",
// 				type: "freedraw",
// 				x: 466.69921875,
// 				y: 261.984375,
// 				width: 31.0078125,
// 				height: 3.99609375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 759533481,
// 				version: 12,
// 				versionNonce: 949327527,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751212963436,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[-1.4921875, -0.9921875],
// 					[-3.49609375, -1.5],
// 					[-12.49609375, -2.4921875],
// 					[-18.51171875, -2.4921875],
// 					[-25.5078125, -2.9765625],
// 					[-28.4921875, -3.484375],
// 					[-31.0078125, -3.484375],
// 					[-29.00390625, -3.484375],
// 					[-27.51171875, -3.484375],
// 					[-26.48828125, -3.99609375],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.10588235408067703, 0.14509804546833038,
// 					0.21960784494876862, 0.22745098173618317, 0.2235294133424759,
// 					0.21176470816135406, 0.15294118225574493, 0.05098039284348488,
// 					0.027450980618596077, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-26.48828125, -3.99609375],
// 			},
// 			{
// 				id: "BF0ctUue1c3cXnzPegqUW",
// 				type: "freedraw",
// 				x: 441.703125,
// 				y: 209.50390625,
// 				width: 16.5078125,
// 				height: 10,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 508262953,
// 				version: 11,
// 				versionNonce: 370666759,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751212963918,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.4921875, 0],
// 					[2.00390625, 0.48046875],
// 					[2.98828125, 1.50390625],
// 					[9, 5.98046875],
// 					[12.5, 8.5],
// 					[15.01171875, 9.49609375],
// 					[15.99609375, 10],
// 					[16.5078125, 9.49609375],
// 					[16.5078125, 8.984375],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.05882352963089943, 0.10980392247438431,
// 					0.1568627506494522, 0.22745098173618317, 0.239215686917305, 0.21960784494876862,
// 					0.12941177189350128, 0.10588235408067703, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [16.5078125, 8.984375],
// 			},
// 		],
// 		É: [
// 			{
// 				id: "2xBSz9ZCSOth1MYKam6F9",
// 				type: "freedraw",
// 				x: 447.20703125,
// 				y: 244.5,
// 				width: 1.4921875,
// 				height: 46.984375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1251321001,
// 				version: 21,
// 				versionNonce: 2111196615,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751212966128,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.98046875, -0.51171875],
// 					[1.4921875, -0.9921875],
// 					[1.4921875, 1.984375],
// 					[0.98046875, 6.48828125],
// 					[0.98046875, 15.984375],
// 					[0.98046875, 26.4921875],
// 					[0.98046875, 34.99609375],
// 					[0.98046875, 39.984375],
// 					[0.98046875, 41.99609375],
// 					[0.98046875, 42.5078125],
// 					[0.98046875, 42.98828125],
// 					[0.98046875, 44.0078125],
// 					[0.98046875, 45],
// 					[0.98046875, 45.9921875],
// 					[0.5078125, 45.9921875],
// 					[0, 45.51171875],
// 					[0, 45],
// 					[0, 44.0078125],
// 					[0, 42.98828125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.09803921729326248, 0.11764705926179886,
// 					0.18431372940540314, 0.1921568661928177, 0.21176470816135406,
// 					0.21568627655506134, 0.2235294133424759, 0.22745098173618317,
// 					0.23137255012989044, 0.21568627655506134, 0.19607843458652496,
// 					0.19607843458652496, 0.19607843458652496, 0.1882352977991104,
// 					0.12156862765550613, 0.07058823853731155, 0.03921568766236305,
// 					0.0117647061124444, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [0, 42.98828125],
// 			},
// 			{
// 				id: "ptjEl9wd92eJy4UCxcTus",
// 				type: "freedraw",
// 				x: 439.69921875,
// 				y: 215.00390625,
// 				width: 14.50390625,
// 				height: 13.00390625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 389081353,
// 				version: 9,
// 				versionNonce: 26109415,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751212966562,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[2.515625, 0.48046875],
// 					[4.48046875, 0.98828125],
// 					[6.99609375, 3],
// 					[9.51171875, 6.48828125],
// 					[11.98828125, 10.484375],
// 					[13.48046875, 12.4921875],
// 					[14.50390625, 13.00390625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.07450980693101883, 0.07058823853731155,
// 					0.12156862765550613, 0.14509804546833038, 0.14509804546833038,
// 					0.08627451211214066, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [14.50390625, 13.00390625],
// 			},
// 		],
// 		Ì: [
// 			{
// 				id: "SjKAIDG2fBC-4a19phSYx",
// 				type: "freedraw",
// 				x: 453.1796875,
// 				y: 284.484375,
// 				width: 50.97265625,
// 				height: 52,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 358670793,
// 				version: 44,
// 				versionNonce: 484754055,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751212969736,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[3.02734375, 0.5078125],
// 					[4.0078125, 0.5078125],
// 					[6.5234375, -0.48046875],
// 					[9, -1.984375],
// 					[12.02734375, -5.5],
// 					[15.5234375, -9.49609375],
// 					[18.51171875, -15.5],
// 					[20.515625, -20.99609375],
// 					[21.5390625, -26.49609375],
// 					[22.0078125, -30.4921875],
// 					[22.0078125, -33.9765625],
// 					[21.03125, -37.4921875],
// 					[19.0234375, -40.49609375],
// 					[17.015625, -43.98046875],
// 					[13.51953125, -46.50390625],
// 					[9.51171875, -48.484375],
// 					[3.53515625, -49.4765625],
// 					[-1.96484375, -50.5],
// 					[-6.484375, -50.98046875],
// 					[-10.4921875, -50.98046875],
// 					[-14.46484375, -48.99609375],
// 					[-18.47265625, -45.9921875],
// 					[-22.48046875, -42.98828125],
// 					[-25.9765625, -38.48046875],
// 					[-27.984375, -31.9921875],
// 					[-28.96484375, -25.4765625],
// 					[-28.96484375, -18.98828125],
// 					[-28.4921875, -13.4921875],
// 					[-25.9765625, -8.50390625],
// 					[-21.96875, -4.4765625],
// 					[-17.48828125, -1.984375],
// 					[-12.96875, 0.5078125],
// 					[-7.46875, 1.01953125],
// 					[-1.96484375, 1.01953125],
// 					[4.51953125, -0.48046875],
// 					[11.515625, -3.484375],
// 					[15.5234375, -6.4921875],
// 					[18, -10.484375],
// 					[19.0234375, -14.9921875],
// 					[19.0234375, -19.49609375],
// 					[18.51171875, -22.5],
// 					[17.53125, -24],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.06666667014360428, 0.08235294371843338,
// 					0.12156862765550613, 0.13725490868091583, 0.16078431904315948,
// 					0.1725490242242813, 0.18039216101169586, 0.1921568661928177,
// 					0.20000000298023224, 0.20000000298023224, 0.19607843458652496,
// 					0.19607843458652496, 0.19607843458652496, 0.1921568661928177,
// 					0.1921568661928177, 0.1882352977991104, 0.1882352977991104, 0.18431372940540314,
// 					0.18431372940540314, 0.1882352977991104, 0.1921568661928177,
// 					0.19607843458652496, 0.20392157137393951, 0.21176470816135406,
// 					0.21176470816135406, 0.21176470816135406, 0.2078431397676468,
// 					0.20392157137393951, 0.21176470816135406, 0.21176470816135406,
// 					0.21960784494876862, 0.23137255012989044, 0.23529411852359772,
// 					0.23529411852359772, 0.23529411852359772, 0.23137255012989044,
// 					0.23137255012989044, 0.20392157137393951, 0.16078431904315948,
// 					0.08627451211214066, 0.05098039284348488, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [17.53125, -24],
// 			},
// 			{
// 				id: "8xcUhUFVmqiRIhun1czYo",
// 				type: "freedraw",
// 				x: 451.21484375,
// 				y: 207.4921875,
// 				width: 21.96875,
// 				height: 17.51171875,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 225982537,
// 				version: 12,
// 				versionNonce: 1422594055,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751212970180,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.4921875, 0.51171875],
// 					[2.4765625, 0.9921875],
// 					[4.9921875, 2.4921875],
// 					[7.46875, 4.5078125],
// 					[11.4765625, 7.51171875],
// 					[15.484375, 11.5078125],
// 					[18.98046875, 15.015625],
// 					[20.98828125, 17],
// 					[21.96875, 17.51171875],
// 					[21.96875, 16.4921875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0941176488995552, 0.10980392247438431,
// 					0.18431372940540314, 0.2235294133424759, 0.239215686917305, 0.25882354378700256,
// 					0.2705882489681244, 0.23529411852359772, 0.14509804546833038, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [21.96875, 16.4921875],
// 			},
// 		],
// 		Ò: [
// 			{
// 				id: "SjKAIDG2fBC-4a19phSYx",
// 				type: "freedraw",
// 				x: 453.1796875,
// 				y: 284.484375,
// 				width: 50.97265625,
// 				height: 52,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 358670793,
// 				version: 45,
// 				versionNonce: 1130896167,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751212977674,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[3.02734375, 0.5078125],
// 					[4.0078125, 0.5078125],
// 					[6.5234375, -0.48046875],
// 					[9, -1.984375],
// 					[12.02734375, -5.5],
// 					[15.5234375, -9.49609375],
// 					[18.51171875, -15.5],
// 					[20.515625, -20.99609375],
// 					[21.5390625, -26.49609375],
// 					[22.0078125, -30.4921875],
// 					[22.0078125, -33.9765625],
// 					[21.03125, -37.4921875],
// 					[19.0234375, -40.49609375],
// 					[17.015625, -43.98046875],
// 					[13.51953125, -46.50390625],
// 					[9.51171875, -48.484375],
// 					[3.53515625, -49.4765625],
// 					[-1.96484375, -50.5],
// 					[-6.484375, -50.98046875],
// 					[-10.4921875, -50.98046875],
// 					[-14.46484375, -48.99609375],
// 					[-18.47265625, -45.9921875],
// 					[-22.48046875, -42.98828125],
// 					[-25.9765625, -38.48046875],
// 					[-27.984375, -31.9921875],
// 					[-28.96484375, -25.4765625],
// 					[-28.96484375, -18.98828125],
// 					[-28.4921875, -13.4921875],
// 					[-25.9765625, -8.50390625],
// 					[-21.96875, -4.4765625],
// 					[-17.48828125, -1.984375],
// 					[-12.96875, 0.5078125],
// 					[-7.46875, 1.01953125],
// 					[-1.96484375, 1.01953125],
// 					[4.51953125, -0.48046875],
// 					[11.515625, -3.484375],
// 					[15.5234375, -6.4921875],
// 					[18, -10.484375],
// 					[19.0234375, -14.9921875],
// 					[19.0234375, -19.49609375],
// 					[18.51171875, -22.5],
// 					[17.53125, -24],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.06666667014360428, 0.08235294371843338,
// 					0.12156862765550613, 0.13725490868091583, 0.16078431904315948,
// 					0.1725490242242813, 0.18039216101169586, 0.1921568661928177,
// 					0.20000000298023224, 0.20000000298023224, 0.19607843458652496,
// 					0.19607843458652496, 0.19607843458652496, 0.1921568661928177,
// 					0.1921568661928177, 0.1882352977991104, 0.1882352977991104, 0.18431372940540314,
// 					0.18431372940540314, 0.1882352977991104, 0.1921568661928177,
// 					0.19607843458652496, 0.20392157137393951, 0.21176470816135406,
// 					0.21176470816135406, 0.21176470816135406, 0.2078431397676468,
// 					0.20392157137393951, 0.21176470816135406, 0.21176470816135406,
// 					0.21960784494876862, 0.23137255012989044, 0.23529411852359772,
// 					0.23529411852359772, 0.23529411852359772, 0.23137255012989044,
// 					0.23137255012989044, 0.20392157137393951, 0.16078431904315948,
// 					0.08627451211214066, 0.05098039284348488, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [17.53125, -24],
// 			},
// 			{
// 				id: "8xcUhUFVmqiRIhun1czYo",
// 				type: "freedraw",
// 				x: 451.21484375,
// 				y: 207.4921875,
// 				width: 21.96875,
// 				height: 17.51171875,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 225982537,
// 				version: 13,
// 				versionNonce: 454545097,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751212977674,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.4921875, 0.51171875],
// 					[2.4765625, 0.9921875],
// 					[4.9921875, 2.4921875],
// 					[7.46875, 4.5078125],
// 					[11.4765625, 7.51171875],
// 					[15.484375, 11.5078125],
// 					[18.98046875, 15.015625],
// 					[20.98828125, 17],
// 					[21.96875, 17.51171875],
// 					[21.96875, 16.4921875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0941176488995552, 0.10980392247438431,
// 					0.18431372940540314, 0.2235294133424759, 0.239215686917305, 0.25882354378700256,
// 					0.2705882489681244, 0.23529411852359772, 0.14509804546833038, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [21.96875, 16.4921875],
// 			},
// 		],
// 		Ù: [
// 			{
// 				id: "bwVBjNGypM55_HDD_UqgJ",
// 				type: "freedraw",
// 				x: 470.7109375,
// 				y: 228.0078125,
// 				width: 36.51171875,
// 				height: 63.984375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 149715079,
// 				version: 30,
// 				versionNonce: 126177257,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751212980813,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.46875, 1.5],
// 					[1.4921875, 3.484375],
// 					[1.4921875, 5.9765625],
// 					[0.98046875, 11.4765625],
// 					[-0.515625, 22.5],
// 					[-1.4921875, 29.98046875],
// 					[-3.5, 40.9765625],
// 					[-5.50390625, 50.49609375],
// 					[-8.01953125, 57.49609375],
// 					[-11.0078125, 62.484375],
// 					[-14.50390625, 63.984375],
// 					[-20.0078125, 63.984375],
// 					[-24.52734375, 61.4921875],
// 					[-26.53125, 59.9921875],
// 					[-31.01171875, 53.5],
// 					[-34.5078125, 45.48046875],
// 					[-35.01953125, 40.4921875],
// 					[-35.01953125, 34.48828125],
// 					[-34.5078125, 24.99609375],
// 					[-34, 18.4765625],
// 					[-34, 12.9765625],
// 					[-34, 8.98046875],
// 					[-34, 7],
// 					[-34, 6.48828125],
// 					[-34, 5.9765625],
// 					[-34.5078125, 5.9765625],
// 					[-34.5078125, 5.49609375],
// 					[-34.5078125, 5.49609375],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.062745101749897, 0.10588235408067703, 0.125490203499794,
// 					0.1411764770746231, 0.16470588743686676, 0.16862745583057404,
// 					0.1764705926179886, 0.1882352977991104, 0.18431372940540314,
// 					0.18431372940540314, 0.18431372940540314, 0.18431372940540314,
// 					0.18431372940540314, 0.18431372940540314, 0.1882352977991104,
// 					0.20392157137393951, 0.21176470816135406, 0.21960784494876862,
// 					0.22745098173618317, 0.2235294133424759, 0.22745098173618317,
// 					0.22745098173618317, 0.23137255012989044, 0.23137255012989044,
// 					0.22745098173618317, 0.13725490868091583, 0.01568627543747425, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-34.5078125, 5.49609375],
// 			},
// 			{
// 				id: "v80XoYclHSJpy0AqwJCgn",
// 				type: "freedraw",
// 				x: 442.6875,
// 				y: 208.00390625,
// 				width: 20.515625,
// 				height: 15.98046875,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1836204615,
// 				version: 10,
// 				versionNonce: 418132137,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751212981151,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[3.0234375, 0.98828125],
// 					[5.5, 1.98046875],
// 					[8.52734375, 3.99609375],
// 					[13.0078125, 7.98828125],
// 					[17.52734375, 13.48828125],
// 					[19.4921875, 15.49609375],
// 					[20.515625, 15.98046875],
// 					[20.515625, 14.98828125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.125490203499794, 0.1725490242242813,
// 					0.20392157137393951, 0.22745098173618317, 0.19607843458652496,
// 					0.1568627506494522, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [20.515625, 14.98828125],
// 			},
// 		],
// 	},
// 	...{
// 		a: [
// 			{
// 				id: "E-4ZUGpi7kUcFzuc4VZ4u",
// 				type: "freedraw",
// 				x: 258.59375,
// 				y: 185.98828125,
// 				width: 45.5078125,
// 				height: 48.99609375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1182722639,
// 				version: 53,
// 				versionNonce: 1306478529,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810170516,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[6.48828125, -27.00390625],
// 					[4.9921875, -30.4921875],
// 					[4.51953125, -31.484375],
// 					[4.01171875, -31.99609375],
// 					[0.51171875, -35.48046875],
// 					[-2.984375, -36.49609375],
// 					[-6.9921875, -36.49609375],
// 					[-11.00390625, -35.48046875],
// 					[-15.484375, -32.984375],
// 					[-16.9765625, -31.99609375],
// 					[-19.4921875, -28.48046875],
// 					[-20.984375, -25.984375],
// 					[-22.98828125, -22.5],
// 					[-24.484375, -18.50390625],
// 					[-24.9921875, -14],
// 					[-24.9921875, -10.00390625],
// 					[-23.5, -5.9765625],
// 					[-20.51171875, -3.00390625],
// 					[-17.48828125, -0.484375],
// 					[-13.48046875, 1.50390625],
// 					[-11.51171875, 2.49609375],
// 					[-9.5078125, 2.49609375],
// 					[-6.9921875, 2.49609375],
// 					[-4.98828125, 2.49609375],
// 					[-2.51171875, 1.01953125],
// 					[-0.5078125, -0.98828125],
// 					[2.0078125, -3.99609375],
// 					[3.5, -7],
// 					[4.9921875, -10.484375],
// 					[6.015625, -14.98828125],
// 					[6.48828125, -18.984375],
// 					[6.99609375, -22.98046875],
// 					[6.99609375, -25.984375],
// 					[6.99609375, -26.49609375],
// 					[6.99609375, -27.00390625],
// 					[6.99609375, -27.48828125],
// 					[6.99609375, -28],
// 					[7.5078125, -27.00390625],
// 					[8.01953125, -23.4921875],
// 					[8.01953125, -21],
// 					[9, -15.98046875],
// 					[9.984375, -9.4921875],
// 					[11.515625, -3.00390625],
// 					[13.9921875, 2.49609375],
// 					[16.5078125, 6.01171875],
// 					[18.51171875, 9.01171875],
// 					[19.49609375, 10.99609375],
// 					[20.0078125, 12.015625],
// 					[20.515625, 12.5],
// 					[18.984375, 12.015625],
// 					[18.51171875, 11.50390625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.26274511218070984, 0.26274511218070984,
// 					0.26274511218070984, 0.26274511218070984, 0.25882354378700256,
// 					0.26274511218070984, 0.26274511218070984, 0.2666666805744171,
// 					0.26274511218070984, 0.2666666805744171, 0.27843138575553894,
// 					0.2862745225429535, 0.29411765933036804, 0.29411765933036804,
// 					0.2862745225429535, 0.2862745225429535, 0.2823529541492462, 0.2862745225429535,
// 					0.2823529541492462, 0.2862745225429535, 0.29019609093666077,
// 					0.29411765933036804, 0.29411765933036804, 0.2980392277240753,
// 					0.29411765933036804, 0.29411765933036804, 0.29019609093666077,
// 					0.2862745225429535, 0.2823529541492462, 0.27843138575553894,
// 					0.27843138575553894, 0.27843138575553894, 0.27843138575553894,
// 					0.2823529541492462, 0.2823529541492462, 0.2823529541492462, 0.27843138575553894,
// 					0.33725491166114807, 0.34117648005485535, 0.3450980484485626,
// 					0.34117648005485535, 0.34117648005485535, 0.33725491166114807,
// 					0.3450980484485626, 0.3529411852359772, 0.3450980484485626, 0.33725491166114807,
// 					0.30980393290519714, 0.239215686917305, 0.05098039284348488, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [18.51171875, 11.50390625],
// 			},
// 		],
// 		b: [
// 			{
// 				id: "7yba7xEnSvj9g6jsuau-f",
// 				type: "freedraw",
// 				x: 240.59375,
// 				y: 112.5078125,
// 				width: 42.01171875,
// 				height: 75.0078125,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 342094689,
// 				version: 60,
// 				versionNonce: 2138773103,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810176558,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.0234375, -0.5078125],
// 					[1.0234375, 0],
// 					[1.0234375, 2.49609375],
// 					[1.0234375, 7],
// 					[0.51171875, 14],
// 					[0, 22.984375],
// 					[-0.5078125, 31.484375],
// 					[-0.5078125, 39.984375],
// 					[-0.98046875, 45],
// 					[-0.98046875, 50.98046875],
// 					[-0.98046875, 57.98046875],
// 					[-0.98046875, 59.9921875],
// 					[-0.98046875, 64.5],
// 					[-0.98046875, 66.48046875],
// 					[-1.4921875, 68.9765625],
// 					[-1.4921875, 69.484375],
// 					[-1.4921875, 68.49609375],
// 					[-1.4921875, 67.50390625],
// 					[-0.5078125, 66],
// 					[0, 64.98046875],
// 					[0.51171875, 63.4765625],
// 					[1.0234375, 62.99609375],
// 					[3.5, 59.48046875],
// 					[4.01171875, 58.4921875],
// 					[6.99609375, 54.49609375],
// 					[9, 51.4921875],
// 					[11.98828125, 48.99609375],
// 					[15.48828125, 46.984375],
// 					[18.984375, 45.9921875],
// 					[22.9921875, 45.48046875],
// 					[25.5078125, 45.48046875],
// 					[27.984375, 45.9921875],
// 					[29.98828125, 46.4765625],
// 					[31.9921875, 46.984375],
// 					[33.48828125, 47.9765625],
// 					[34.5078125, 48.99609375],
// 					[35.4921875, 50.5],
// 					[36, 52.48046875],
// 					[36, 56.4765625],
// 					[35.01953125, 59.48046875],
// 					[33.015625, 62.484375],
// 					[31.51953125, 64.5],
// 					[29.0078125, 66.9921875],
// 					[26.4921875, 68.9765625],
// 					[23.50390625, 70.98828125],
// 					[20.0078125, 72.4921875],
// 					[15.48828125, 73.48046875],
// 					[11.0078125, 74.5],
// 					[6.48828125, 74.5],
// 					[2.0078125, 74.5],
// 					[1.49609375, 74.5],
// 					[0, 74.5],
// 					[-1.4921875, 74.5],
// 					[-4.0078125, 74.5],
// 					[-4.48046875, 74.5],
// 					[-4.98828125, 74.5],
// 					[-5.5, 74.5],
// 					[-6.01171875, 73.9921875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.13333334028720856, 0.18431372940540314,
// 					0.20392157137393951, 0.2078431397676468, 0.21568627655506134,
// 					0.21176470816135406, 0.22745098173618317, 0.22745098173618317,
// 					0.23137255012989044, 0.23137255012989044, 0.2235294133424759,
// 					0.2235294133424759, 0.2235294133424759, 0.21960784494876862,
// 					0.21960784494876862, 0.2235294133424759, 0.1921568661928177,
// 					0.19607843458652496, 0.2078431397676468, 0.21176470816135406,
// 					0.21176470816135406, 0.21176470816135406, 0.21176470816135406,
// 					0.2078431397676468, 0.2078431397676468, 0.2078431397676468, 0.2078431397676468,
// 					0.21176470816135406, 0.2235294133424759, 0.23137255012989044, 0.239215686917305,
// 					0.250980406999588, 0.250980406999588, 0.250980406999588, 0.25882354378700256,
// 					0.26274511218070984, 0.26274511218070984, 0.26274511218070984,
// 					0.2705882489681244, 0.2666666805744171, 0.2705882489681244, 0.2705882489681244,
// 					0.27450981736183167, 0.27843138575553894, 0.2862745225429535,
// 					0.2862745225429535, 0.29411765933036804, 0.2980392277240753, 0.3019607961177826,
// 					0.29411765933036804, 0.29411765933036804, 0.29411765933036804,
// 					0.29411765933036804, 0.2862745225429535, 0.2549019753932953,
// 					0.19607843458652496, 0.06666667014360428, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-6.01171875, 73.9921875],
// 			},
// 		],
// 		c: [
// 			{
// 				id: "PP0X90O8EoUeduw_N715m",
// 				type: "freedraw",
// 				x: 262.09375,
// 				y: 152.4921875,
// 				width: 30.5,
// 				height: 38.99609375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 38197455,
// 				version: 23,
// 				versionNonce: 1099405569,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810181632,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.01953125, -0.5078125],
// 					[1.4921875, -0.5078125],
// 					[2.515625, -1.5],
// 					[2.515625, -3],
// 					[2.515625, -3.484375],
// 					[-0.984375, -3.99609375],
// 					[-6.484375, -1.984375],
// 					[-13.0078125, 1.5],
// 					[-18, 6.4921875],
// 					[-20.98828125, 12.015625],
// 					[-22.9921875, 17.515625],
// 					[-22.9921875, 23.01171875],
// 					[-20.98828125, 28.9921875],
// 					[-17.48828125, 32.5078125],
// 					[-12.5, 34.515625],
// 					[-7.5078125, 35],
// 					[1.01953125, 33.49609375],
// 					[4.9921875, 32.5078125],
// 					[6.484375, 31.99609375],
// 					[7.5078125, 31.99609375],
// 					[7.5078125, 32.5078125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.09803921729326248,
// 					0.12941177189350128, 0.1764705926179886, 0.22745098173618317,
// 					0.27843138575553894, 0.3019607961177826, 0.3176470696926117, 0.3294117748737335,
// 					0.33725491166114807, 0.3529411852359772, 0.364705890417099, 0.38823530077934265,
// 					0.40392157435417175, 0.4156862795352936, 0.4274509847164154, 0.3843137323856354,
// 					0.33725491166114807, 0.24705882370471954, 0.14901961386203766, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [7.5078125, 32.5078125],
// 			},
// 		],
// 		d: [
// 			{
// 				id: "nMsLRhWwVvRMif87TIf2o",
// 				type: "freedraw",
// 				x: 265.58984375,
// 				y: 120.5,
// 				width: 39.5,
// 				height: 67.984375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 83942351,
// 				version: 40,
// 				versionNonce: 1596087265,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810184285,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.51171875, -0.9921875],
// 					[0.51171875, -1.5],
// 					[1.0234375, -3.515625],
// 					[1.49609375, -5.015625],
// 					[1.49609375, -6.515625],
// 					[1.49609375, -7],
// 					[0.51171875, -5.015625],
// 					[-0.98046875, 0],
// 					[-2.4765625, 7],
// 					[-3.49609375, 16.4921875],
// 					[-4.48046875, 25.98828125],
// 					[-5.5, 35.5078125],
// 					[-6.484375, 42.5078125],
// 					[-7.9765625, 48.00390625],
// 					[-8.48828125, 52.9921875],
// 					[-9, 57.5],
// 					[-9, 59.9921875],
// 					[-9, 60.984375],
// 					[-9, 59.51171875],
// 					[-7.9765625, 56.5078125],
// 					[-7.9765625, 52.51171875],
// 					[-7.9765625, 48.484375],
// 					[-9, 45],
// 					[-10.4921875, 42.5078125],
// 					[-15.99609375, 38.9921875],
// 					[-20.984375, 37.48828125],
// 					[-26.48828125, 38],
// 					[-31.48046875, 39.984375],
// 					[-35.48828125, 42.98828125],
// 					[-38.00390625, 45.9921875],
// 					[-38.00390625, 49.98828125],
// 					[-35.48828125, 53.984375],
// 					[-29.4765625, 56.98828125],
// 					[-20.4765625, 58.48828125],
// 					[-11.984375, 56.98828125],
// 					[-6.01171875, 54.4921875],
// 					[-0.98046875, 52.51171875],
// 					[-0.5078125, 52],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.05098039284348488,
// 					0.07450980693101883, 0.10980392247438431, 0.13725490868091583,
// 					0.16078431904315948, 0.18431372940540314, 0.20392157137393951,
// 					0.21960784494876862, 0.2235294133424759, 0.23137255012989044,
// 					0.22745098173618317, 0.22745098173618317, 0.2235294133424759,
// 					0.21960784494876862, 0.21960784494876862, 0.21960784494876862,
// 					0.21960784494876862, 0.21960784494876862, 0.22745098173618317,
// 					0.22745098173618317, 0.239215686917305, 0.239215686917305, 0.23137255012989044,
// 					0.21176470816135406, 0.2078431397676468, 0.2078431397676468,
// 					0.21176470816135406, 0.21960784494876862, 0.23137255012989044,
// 					0.24705882370471954, 0.26274511218070984, 0.27450981736183167,
// 					0.2823529541492462, 0.2823529541492462, 0.24313725531101227,
// 					0.12156862765550613, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-0.5078125, 52],
// 			},
// 		],
// 		e: [
// 			{
// 				id: "lerLuhaOnwyNqNh-YMsRL",
// 				type: "freedraw",
// 				x: 241.6171875,
// 				y: 164,
// 				width: 44.015625,
// 				height: 39.5,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1703669487,
// 				version: 27,
// 				versionNonce: 296046689,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810189897,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[-1.0234375, 0.5078125],
// 					[-1.0234375, 0.98828125],
// 					[1.96484375, 0.98828125],
// 					[4.48046875, 0.98828125],
// 					[10.96484375, 0.5078125],
// 					[16.9765625, -0.51171875],
// 					[23.97265625, -3.0078125],
// 					[27.47265625, -6.01171875],
// 					[28.4921875, -10.51171875],
// 					[27.984375, -13.0078125],
// 					[25.9765625, -15.50390625],
// 					[22.9921875, -17.51171875],
// 					[16.46875, -17.51171875],
// 					[5.97265625, -16.01171875],
// 					[0.47265625, -13.4921875],
// 					[-4.51953125, -8.50390625],
// 					[-6.5234375, -2.49609375],
// 					[-6.01171875, 4.50390625],
// 					[-0.51171875, 11.984375],
// 					[6.99609375, 19.49609375],
// 					[13.48046875, 21.50390625],
// 					[23.46484375, 21.98828125],
// 					[30.96875, 21.98828125],
// 					[35.9609375, 21],
// 					[37.4921875, 20.48828125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.07058823853731155,
// 					0.21960784494876862, 0.239215686917305, 0.26274511218070984, 0.2666666805744171,
// 					0.2705882489681244, 0.26274511218070984, 0.23529411852359772,
// 					0.21960784494876862, 0.2078431397676468, 0.20392157137393951,
// 					0.20392157137393951, 0.19607843458652496, 0.1882352977991104,
// 					0.18431372940540314, 0.1882352977991104, 0.21568627655506134,
// 					0.24313725531101227, 0.26274511218070984, 0.27450981736183167,
// 					0.27450981736183167, 0.24705882370471954, 0.08627451211214066, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [37.4921875, 20.48828125],
// 			},
// 		],
// 		f: [
// 			{
// 				id: "hnEsiOBDjP-wW7VYvvw1K",
// 				type: "freedraw",
// 				x: 243.58203125,
// 				y: 185.98828125,
// 				width: 18.984375,
// 				height: 68.0078125,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 627261441,
// 				version: 23,
// 				versionNonce: 2005075247,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810202901,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, 1.01953125],
// 					[0, 0],
// 					[0, -5.49609375],
// 					[-0.98046875, -14.98828125],
// 					[-1.96484375, -27.00390625],
// 					[-2.4765625, -38.484375],
// 					[-2.4765625, -45.484375],
// 					[-1.96484375, -53.5],
// 					[0, -57.9765625],
// 					[2.00390625, -60.98046875],
// 					[5.03125, -64.49609375],
// 					[8.01953125, -66.48046875],
// 					[10.53125, -66.98828125],
// 					[13.0078125, -66.98828125],
// 					[15.01171875, -66],
// 					[15.99609375, -64.49609375],
// 					[16.5078125, -61.4921875],
// 					[16.5078125, -57.9765625],
// 					[16.5078125, -54.4921875],
// 					[15.5234375, -50.49609375],
// 					[15.01171875, -49.50390625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.09803921729326248, 0.1882352977991104,
// 					0.24313725531101227, 0.2862745225429535, 0.3176470696926117,
// 					0.33725491166114807, 0.3450980484485626, 0.3490196168422699, 0.3529411852359772,
// 					0.35686275362968445, 0.3490196168422699, 0.33725491166114807,
// 					0.33725491166114807, 0.3333333432674408, 0.3137255012989044, 0.2666666805744171,
// 					0.21960784494876862, 0.16078431904315948, 0.11372549086809158,
// 					0.0313725508749485, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [15.01171875, -49.50390625],
// 			},
// 			{
// 				id: "_G3nh355eOprtP0i8xD2Z",
// 				type: "freedraw",
// 				x: 257.1015625,
// 				y: 158.5,
// 				width: 26.015625,
// 				height: 1.50390625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 599890209,
// 				version: 10,
// 				versionNonce: 880354927,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810203339,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.984375, 0.484375],
// 					[2.00390625, 0.9921875],
// 					[-1.01953125, 1.50390625],
// 					[-6.99609375, 1.50390625],
// 					[-11.98828125, 1.50390625],
// 					[-17.48828125, 1.50390625],
// 					[-21.49609375, 0.9921875],
// 					[-24.01171875, 0.9921875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.13333334028720856,
// 					0.19607843458652496, 0.23137255012989044, 0.22745098173618317,
// 					0.1921568661928177, 0.125490203499794, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-24.01171875, 0.9921875],
// 			},
// 		],
// 		g: [
// 			{
// 				id: "EgekiMU6YmS4-t2V-aXhP",
// 				type: "freedraw",
// 				x: 245.5859375,
// 				y: 164.5078125,
// 				width: 36.984375,
// 				height: 93.00390625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 2034165967,
// 				version: 45,
// 				versionNonce: 1870721601,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810209738,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.0234375, 0.48046875],
// 					[1.49609375, 0.9921875],
// 					[3.02734375, 0.9921875],
// 					[5.50390625, -0.5078125],
// 					[10.0234375, -5.5234375],
// 					[12.02734375, -9.51953125],
// 					[12.5, -16.01171875],
// 					[10.49609375, -18.01953125],
// 					[3.02734375, -18.50390625],
// 					[-1.4921875, -16.01171875],
// 					[-9, -8.5],
// 					[-11.4765625, -2.5234375],
// 					[-9.98046875, 3.99609375],
// 					[-5.97265625, 7.48046875],
// 					[1.0234375, 10.484375],
// 					[5.03125, 9.49609375],
// 					[10.49609375, 4.98828125],
// 					[13.51953125, -1.5],
// 					[13.51953125, -5.015625],
// 					[12.02734375, -8.01953125],
// 					[10.0234375, -10.00390625],
// 					[8.52734375, -11.01953125],
// 					[8.01953125, -11.01953125],
// 					[8.01953125, -9.01171875],
// 					[9, -4.0234375],
// 					[12.02734375, 6.4921875],
// 					[15.015625, 16.9765625],
// 					[19.49609375, 36.5],
// 					[21.02734375, 45.9921875],
// 					[21.5, 56.4765625],
// 					[18.51171875, 66.48046875],
// 					[13.51953125, 70.98828125],
// 					[3.5, 74.5],
// 					[-1.4921875, 74.5],
// 					[-6.99609375, 70.4765625],
// 					[-9.98046875, 66.48046875],
// 					[-11.4765625, 59],
// 					[-8.48828125, 50.5],
// 					[-2.00390625, 41.484375],
// 					[7.5078125, 32.4765625],
// 					[18, 24.484375],
// 					[24.015625, 17.99609375],
// 					[25.5078125, 14],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.10980392247438431,
// 					0.16470588743686676, 0.21176470816135406, 0.25882354378700256,
// 					0.2823529541492462, 0.2980392277240753, 0.29411765933036804,
// 					0.27843138575553894, 0.2705882489681244, 0.250980406999588, 0.24705882370471954,
// 					0.2705882489681244, 0.2705882489681244, 0.2823529541492462, 0.2862745225429535,
// 					0.2862745225429535, 0.2705882489681244, 0.26274511218070984, 0.250980406999588,
// 					0.23529411852359772, 0.22745098173618317, 0.2235294133424759,
// 					0.2549019753932953, 0.2862745225429535, 0.3019607961177826, 0.30980393290519714,
// 					0.3176470696926117, 0.3333333432674408, 0.3490196168422699, 0.364705890417099,
// 					0.37254902720451355, 0.364705890417099, 0.34117648005485535,
// 					0.30980393290519714, 0.3137255012989044, 0.3137255012989044,
// 					0.32549020648002625, 0.32156863808631897, 0.27450981736183167,
// 					0.1882352977991104, 0.10196078568696976, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [25.5078125, 14],
// 			},
// 		],
// 		h: [
// 			{
// 				id: "9tKK_jGfMZT6BUKjX32xY",
// 				type: "freedraw",
// 				x: 240.59375,
// 				y: 115.00390625,
// 				width: 27,
// 				height: 65.00390625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 271386255,
// 				version: 29,
// 				versionNonce: 444635777,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810213163,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.0234375, -0.51171875],
// 					[1.49609375, -1.01953125],
// 					[2.0078125, -1.01953125],
// 					[2.515625, 0],
// 					[2.515625, 4.50390625],
// 					[2.0078125, 12.49609375],
// 					[1.49609375, 24.484375],
// 					[1.49609375, 38],
// 					[1.49609375, 50.9765625],
// 					[2.0078125, 59],
// 					[2.515625, 63.50390625],
// 					[2.515625, 63.984375],
// 					[2.515625, 62.99609375],
// 					[2.515625, 59.98828125],
// 					[3.5, 55.99609375],
// 					[4.51953125, 51.48828125],
// 					[6.015625, 47.4921875],
// 					[8.4921875, 42.984375],
// 					[13.51953125, 38.98828125],
// 					[19.49609375, 37.48828125],
// 					[24.015625, 39.5],
// 					[26.01953125, 44.48828125],
// 					[27, 49.984375],
// 					[27, 55.00390625],
// 					[26.4921875, 59],
// 					[26.4921875, 59.48046875],
// 					[26.4921875, 59.48046875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.0941176488995552, 0.14509804546833038,
// 					0.18431372940540314, 0.20392157137393951, 0.23529411852359772,
// 					0.23137255012989044, 0.23529411852359772, 0.2549019753932953,
// 					0.27450981736183167, 0.2862745225429535, 0.2980392277240753,
// 					0.25882354378700256, 0.23529411852359772, 0.23137255012989044,
// 					0.23137255012989044, 0.23137255012989044, 0.24313725531101227,
// 					0.24313725531101227, 0.25882354378700256, 0.2823529541492462,
// 					0.30980393290519714, 0.32156863808631897, 0.32549020648002625,
// 					0.2823529541492462, 0.27843138575553894, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [26.4921875, 59.48046875],
// 			},
// 		],
// 		i: [
// 			{
// 				id: "7CxPArXPsFKv_MVo8Pxt8",
// 				type: "freedraw",
// 				x: 250.10546875,
// 				y: 188.484375,
// 				width: 2.00390625,
// 				height: 25.4765625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 56442401,
// 				version: 12,
// 				versionNonce: 849019311,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810215514,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.51171875, -0.9921875],
// 					[0.984375, -1.4765625],
// 					[1.49609375, -5.5],
// 					[2.00390625, -10.484375],
// 					[2.00390625, -16.49609375],
// 					[2.00390625, -21.9921875],
// 					[1.49609375, -24.99609375],
// 					[0.984375, -25.4765625],
// 					[0, -24.99609375],
// 					[0, -24.484375],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.0784313753247261, 0.08627451211214066,
// 					0.16078431904315948, 0.18431372940540314, 0.1921568661928177,
// 					0.18039216101169586, 0.1411764770746231, 0.04313725605607033, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [0, -24.484375],
// 			},
// 			{
// 				id: "Z6rZF6ge6pqox3WfjMmQx",
// 				type: "freedraw",
// 				x: 247.08203125,
// 				y: 146.00390625,
// 				width: 3.53515625,
// 				height: 3.51171875,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1409823905,
// 				version: 9,
// 				versionNonce: 1766913231,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810215714,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.01953125, 0],
// 					[2.00390625, -0.5078125],
// 					[3.0234375, -2.01171875],
// 					[3.53515625, -2.51953125],
// 					[3.53515625, -3.51171875],
// 					[0, 0],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.10196078568696976,
// 					0.14901961386203766, 0.16078431904315948, 0.09803921729326248, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [3.0234375, -3.99609375],
// 			},
// 		],
// 		j: [
// 			{
// 				id: "4e5CjXwu2dI78-qL3tfu1",
// 				type: "freedraw",
// 				x: 246.609375,
// 				y: 150,
// 				width: 2.00390625,
// 				height: 1.984375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 33084207,
// 				version: 11,
// 				versionNonce: 683637281,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810217823,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.98046875, 0.5078125],
// 					[0.98046875, 0.9921875],
// 					[1.4921875, 0.9921875],
// 					[2.00390625, 0.9921875],
// 					[2.00390625, 0.5078125],
// 					[2.00390625, -0.5078125],
// 					[2.00390625, -0.9921875],
// 					[0, 0],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.11372549086809158,
// 					0.16078431904315948, 0.22745098173618317, 0.250980406999588,
// 					0.22745098173618317, 0.20000000298023224, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [0.98046875, -0.9921875],
// 			},
// 			{
// 				id: "F1qfnwzTI4t1ix5TT7xFQ",
// 				type: "freedraw",
// 				x: 251.08984375,
// 				y: 177.48828125,
// 				width: 18.98046875,
// 				height: 58.99609375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1274744463,
// 				version: 19,
// 				versionNonce: 464822209,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810218296,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.01953125, -0.48046875],
// 					[1.4921875, -0.9921875],
// 					[1.4921875, -1.50390625],
// 					[1.01953125, -1.984375],
// 					[0, -0.48046875],
// 					[-0.984375, 2.5234375],
// 					[-0.984375, 15.015625],
// 					[1.01953125, 26.4921875],
// 					[4.51953125, 44.0078125],
// 					[5.5, 51.51953125],
// 					[4.0078125, 57.01171875],
// 					[0.51171875, 57.01171875],
// 					[-5.50390625, 54.01171875],
// 					[-11.00390625, 47.01171875],
// 					[-13.0078125, 41.99609375],
// 					[-13.48046875, 38],
// 					[-13.0078125, 37.0078125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.07450980693101883, 0.10980392247438431,
// 					0.15294118225574493, 0.20000000298023224, 0.250980406999588,
// 					0.27450981736183167, 0.2705882489681244, 0.27450981736183167,
// 					0.2705882489681244, 0.27843138575553894, 0.3137255012989044,
// 					0.30980393290519714, 0.30980393290519714, 0.250980406999588, 0.1725490242242813,
// 					0.05098039284348488, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-13.0078125, 37.0078125],
// 			},
// 		],
// 		k: [
// 			{
// 				id: "aqQNyZR_wvklRykMIVsvV",
// 				type: "freedraw",
// 				x: 240.59375,
// 				y: 150.9921875,
// 				width: 45.5078125,
// 				height: 50.5,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1985761551,
// 				version: 42,
// 				versionNonce: 1847547489,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810224205,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, -1.5],
// 					[0, -5.49609375],
// 					[0.51171875, -8.984375],
// 					[0.51171875, -10.48828125],
// 					[1.0234375, -10.48828125],
// 					[1.49609375, -6.0078125],
// 					[1.49609375, -0.9921875],
// 					[1.0234375, 7.9921875],
// 					[0.51171875, 16.4921875],
// 					[-0.5078125, 27.0078125],
// 					[-0.5078125, 31.51171875],
// 					[-0.5078125, 33.015625],
// 					[-0.5078125, 32.50390625],
// 					[-0.5078125, 30.01171875],
// 					[1.0234375, 26.49609375],
// 					[2.515625, 22.01953125],
// 					[4.9921875, 17],
// 					[9.51171875, 11.50390625],
// 					[17.4921875, 5.015625],
// 					[25.5078125, 0],
// 					[29.515625, -2.49609375],
// 					[31.51953125, -3.48828125],
// 					[31.51953125, -3.00390625],
// 					[28.49609375, -0.9921875],
// 					[24.48828125, 3],
// 					[20.0078125, 6.515625],
// 					[15.99609375, 9.4921875],
// 					[12.5, 12.49609375],
// 					[11.515625, 13.99609375],
// 					[11.98828125, 14.98828125],
// 					[14.50390625, 16.4921875],
// 					[18.51171875, 19.49609375],
// 					[22.9921875, 23.4921875],
// 					[27.51171875, 27.99609375],
// 					[31.9921875, 32.50390625],
// 					[36, 36.015625],
// 					[38.515625, 38],
// 					[42.015625, 39.50390625],
// 					[44.01953125, 40.01171875],
// 					[45, 40.01171875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.0784313753247261, 0.12156862765550613,
// 					0.1764705926179886, 0.24313725531101227, 0.27450981736183167,
// 					0.2980392277240753, 0.2980392277240753, 0.2980392277240753, 0.2980392277240753,
// 					0.3137255012989044, 0.3333333432674408, 0.3333333432674408, 0.3137255012989044,
// 					0.30588236451148987, 0.3019607961177826, 0.30588236451148987,
// 					0.3176470696926117, 0.3176470696926117, 0.3294117748737335, 0.34117648005485535,
// 					0.35686275362968445, 0.364705890417099, 0.3294117748737335, 0.30980393290519714,
// 					0.30980393290519714, 0.3019607961177826, 0.2980392277240753, 0.2980392277240753,
// 					0.2980392277240753, 0.30980393290519714, 0.3176470696926117, 0.3294117748737335,
// 					0.3450980484485626, 0.3843137323856354, 0.3921568691730499, 0.3921568691730499,
// 					0.2705882489681244, 0.18039216101169586, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [45, 40.01171875],
// 			},
// 		],
// 		l: [
// 			{
// 				id: "qCjjEVkd5jupXVluA4t-G",
// 				type: "freedraw",
// 				x: 244.09375,
// 				y: 118.0078125,
// 				width: 15.5234375,
// 				height: 71.5,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 129233441,
// 				version: 19,
// 				versionNonce: 516069519,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810230238,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.01953125, -1.50390625],
// 					[1.01953125, -2.015625],
// 					[1.4921875, -3.00390625],
// 					[2.00390625, -4.5078125],
// 					[2.515625, -3.00390625],
// 					[1.4921875, 3.484375],
// 					[-0.51171875, 11.984375],
// 					[-3.5, 29.98046875],
// 					[-4.0078125, 45],
// 					[-2.98828125, 55.99609375],
// 					[-0.984375, 62.484375],
// 					[0.51171875, 64.49609375],
// 					[3.49609375, 66],
// 					[5.5, 66.48046875],
// 					[7.5078125, 66.9921875],
// 					[9.51171875, 66.9921875],
// 					[11.515625, 66.48046875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.07450980693101883,
// 					0.07450980693101883, 0.12156862765550613, 0.22745098173618317,
// 					0.2666666805744171, 0.3019607961177826, 0.33725491166114807, 0.3450980484485626,
// 					0.3529411852359772, 0.364705890417099, 0.3686274588108063, 0.34117648005485535,
// 					0.30588236451148987, 0.23137255012989044, 0.1568627506494522, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [11.515625, 66.48046875],
// 			},
// 		],
// 		m: [
// 			{
// 				id: "4mprFZpuyBIGdyrGamuL0",
// 				type: "freedraw",
// 				x: 225.578125,
// 				y: 147,
// 				width: 47.51953125,
// 				height: 50.49609375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 601030863,
// 				version: 53,
// 				versionNonce: 1043089729,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810232858,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.515625, -0.99609375],
// 					[1.02734375, -1.50390625],
// 					[1.53515625, 0.50390625],
// 					[2.0078125, 4.5],
// 					[2.0078125, 12.4921875],
// 					[2.0078125, 24.5078125],
// 					[2.0078125, 32.5],
// 					[2.51953125, 41.00390625],
// 					[2.51953125, 47.4921875],
// 					[2.51953125, 48.9921875],
// 					[2.0078125, 47.4921875],
// 					[2.0078125, 43.49609375],
// 					[2.51953125, 38],
// 					[3.5, 31],
// 					[5.03515625, 23.0078125],
// 					[7.51171875, 15.49609375],
// 					[10.53515625, 9.48828125],
// 					[14.03515625, 5.4921875],
// 					[16.51171875, 3.5078125],
// 					[19.02734375, 3],
// 					[21.03125, 4.984375],
// 					[22.5234375, 9.0078125],
// 					[23.5078125, 14.984375],
// 					[24.015625, 21.50390625],
// 					[24.015625, 28.50390625],
// 					[24.015625, 34.9921875],
// 					[24.015625, 40.0078125],
// 					[24.015625, 41.00390625],
// 					[24.015625, 41.484375],
// 					[24.015625, 41.00390625],
// 					[24.015625, 40.0078125],
// 					[24.52734375, 38],
// 					[25.51171875, 34.00390625],
// 					[28.02734375, 27.00390625],
// 					[29.51953125, 23.0078125],
// 					[33.52734375, 16.0078125],
// 					[35.53125, 13.00390625],
// 					[39.50390625, 8.49609375],
// 					[42.015625, 6.9921875],
// 					[43.51171875, 7.50390625],
// 					[45.00390625, 10.98828125],
// 					[46.02734375, 17],
// 					[46.53515625, 24.5078125],
// 					[47.0078125, 31.98828125],
// 					[47.51953125, 38.98828125],
// 					[47.51953125, 44.48828125],
// 					[47.51953125, 46.49609375],
// 					[47.51953125, 47.0078125],
// 					[47.51953125, 46.49609375],
// 					[47.51953125, 45.50390625],
// 					[47.51953125, 44.48828125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.10588235408067703,
// 					0.15294118225574493, 0.1764705926179886, 0.18039216101169586,
// 					0.19607843458652496, 0.20000000298023224, 0.21568627655506134,
// 					0.239215686917305, 0.24313725531101227, 0.20392157137393951,
// 					0.20000000298023224, 0.2078431397676468, 0.21176470816135406,
// 					0.21568627655506134, 0.21568627655506134, 0.21568627655506134,
// 					0.21176470816135406, 0.21176470816135406, 0.22745098173618317,
// 					0.250980406999588, 0.26274511218070984, 0.2705882489681244, 0.2705882489681244,
// 					0.2666666805744171, 0.2666666805744171, 0.2705882489681244, 0.2705882489681244,
// 					0.2705882489681244, 0.2666666805744171, 0.22745098173618317,
// 					0.20392157137393951, 0.19607843458652496, 0.1921568661928177,
// 					0.19607843458652496, 0.18431372940540314, 0.18039216101169586,
// 					0.18039216101169586, 0.18039216101169586, 0.2078431397676468,
// 					0.23529411852359772, 0.25882354378700256, 0.2705882489681244,
// 					0.27843138575553894, 0.29019609093666077, 0.29411765933036804,
// 					0.2823529541492462, 0.24705882370471954, 0.1568627506494522, 0.062745101749897,
// 					0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [47.51953125, 44.48828125],
// 			},
// 		],
// 		n: [
// 			{
// 				id: "Hr2Y1YQ2a820LVv7BVPlb",
// 				type: "freedraw",
// 				x: 233.08984375,
// 				y: 150,
// 				width: 31.51953125,
// 				height: 46.5,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1804184833,
// 				version: 31,
// 				versionNonce: 961784111,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810234906,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.01953125, 0],
// 					[1.4921875, 0],
// 					[2.515625, 0.5078125],
// 					[3.0234375, 3.48828125],
// 					[3.0234375, 8.984375],
// 					[2.515625, 17.484375],
// 					[2.00390625, 27.0078125],
// 					[2.00390625, 35.50390625],
// 					[2.00390625, 42.50390625],
// 					[2.00390625, 45.9921875],
// 					[2.00390625, 46.5],
// 					[2.00390625, 44.4921875],
// 					[2.00390625, 41.00390625],
// 					[2.00390625, 35.98828125],
// 					[3.0234375, 31.00390625],
// 					[4.51953125, 24.9921875],
// 					[7.50390625, 19.49609375],
// 					[11.515625, 14.5078125],
// 					[15.99609375, 11.984375],
// 					[21.49609375, 10.484375],
// 					[26.015625, 10.484375],
// 					[29.00390625, 10.9921875],
// 					[30.49609375, 13.48828125],
// 					[31.51953125, 18.984375],
// 					[31.51953125, 25.984375],
// 					[31.51953125, 32.984375],
// 					[31.0078125, 38.00390625],
// 					[31.0078125, 39.984375],
// 					[31.0078125, 39.5],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.10980392247438431,
// 					0.12941177189350128, 0.14901961386203766, 0.18431372940540314,
// 					0.20392157137393951, 0.1921568661928177, 0.19607843458652496,
// 					0.21568627655506134, 0.23137255012989044, 0.250980406999588,
// 					0.24705882370471954, 0.21176470816135406, 0.21176470816135406,
// 					0.21960784494876862, 0.23137255012989044, 0.239215686917305,
// 					0.24313725531101227, 0.25882354378700256, 0.27843138575553894,
// 					0.29411765933036804, 0.30980393290519714, 0.32549020648002625,
// 					0.3294117748737335, 0.32156863808631897, 0.3019607961177826,
// 					0.29019609093666077, 0.24705882370471954, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [31.0078125, 39.5],
// 			},
// 		],
// 		o: [
// 			{
// 				id: "LSQ-xIu-ROUgszWKMrFHq",
// 				type: "freedraw",
// 				x: 251.6015625,
// 				y: 174.00390625,
// 				width: 29.984375,
// 				height: 32.984375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 512780655,
// 				version: 22,
// 				versionNonce: 798867073,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810236652,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.4921875, 0.48046875],
// 					[4.48046875, 0.48046875],
// 					[7.50390625, 0],
// 					[9.98046875, -3.515625],
// 					[11.51171875, -9.015625],
// 					[11.00390625, -15.50390625],
// 					[7.9765625, -21],
// 					[2.51171875, -24.51171875],
// 					[-4.51953125, -24.99609375],
// 					[-11.0078125, -21.51171875],
// 					[-15.015625, -15.01953125],
// 					[-15.99609375, -9.015625],
// 					[-13.9921875, -1.50390625],
// 					[-8.4921875, 4.984375],
// 					[-2.98828125, 7.98828125],
// 					[1.4921875, 7.98828125],
// 					[9.5078125, 1.98046875],
// 					[13.0078125, -3.99609375],
// 					[13.98828125, -9.49609375],
// 					[13.48046875, -10.515625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.12941177189350128,
// 					0.16862745583057404, 0.18431372940540314, 0.20000000298023224,
// 					0.19607843458652496, 0.1921568661928177, 0.18039216101169586,
// 					0.1764705926179886, 0.1725490242242813, 0.16862745583057404, 0.1882352977991104,
// 					0.2078431397676468, 0.2235294133424759, 0.239215686917305, 0.24705882370471954,
// 					0.21960784494876862, 0.1882352977991104, 0.062745101749897, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [13.48046875, -10.515625],
// 			},
// 		],
// 		p: [
// 			{
// 				id: "l3rcSNHl0DjJAzRnukxk3",
// 				type: "freedraw",
// 				x: 244.60546875,
// 				y: 163.0078125,
// 				width: 30.49609375,
// 				height: 79.9921875,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1754190401,
// 				version: 34,
// 				versionNonce: 1699689039,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810238539,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.5078125, 0.9921875],
// 					[0.5078125, 2.4921875],
// 					[0.98046875, 5.9765625],
// 					[0.98046875, 12.9765625],
// 					[0.98046875, 21],
// 					[0.98046875, 37.48828125],
// 					[0.98046875, 52],
// 					[1.4921875, 64.49609375],
// 					[1.4921875, 71.4921875],
// 					[1.4921875, 73.984375],
// 					[0.5078125, 70.4765625],
// 					[0, 64.9765625],
// 					[0, 54.4921875],
// 					[0, 42.4765625],
// 					[0.5078125, 24.484375],
// 					[2.4765625, 10.99609375],
// 					[6.01171875, 2.97265625],
// 					[8.48828125, -1.0234375],
// 					[13.48046875, -5.01953125],
// 					[16.9765625, -6.0078125],
// 					[22.48046875, -5.5],
// 					[26.48828125, -2.5234375],
// 					[29.4765625, 2.4921875],
// 					[30.49609375, 7.48046875],
// 					[29.984375, 13.48828125],
// 					[27, 18.4765625],
// 					[22.48046875, 21.48046875],
// 					[18.5078125, 22.98046875],
// 					[11.4765625, 24],
// 					[7.50390625, 24],
// 					[4.98828125, 24],
// 					[4.48046875, 24],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.0784313753247261, 0.10196078568696976,
// 					0.13333334028720856, 0.14901961386203766, 0.15294118225574493,
// 					0.1568627506494522, 0.1764705926179886, 0.1921568661928177, 0.21176470816135406,
// 					0.18039216101169586, 0.16470588743686676, 0.16470588743686676,
// 					0.18039216101169586, 0.2078431397676468, 0.21176470816135406,
// 					0.20392157137393951, 0.2078431397676468, 0.21568627655506134,
// 					0.22745098173618317, 0.250980406999588, 0.27450981736183167,
// 					0.29019609093666077, 0.2980392277240753, 0.2980392277240753, 0.2862745225429535,
// 					0.2705882489681244, 0.24705882370471954, 0.20000000298023224,
// 					0.12941177189350128, 0.0784313753247261, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [4.48046875, 24],
// 			},
// 		],
// 		q: [
// 			{
// 				id: "yXsUrLZTRRpWYbqq_stD6",
// 				type: "freedraw",
// 				x: 247.58984375,
// 				y: 171.5078125,
// 				width: 34.50390625,
// 				height: 83.51171875,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1943284367,
// 				version: 37,
// 				versionNonce: 1206904193,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810241283,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.0234375, 0.48046875],
// 					[2.515625, 0.9921875],
// 					[4.9921875, 1.50390625],
// 					[6.99609375, 0.9921875],
// 					[9, -2.5234375],
// 					[9.51171875, -6.51953125],
// 					[8.4921875, -11.0234375],
// 					[4.51953125, -14],
// 					[-2.00390625, -15.01953125],
// 					[-9, -12.5234375],
// 					[-15.484375, -6.51953125],
// 					[-18.98046875, 0.9921875],
// 					[-18.98046875, 9.49609375],
// 					[-14.97265625, 16.49609375],
// 					[-9, 21.48046875],
// 					[-3.49609375, 22.5],
// 					[1.49609375, 18.4765625],
// 					[6.015625, 11.98828125],
// 					[8.4921875, 4.98828125],
// 					[9, -1.5],
// 					[9, -6.51953125],
// 					[8.01953125, -8.5],
// 					[7.5078125, -8.01953125],
// 					[7.5078125, -6.0078125],
// 					[8.01953125, -2.01171875],
// 					[9, 5.98046875],
// 					[10.0234375, 18.98828125],
// 					[11.98828125, 36.5],
// 					[13.51953125, 52],
// 					[13.9921875, 61.49609375],
// 					[14.50390625, 65.99609375],
// 					[14.50390625, 68.4921875],
// 					[14.50390625, 67.5],
// 					[15.5234375, 62.9921875],
// 					[15.5234375, 61.9765625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.0784313753247261, 0.1411764770746231,
// 					0.1882352977991104, 0.21960784494876862, 0.23529411852359772, 0.239215686917305,
// 					0.23529411852359772, 0.239215686917305, 0.250980406999588, 0.24705882370471954,
// 					0.2549019753932953, 0.25882354378700256, 0.2549019753932953, 0.250980406999588,
// 					0.26274511218070984, 0.27843138575553894, 0.27843138575553894,
// 					0.27450981736183167, 0.2666666805744171, 0.26274511218070984,
// 					0.26274511218070984, 0.3019607961177826, 0.35686275362968445,
// 					0.38823530077934265, 0.40392157435417175, 0.40392157435417175,
// 					0.40392157435417175, 0.4156862795352936, 0.4274509847164154, 0.4156862795352936,
// 					0.4117647111415863, 0.20392157137393951, 0.05882352963089943, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [15.5234375, 61.9765625],
// 			},
// 		],
// 		r: [
// 			{
// 				id: "7wIlVi1-Fju2rfvUc5FrE",
// 				type: "freedraw",
// 				x: 242.08984375,
// 				y: 153.00390625,
// 				width: 29.00390625,
// 				height: 45.484375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1908619585,
// 				version: 21,
// 				versionNonce: 787539887,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810243100,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.51171875, 0.98828125],
// 					[1.4921875, 3.484375],
// 					[1.4921875, 7.98828125],
// 					[2.00390625, 16.4921875],
// 					[2.00390625, 28],
// 					[2.00390625, 37.4921875],
// 					[2.00390625, 43.49609375],
// 					[2.00390625, 45.484375],
// 					[1.4921875, 43.98046875],
// 					[1.4921875, 38.99609375],
// 					[2.515625, 31.99609375],
// 					[4.0078125, 24.484375],
// 					[6.99609375, 17.484375],
// 					[15.99609375, 9.4921875],
// 					[22.0078125, 7],
// 					[26.015625, 7],
// 					[28.01953125, 7.98828125],
// 					[29.00390625, 10.99609375],
// 					[29.00390625, 11.984375],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.08235294371843338, 0.125490203499794,
// 					0.13725490868091583, 0.1568627506494522, 0.18431372940540314,
// 					0.21960784494876862, 0.2549019753932953, 0.25882354378700256,
// 					0.25882354378700256, 0.24705882370471954, 0.24313725531101227,
// 					0.250980406999588, 0.2666666805744171, 0.26274511218070984, 0.26274511218070984,
// 					0.25882354378700256, 0.054901961237192154, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [29.00390625, 11.984375],
// 			},
// 		],
// 		s: [
// 			{
// 				id: "ACJPGPsetzvxd6j55rxHH",
// 				type: "freedraw",
// 				x: 252.109375,
// 				y: 156.0078125,
// 				width: 27.984375,
// 				height: 33.9765625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 399509487,
// 				version: 22,
// 				versionNonce: 1815709697,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810244775,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.49609375, 0],
// 					[0.984375, 0],
// 					[-2.00390625, 0.9921875],
// 					[-6.5234375, 1.98046875],
// 					[-10.4921875, 3.484375],
// 					[-12.49609375, 5.49609375],
// 					[-12.49609375, 7.48046875],
// 					[-8.52734375, 10.484375],
// 					[-2.515625, 14],
// 					[3.97265625, 18.984375],
// 					[7.46875, 24.00390625],
// 					[8.4921875, 28],
// 					[5.50390625, 30.4921875],
// 					[-0.5078125, 32.4765625],
// 					[-7.50390625, 33.9765625],
// 					[-14.02734375, 33.9765625],
// 					[-18, 32.984375],
// 					[-19.4921875, 31.484375],
// 					[-18, 28.9921875],
// 					[-16.50390625, 28],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.0784313753247261, 0.1921568661928177,
// 					0.20392157137393951, 0.2235294133424759, 0.23529411852359772, 0.250980406999588,
// 					0.2666666805744171, 0.2862745225429535, 0.30588236451148987, 0.3176470696926117,
// 					0.34117648005485535, 0.3529411852359772, 0.3529411852359772, 0.3529411852359772,
// 					0.32156863808631897, 0.2666666805744171, 0.1921568661928177,
// 					0.07450980693101883, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-16.50390625, 28],
// 			},
// 		],
// 		t: [
// 			{
// 				id: "BP_t_6lcCULzWw79UF8YM",
// 				type: "freedraw",
// 				x: 268.10546875,
// 				y: 129.00390625,
// 				width: 43.03515625,
// 				height: 3.484375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 484850625,
// 				version: 16,
// 				versionNonce: 2000762511,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810246173,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.49609375, 0],
// 					[2.00390625, 0],
// 					[3.5, 0.48046875],
// 					[4.0078125, 0.98828125],
// 					[2.00390625, 0.98828125],
// 					[-3.49609375, 0.98828125],
// 					[-13.0078125, 0.98828125],
// 					[-24.01171875, 1.5],
// 					[-32.5, 1.5],
// 					[-37.4921875, 2.4921875],
// 					[-39.02734375, 3.484375],
// 					[-38.515625, 3.484375],
// 					[-37.4921875, 3.00390625],
// 					[-36.51171875, 2.4921875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.125490203499794, 0.16078431904315948,
// 					0.125490203499794, 0.18431372940540314, 0.250980406999588, 0.2705882489681244,
// 					0.250980406999588, 0.22745098173618317, 0.16078431904315948,
// 					0.08235294371843338, 0.01568627543747425, 0.003921568859368563, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-36.51171875, 2.4921875],
// 			},
// 			{
// 				id: "FrsQM1r4wbRvVpPWojAZF",
// 				type: "freedraw",
// 				x: 244.60546875,
// 				y: 122.484375,
// 				width: 24.99609375,
// 				height: 62.515625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 932583873,
// 				version: 16,
// 				versionNonce: 1312471183,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810246468,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.4921875, 0],
// 					[2.984375, 0],
// 					[4.0078125, 3.00390625],
// 					[4.0078125, 12.52734375],
// 					[2.4765625, 26.5234375],
// 					[1.4921875, 41.515625],
// 					[2.00390625, 53.01953125],
// 					[4.48046875, 59.5078125],
// 					[7.9765625, 62.515625],
// 					[11.984375, 62.515625],
// 					[16.9765625, 61.01171875],
// 					[20.984375, 59.5078125],
// 					[24.484375, 58.51953125],
// 					[24.99609375, 58.51953125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.13333334028720856,
// 					0.18039216101169586, 0.22745098173618317, 0.250980406999588, 0.2823529541492462,
// 					0.3137255012989044, 0.3294117748737335, 0.33725491166114807, 0.3333333432674408,
// 					0.29019609093666077, 0.2078431397676468, 0.062745101749897, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [24.99609375, 58.51953125],
// 			},
// 		],
// 		u: [
// 			{
// 				id: "XE46EQUbSe1ldf8OZB7mS",
// 				type: "freedraw",
// 				x: 238.58984375,
// 				y: 148.49609375,
// 				width: 38.98828125,
// 				height: 45.99609375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 734208207,
// 				version: 25,
// 				versionNonce: 988759233,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810248736,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.51171875, 0.99609375],
// 					[0, 5.49609375],
// 					[-2.4765625, 14.51171875],
// 					[-3.49609375, 24.99609375],
// 					[-2.984375, 33.49609375],
// 					[0.51171875, 38.99609375],
// 					[4.51953125, 42],
// 					[8.01953125, 42.5078125],
// 					[12.02734375, 38.99609375],
// 					[16.5078125, 31.00390625],
// 					[20.515625, 21],
// 					[22.51953125, 12.49609375],
// 					[22.51953125, 10.48828125],
// 					[22.51953125, 11.5078125],
// 					[22.51953125, 16.4921875],
// 					[22.9921875, 24.515625],
// 					[24.5234375, 32.98828125],
// 					[26.4921875, 41.00390625],
// 					[28.49609375, 45],
// 					[31.01171875, 45.99609375],
// 					[32.50390625, 45.51171875],
// 					[34.5078125, 44.4921875],
// 					[35.4921875, 44.0078125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.125490203499794, 0.15294118225574493,
// 					0.1764705926179886, 0.20392157137393951, 0.2235294133424759,
// 					0.22745098173618317, 0.23529411852359772, 0.24313725531101227,
// 					0.23137255012989044, 0.21960784494876862, 0.21176470816135406,
// 					0.2078431397676468, 0.239215686917305, 0.27843138575553894, 0.3019607961177826,
// 					0.32156863808631897, 0.3333333432674408, 0.3176470696926117, 0.2666666805744171,
// 					0.2078431397676468, 0.09019608050584793, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [35.4921875, 44.0078125],
// 			},
// 		],
// 		v: [
// 			{
// 				id: "Ih1XlEFEzCbQtcrM4nkWI",
// 				type: "freedraw",
// 				x: 266.61328125,
// 				y: 149.0078125,
// 				width: 31.9921875,
// 				height: 42.0234375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1633929345,
// 				version: 22,
// 				versionNonce: 428818063,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810250458,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.47265625, -1.01953125],
// 					[0.98046875, -1.50390625],
// 					[1.4921875, -1.50390625],
// 					[0.98046875, 0],
// 					[-1.53125, 3.99609375],
// 					[-7.5078125, 15.98046875],
// 					[-11.00390625, 24.484375],
// 					[-15.01171875, 35.48046875],
// 					[-15.99609375, 38],
// 					[-18.51171875, 35.9921875],
// 					[-20.515625, 32.4765625],
// 					[-23.50390625, 24.484375],
// 					[-27, 13.48828125],
// 					[-29.515625, 3.99609375],
// 					[-30.02734375, 0.484375],
// 					[-30.5, -3.51171875],
// 					[-30.5, -4.0234375],
// 					[-30.5, -3.00390625],
// 					[-29.515625, -0.51171875],
// 					[-28.53125, 0.484375],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.062745101749897, 0.14509804546833038,
// 					0.19607843458652496, 0.2235294133424759, 0.239215686917305, 0.250980406999588,
// 					0.250980406999588, 0.26274511218070984, 0.27843138575553894, 0.2666666805744171,
// 					0.26274511218070984, 0.24705882370471954, 0.24705882370471954,
// 					0.24313725531101227, 0.239215686917305, 0.21960784494876862,
// 					0.20000000298023224, 0.13725490868091583, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-28.53125, 0.484375],
// 			},
// 		],
// 		w: [
// 			{
// 				id: "BdsBYh2PfwStCxv8rtfwd",
// 				type: "freedraw",
// 				x: 275.1015625,
// 				y: 157,
// 				width: 46.49609375,
// 				height: 42.5078125,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 607004367,
// 				version: 39,
// 				versionNonce: 785271041,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810252410,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.51171875, -0.9921875],
// 					[0.51171875, -2.01171875],
// 					[0.984375, -4.5078125],
// 					[0.984375, -5.5],
// 					[0.51171875, -5.015625],
// 					[-2.515625, 0],
// 					[-4.9921875, 5.49609375],
// 					[-8.015625, 14],
// 					[-10.4921875, 25.50390625],
// 					[-11.515625, 30.0078125],
// 					[-11.98828125, 31.9921875],
// 					[-12.49609375, 31.00390625],
// 					[-13.51953125, 27.0078125],
// 					[-15.01171875, 21],
// 					[-16.5078125, 14.5078125],
// 					[-17.48828125, 8.5],
// 					[-18, 5.49609375],
// 					[-18, 4.50390625],
// 					[-19.01953125, 6.0078125],
// 					[-21.49609375, 10.9921875],
// 					[-24.01171875, 16.4921875],
// 					[-26.48828125, 24.00390625],
// 					[-28.4921875, 31.00390625],
// 					[-29.98828125, 35.98828125],
// 					[-30.49609375, 37.0078125],
// 					[-31.51953125, 35.50390625],
// 					[-33.99609375, 28.98828125],
// 					[-36, 21.5078125],
// 					[-39.49609375, 10.9921875],
// 					[-40.9921875, 6.0078125],
// 					[-42.01171875, 3.00390625],
// 					[-42.484375, 0.98828125],
// 					[-43.5078125, -0.9921875],
// 					[-44.015625, -2.49609375],
// 					[-45, -3.51171875],
// 					[-45, -3.99609375],
// 					[-45.51171875, -3.99609375],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.0784313753247261, 0.11372549086809158,
// 					0.1411764770746231, 0.19607843458652496, 0.21960784494876862,
// 					0.21960784494876862, 0.21568627655506134, 0.22745098173618317,
// 					0.23529411852359772, 0.25882354378700256, 0.25882354378700256,
// 					0.24705882370471954, 0.239215686917305, 0.22745098173618317,
// 					0.21960784494876862, 0.2235294133424759, 0.22745098173618317,
// 					0.23529411852359772, 0.26274511218070984, 0.2705882489681244,
// 					0.2705882489681244, 0.2862745225429535, 0.29411765933036804,
// 					0.30980393290519714, 0.3019607961177826, 0.2980392277240753,
// 					0.29411765933036804, 0.2980392277240753, 0.3019607961177826, 0.3019607961177826,
// 					0.2980392277240753, 0.2862745225429535, 0.25882354378700256, 0.2235294133424759,
// 					0.1411764770746231, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-45.51171875, -3.99609375],
// 			},
// 		],
// 		x: [
// 			{
// 				id: "bNLmpUrFtqvz7IJStxZ7t",
// 				type: "freedraw",
// 				x: 267.0859375,
// 				y: 150.5078125,
// 				width: 36.984375,
// 				height: 30.49609375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1073659073,
// 				version: 12,
// 				versionNonce: 593331471,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810253794,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[2.00390625, 0],
// 					[-1.49609375, 1.984375],
// 					[-12.97265625, 9.49609375],
// 					[-20.98828125, 14.9921875],
// 					[-28.49609375, 21],
// 					[-33.484375, 25.98828125],
// 					[-34.98046875, 29.984375],
// 					[-34.98046875, 30.49609375],
// 					[-32.9765625, 30.49609375],
// 					[-27.984375, 29.984375],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.05882352963089943, 0.18039216101169586,
// 					0.2078431397676468, 0.2235294133424759, 0.2235294133424759, 0.20392157137393951,
// 					0.1725490242242813, 0.14509804546833038, 0.0784313753247261, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-27.984375, 29.984375],
// 			},
// 			{
// 				id: "x6CNzau4n_A8VSWkrYE_i",
// 				type: "freedraw",
// 				x: 262.09375,
// 				y: 187.0078125,
// 				width: 23.02734375,
// 				height: 44.515625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 2081735489,
// 				version: 12,
// 				versionNonce: 2006795919,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810254062,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.01953125, -1.01953125],
// 					[1.01953125, -1.50390625],
// 					[0, -5.5234375],
// 					[-5.50390625, -15.01953125],
// 					[-13.9921875, -29.01953125],
// 					[-17.48828125, -35.5078125],
// 					[-20.00390625, -40.0078125],
// 					[-21.5, -42.5078125],
// 					[-22.0078125, -44.515625],
// 					[-22.0078125, -44.515625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.13333334028720856, 0.1411764770746231, 0.1725490242242813,
// 					0.23137255012989044, 0.27843138575553894, 0.27450981736183167,
// 					0.23529411852359772, 0.1921568661928177, 0.09803921729326248, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-22.0078125, -44.515625],
// 			},
// 		],
// 		y: [
// 			{
// 				id: "ua-hAvJn_Q4Us1DcVPGR0",
// 				type: "freedraw",
// 				x: 245.11328125,
// 				y: 155.49609375,
// 				width: 25.50390625,
// 				height: 83.00390625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1280978639,
// 				version: 25,
// 				versionNonce: 800347841,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810255721,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.47265625, -0.9921875],
// 					[0.984375, -1.50390625],
// 					[1.49609375, -3.00390625],
// 					[-0.5078125, -0.5078125],
// 					[-3.49609375, 7],
// 					[-5.02734375, 16.01171875],
// 					[-3.0234375, 27.48828125],
// 					[0.47265625, 30.4921875],
// 					[5.9765625, 28],
// 					[11.98828125, 20.0078125],
// 					[17.4921875, 10.99609375],
// 					[19.96875, 7],
// 					[20.4765625, 7.51171875],
// 					[19.96875, 14],
// 					[16.98046875, 26.49609375],
// 					[12.5, 41.99609375],
// 					[9, 56.98828125],
// 					[7.98046875, 63.5078125],
// 					[5.50390625, 76.51171875],
// 					[4.9921875, 79.48828125],
// 					[4.48046875, 80],
// 					[4.48046875, 79.48828125],
// 					[4.9921875, 79.48828125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.0941176488995552, 0.12941177189350128,
// 					0.23529411852359772, 0.250980406999588, 0.2666666805744171, 0.29019609093666077,
// 					0.2980392277240753, 0.3019607961177826, 0.29019609093666077, 0.2666666805744171,
// 					0.250980406999588, 0.2666666805744171, 0.29411765933036804, 0.3019607961177826,
// 					0.3137255012989044, 0.32549020648002625, 0.3294117748737335, 0.3450980484485626,
// 					0.3294117748737335, 0.29019609093666077, 0.16862745583057404, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [4.9921875, 79.48828125],
// 			},
// 		],
// 		z: [
// 			{
// 				id: "Dyh5tCj3chBdBXQDyvroi",
// 				type: "freedraw",
// 				x: 232.10546875,
// 				y: 143.484375,
// 				width: 47.515625,
// 				height: 38,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1905023617,
// 				version: 23,
// 				versionNonce: 271803055,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751810257619,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.49609375, 0],
// 					[4.0078125, 0.5078125],
// 					[9.984375, 1.015625],
// 					[18, 2.51953125],
// 					[22.9921875, 5.01171875],
// 					[24.99609375, 8.015625],
// 					[24.99609375, 10.5078125],
// 					[20.4765625, 15.015625],
// 					[15.99609375, 18.01953125],
// 					[11.00390625, 21.50390625],
// 					[4.0078125, 25.5],
// 					[0.984375, 28.0234375],
// 					[-1.01953125, 31],
// 					[-1.01953125, 33.01171875],
// 					[1.49609375, 35.0234375],
// 					[7.5078125, 37.0078125],
// 					[24.484375, 38],
// 					[28.49609375, 37.51953125],
// 					[46.49609375, 35.0234375],
// 					[45.984375, 35.50390625],
// 					[45.47265625, 36.015625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.2235294133424759, 0.250980406999588, 0.27843138575553894,
// 					0.29411765933036804, 0.3019607961177826, 0.30980393290519714,
// 					0.2980392277240753, 0.2980392277240753, 0.27843138575553894, 0.2666666805744171,
// 					0.26274511218070984, 0.2666666805744171, 0.27450981736183167,
// 					0.29411765933036804, 0.30588236451148987, 0.33725491166114807,
// 					0.3686274588108063, 0.37254902720451355, 0.2078431397676468,
// 					0.054901961237192154, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [45.47265625, 36.015625],
// 			},
// 		],
// 	},
// 	...{
// 		à: [
// 			{
// 				id: "puFXOT1_yKdXowAX4CJp8",
// 				type: "freedraw",
// 				x: 447.71484375,
// 				y: 282.5,
// 				width: 44.48828125,
// 				height: 37.4921875,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1518987847,
// 				version: 30,
// 				versionNonce: 642710057,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213068631,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.49609375, 0],
// 					[3.97265625, 0.48046875],
// 					[6.48828125, -0.51171875],
// 					[8.4921875, -3.00390625],
// 					[10.96875, -9.4921875],
// 					[10.96875, -15.5],
// 					[9.47265625, -19.01171875],
// 					[3.5, -21],
// 					[-1.53125, -19.49609375],
// 					[-11.00390625, -11.5078125],
// 					[-14.02734375, -7],
// 					[-15.01171875, -3.00390625],
// 					[-13.51953125, 2.4921875],
// 					[-7.03125, 7],
// 					[-2.00390625, 7.51171875],
// 					[3.5, 4.5078125],
// 					[8.4921875, -2.01171875],
// 					[11.4765625, -7.9921875],
// 					[11.98828125, -10.515625],
// 					[11.98828125, -6.51953125],
// 					[13.48046875, -2.01171875],
// 					[16.98046875, 4.98828125],
// 					[21.50390625, 11.98828125],
// 					[25.46875, 15.984375],
// 					[28.5, 16.4921875],
// 					[29.4765625, 15.50390625],
// 					[28.5, 12.5],
// 					[27.47265625, 11.5078125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.11372549086809158,
// 					0.14901961386203766, 0.16470588743686676, 0.1725490242242813,
// 					0.16862745583057404, 0.16470588743686676, 0.15294118225574493,
// 					0.15294118225574493, 0.15294118225574493, 0.15294118225574493,
// 					0.1568627506494522, 0.16078431904315948, 0.20392157137393951,
// 					0.21176470816135406, 0.1921568661928177, 0.18431372940540314,
// 					0.1725490242242813, 0.1725490242242813, 0.22745098173618317, 0.239215686917305,
// 					0.25882354378700256, 0.2823529541492462, 0.2549019753932953,
// 					0.21176470816135406, 0.1411764770746231, 0.04313725605607033, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [27.47265625, 11.5078125],
// 			},
// 			{
// 				id: "FzMAa8km_kxbpB9XERXeN",
// 				type: "freedraw",
// 				x: 451.6875,
// 				y: 233.50390625,
// 				width: 16.50390625,
// 				height: 12.5,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 2144740359,
// 				version: 11,
// 				versionNonce: 2017641929,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213068990,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[2.515625, 1.50390625],
// 					[4.0078125, 1.984375],
// 					[7.50390625, 3.99609375],
// 					[11.00390625, 7],
// 					[13.51953125, 9.49609375],
// 					[15.5234375, 11.5078125],
// 					[15.5234375, 11.98828125],
// 					[16.50390625, 12.5],
// 					[16.50390625, 12.5],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.10588235408067703, 0.125490203499794,
// 					0.18431372940540314, 0.19607843458652496, 0.16862745583057404,
// 					0.15294118225574493, 0.14901961386203766, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [16.50390625, 12.5],
// 			},
// 		],
// 		è: [
// 			{
// 				id: "S71ZBDRxMPYFW6emsXuvH",
// 				type: "freedraw",
// 				x: 433.21484375,
// 				y: 272.49609375,
// 				width: 36.5078125,
// 				height: 34.484375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1241556873,
// 				version: 24,
// 				versionNonce: 1194209863,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213070881,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[2.00390625, 0.51171875],
// 					[5.5, 1.50390625],
// 					[8.48828125, 1.50390625],
// 					[13.9921875, 1.50390625],
// 					[19.4921875, 0],
// 					[25.46875, -3.99609375],
// 					[27.98046875, -8.49609375],
// 					[27.98046875, -12.01171875],
// 					[24.484375, -14.5078125],
// 					[18.47265625, -15.49609375],
// 					[9.47265625, -12.01171875],
// 					[4.48046875, -8.49609375],
// 					[-0.51171875, -2.4921875],
// 					[-1.53125, 4.5078125],
// 					[3.49609375, 10.99609375],
// 					[10.96484375, 16.4921875],
// 					[18, 18.98828125],
// 					[25.46875, 17.99609375],
// 					[32.50390625, 14.51171875],
// 					[34.46875, 13.0078125],
// 					[34.9765625, 11.5078125],
// 					[34.9765625, 10.99609375],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.05882352963089943, 0.09019608050584793,
// 					0.13725490868091583, 0.16862745583057404, 0.20392157137393951,
// 					0.21960784494876862, 0.2235294133424759, 0.21960784494876862,
// 					0.1921568661928177, 0.16078431904315948, 0.14509804546833038,
// 					0.13725490868091583, 0.13725490868091583, 0.16862745583057404,
// 					0.1921568661928177, 0.23137255012989044, 0.26274511218070984,
// 					0.24705882370471954, 0.21176470816135406, 0.1725490242242813,
// 					0.05098039284348488, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [34.9765625, 10.99609375],
// 			},
// 			{
// 				id: "DXnlP3Qs4naQU5QtlsRTf",
// 				type: "freedraw",
// 				x: 459.19140625,
// 				y: 232.9921875,
// 				width: 16.51171875,
// 				height: 17.99609375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1031216265,
// 				version: 10,
// 				versionNonce: 1028871559,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213071264,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[2.00390625, 2.015625],
// 					[4.01171875, 4.5078125],
// 					[7.5078125, 7.9921875],
// 					[10.49609375, 12.5],
// 					[13.5234375, 16.015625],
// 					[15.01953125, 17.515625],
// 					[16.51171875, 17.99609375],
// 					[16.51171875, 17.99609375],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0941176488995552, 0.09019608050584793,
// 					0.11764705926179886, 0.1725490242242813, 0.1882352977991104, 0.1725490242242813,
// 					0.10588235408067703, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [16.51171875, 17.99609375],
// 			},
// 		],
// 		é: [
// 			{
// 				id: "6M7Npl9Iy5E20Difj7Fxt",
// 				type: "freedraw",
// 				x: 443.1953125,
// 				y: 277.9921875,
// 				width: 33.015625,
// 				height: 28.5078125,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1034084295,
// 				version: 23,
// 				versionNonce: 1795012745,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213073257,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.49609375, -0.98828125],
// 					[4.51953125, -2.01171875],
// 					[8.4921875, -4.50390625],
// 					[12.5, -8.5],
// 					[13.9921875, -13.48828125],
// 					[13.01171875, -16.0078125],
// 					[8.4921875, -17],
// 					[2.515625, -16.0078125],
// 					[-4.0078125, -11.984375],
// 					[-9, -6.48828125],
// 					[-10.4921875, -0.98828125],
// 					[-7.9765625, 4.5078125],
// 					[-2.00390625, 7.9921875],
// 					[4.51953125, 10.99609375],
// 					[10.49609375, 11.5078125],
// 					[17.4921875, 10.0078125],
// 					[20.98828125, 7.51171875],
// 					[22.5234375, 6.4921875],
// 					[22.5234375, 5.5],
// 					[22.5234375, 4.98828125],
// 					[22.5234375, 4.5078125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.18039216101169586, 0.20000000298023224,
// 					0.2078431397676468, 0.19607843458652496, 0.19607843458652496,
// 					0.18039216101169586, 0.16470588743686676, 0.16470588743686676,
// 					0.1725490242242813, 0.1764705926179886, 0.19607843458652496,
// 					0.21960784494876862, 0.239215686917305, 0.2549019753932953, 0.2666666805744171,
// 					0.25882354378700256, 0.21960784494876862, 0.16078431904315948,
// 					0.05098039284348488, 0.01568627543747425, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [22.5234375, 4.5078125],
// 			},
// 			{
// 				id: "NYhK2QSbn_vQJtsVJn2lP",
// 				type: "freedraw",
// 				x: 455.18359375,
// 				y: 237.5,
// 				width: 20.00390625,
// 				height: 13.48828125,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1497696167,
// 				version: 11,
// 				versionNonce: 347160617,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213073797,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.0234375, 0.48046875],
// 					[-0.47265625, 1.50390625],
// 					[-4.48046875, 3.99609375],
// 					[-9.47265625, 7.51171875],
// 					[-14.5, 10.484375],
// 					[-17.48828125, 12.5],
// 					[-18.98046875, 13.48828125],
// 					[-18, 13.48828125],
// 					[-17.48828125, 13.0078125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.09019608050584793, 0.11372549086809158,
// 					0.1411764770746231, 0.15294118225574493, 0.14901961386203766,
// 					0.12941177189350128, 0.11372549086809158, 0.04313725605607033, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-17.48828125, 13.0078125],
// 			},
// 		],
// 		ì: [
// 			{
// 				id: "rGLsPEOi0DwW4XLHzYfch",
// 				type: "freedraw",
// 				x: 449.68359375,
// 				y: 259.4921875,
// 				width: 2.00390625,
// 				height: 38,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 773589481,
// 				version: 16,
// 				versionNonce: 1206568167,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213075716,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, -1.50390625],
// 					[0, -2.4921875],
// 					[0.5078125, -3.484375],
// 					[0.5078125, -3.00390625],
// 					[-0.47265625, 0.9921875],
// 					[-0.984375, 8.5],
// 					[-0.984375, 17.51171875],
// 					[-0.984375, 27.00390625],
// 					[-0.47265625, 33.4921875],
// 					[0, 34.515625],
// 					[0, 32.5],
// 					[-0.984375, 27.515625],
// 					[-0.984375, 26.4921875],
// 					[-1.49609375, 24.9921875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.07058823853731155,
// 					0.08627451211214066, 0.15294118225574493, 0.1764705926179886,
// 					0.1764705926179886, 0.1725490242242813, 0.1764705926179886, 0.1764705926179886,
// 					0.1725490242242813, 0.11764705926179886, 0.03921568766236305,
// 					0.01568627543747425, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-1.49609375, 24.9921875],
// 			},
// 			{
// 				id: "Q_SjXdKErVwx6HJLE6Dox",
// 				type: "freedraw",
// 				x: 443.1953125,
// 				y: 234.49609375,
// 				width: 15.015625,
// 				height: 15.50390625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 810981353,
// 				version: 11,
// 				versionNonce: 1515094855,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213076131,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.984375, 0.51171875],
// 					[2.0078125, 0.9921875],
// 					[4.51953125, 4.5078125],
// 					[6.015625, 6.0078125],
// 					[11.0078125, 10.99609375],
// 					[13.51953125, 13.48828125],
// 					[14.50390625, 14.9921875],
// 					[15.015625, 15.50390625],
// 					[15.015625, 15.50390625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.05882352963089943, 0.0941176488995552, 0.1568627506494522,
// 					0.16862745583057404, 0.18039216101169586, 0.18039216101169586,
// 					0.13725490868091583, 0.054901961237192154, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [15.015625, 15.50390625],
// 			},
// 		],
// 		ò: [
// 			{
// 				id: "ztzeJQ7MTtg4N2A39IsCH",
// 				type: "freedraw",
// 				x: 455.6953125,
// 				y: 281.98828125,
// 				width: 27.984375,
// 				height: 27.484375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 545103239,
// 				version: 25,
// 				versionNonce: 1035661449,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213078334,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.4921875, 0.51171875],
// 					[2.98828125, 0.51171875],
// 					[4.9921875, 0.51171875],
// 					[7.5078125, 0],
// 					[9.51171875, -3.00390625],
// 					[10.4921875, -4.50390625],
// 					[11.00390625, -11.984375],
// 					[9, -15.98046875],
// 					[6.484375, -17.484375],
// 					[-0.51171875, -17.98828125],
// 					[-11.98828125, -13.99609375],
// 					[-15.99609375, -8.98046875],
// 					[-16.98046875, -3.99609375],
// 					[-14.50390625, 2.015625],
// 					[-9.51171875, 7.51171875],
// 					[-3.5, 9.49609375],
// 					[2.98828125, 9.015625],
// 					[8.48828125, 3.99609375],
// 					[10.0234375, -0.98828125],
// 					[9.51171875, -5.49609375],
// 					[7.5078125, -7.48046875],
// 					[5.5, -7.98828125],
// 					[4.51953125, -7.98828125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.07058823853731155, 0.062745101749897, 0.0941176488995552,
// 					0.125490203499794, 0.14509804546833038, 0.15294118225574493,
// 					0.16470588743686676, 0.1568627506494522, 0.1568627506494522,
// 					0.16078431904315948, 0.1568627506494522, 0.1568627506494522, 0.1725490242242813,
// 					0.1882352977991104, 0.21176470816135406, 0.22745098173618317, 0.239215686917305,
// 					0.23529411852359772, 0.2235294133424759, 0.16862745583057404,
// 					0.09019608050584793, 0.0313725508749485, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [4.51953125, -7.98828125],
// 			},
// 			{
// 				id: "V7vw94_Fgc7i285lmnLA0",
// 				type: "freedraw",
// 				x: 448.69921875,
// 				y: 237.98046875,
// 				width: 19.4921875,
// 				height: 14.51171875,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1150177191,
// 				version: 11,
// 				versionNonce: 1327593513,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213078677,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.4921875, 1.50390625],
// 					[2.515625, 2.5234375],
// 					[4.9921875, 4.5078125],
// 					[8.48828125, 7.51171875],
// 					[12.49609375, 11.02734375],
// 					[15.484375, 13.0078125],
// 					[18, 14.03125],
// 					[18.984375, 14.51171875],
// 					[19.4921875, 14.51171875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.0784313753247261, 0.1411764770746231,
// 					0.16078431904315948, 0.1725490242242813, 0.1725490242242813,
// 					0.13333334028720856, 0.09019608050584793, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [19.4921875, 14.51171875],
// 			},
// 		],
// 		ù: [
// 			{
// 				id: "ROSxBgMuUNWj32z79GGGI",
// 				type: "freedraw",
// 				x: 444.1796875,
// 				y: 256.48828125,
// 				width: 38.4765625,
// 				height: 38,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1138639337,
// 				version: 24,
// 				versionNonce: 506557927,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213080627,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.0234375, 2.51953125],
// 					[0, 7.51171875],
// 					[-1.96484375, 16.0078125],
// 					[-2.4765625, 24],
// 					[-1.96484375, 30.51953125],
// 					[1.0234375, 34.00390625],
// 					[4.0078125, 34.515625],
// 					[7.5078125, 31],
// 					[12.02734375, 25.01953125],
// 					[15.5234375, 18.01953125],
// 					[18, 13.515625],
// 					[18.51171875, 13.00390625],
// 					[18.51171875, 15.49609375],
// 					[19.0234375, 20.515625],
// 					[21.02734375, 26.01171875],
// 					[24.01171875, 32.01953125],
// 					[27.51171875, 36.49609375],
// 					[31.0078125, 38],
// 					[34.5078125, 38],
// 					[36, 36.015625],
// 					[36, 34.00390625],
// 					[36, 33.01171875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.10980392247438431, 0.13333334028720856,
// 					0.13333334028720856, 0.15294118225574493, 0.1725490242242813,
// 					0.1921568661928177, 0.2078431397676468, 0.20000000298023224,
// 					0.18431372940540314, 0.16862745583057404, 0.16078431904315948,
// 					0.16078431904315948, 0.20000000298023224, 0.23137255012989044,
// 					0.24313725531101227, 0.2549019753932953, 0.24313725531101227,
// 					0.22745098173618317, 0.1764705926179886, 0.0784313753247261, 0.0117647061124444,
// 					0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [36, 33.01171875],
// 			},
// 			{
// 				id: "7viXVEOuJw03Dty9FN4H1",
// 				type: "freedraw",
// 				x: 453.1796875,
// 				y: 241.49609375,
// 				width: 19.53515625,
// 				height: 16.4921875,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1197184745,
// 				version: 9,
// 				versionNonce: 135358983,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213080959,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[2.515625, 0.9921875],
// 					[6.01171875, 3.515625],
// 					[10.53125, 7],
// 					[14.03125, 10.515625],
// 					[16.5078125, 13.48828125],
// 					[19.0234375, 16.4921875],
// 					[19.53515625, 16.4921875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0313725508749485, 0.003921568859368563,
// 					0.027450980618596077, 0.054901961237192154, 0.06666667014360428,
// 					0.04313725605607033, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [19.53515625, 16.4921875],
// 			},
// 		],
// 		",": [
// 			{
// 				id: "58760V3X929dWc7E4zhkz",
// 				type: "freedraw",
// 				x: 450.703125,
// 				y: 281.5078125,
// 				width: 13.48046875,
// 				height: 28.98828125,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1792595497,
// 				version: 9,
// 				versionNonce: 1441633991,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213107461,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.984375, 0.48046875],
// 					[0.984375, 2.49609375],
// 					[-2.00390625, 9.49609375],
// 					[-6.5234375, 18.98828125],
// 					[-9, 23.9765625],
// 					[-11.98828125, 28.48046875],
// 					[-12.49609375, 28.98828125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0941176488995552, 0.13725490868091583, 0.1764705926179886,
// 					0.18431372940540314, 0.16078431904315948, 0.09019608050584793, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-12.49609375, 28.98828125],
// 			},
// 		],
// 		".": [
// 			{
// 				id: "xu9t6k9_bOUNeHTmebC0L",
// 				type: "freedraw",
// 				x: 447.20703125,
// 				y: 281,
// 				width: 1.4921875,
// 				height: 0.5078125,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1863176455,
// 				version: 7,
// 				versionNonce: 316568905,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213109428,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.98046875, 0.5078125],
// 					[1.4921875, 0.5078125],
// 					[0.98046875, 0.5078125],
// 					[0, 0],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.20392157137393951, 0.2980392277240753,
// 					0.11372549086809158, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [0.98046875, 0],
// 			},
// 		],
// 		";": [
// 			{
// 				id: "HyQxdixA-4QsIAREIIPpk",
// 				type: "freedraw",
// 				x: 443.70703125,
// 				y: 259.4921875,
// 				width: 2.00390625,
// 				height: 0.9921875,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 504788745,
// 				version: 7,
// 				versionNonce: 2088957351,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213110981,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.49609375, 0],
// 					[2.00390625, -0.484375],
// 					[2.00390625, -0.9921875],
// 					[0, 0],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.08235294371843338,
// 					0.019607843831181526, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [2.00390625, -0.9921875],
// 			},
// 			{
// 				id: "oRcLodQR-1U22q5dIBpLh",
// 				type: "freedraw",
// 				x: 440.68359375,
// 				y: 282.98046875,
// 				width: 9,
// 				height: 29.52734375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 503147305,
// 				version: 9,
// 				versionNonce: 1103704519,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213111164,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.5078125, 5.52734375],
// 					[0.5078125, 7.03125],
// 					[-0.984375, 13.51953125],
// 					[-4.9921875, 23.01171875],
// 					[-6.99609375, 27.0078125],
// 					[-7.46875, 28.02734375],
// 					[-8.4921875, 29.52734375],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.08235294371843338, 0.09019608050584793,
// 					0.13725490868091583, 0.12941177189350128, 0.10588235408067703,
// 					0.05882352963089943, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-8.4921875, 29.52734375],
// 			},
// 		],
// 		":": [
// 			{
// 				id: "dewc8HDvnFrI0xFXKgYE6",
// 				type: "freedraw",
// 				x: 447.20703125,
// 				y: 253.9921875,
// 				width: 0.98046875,
// 				height: 1.50390625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1727966215,
// 				version: 7,
// 				versionNonce: 1688709705,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213112787,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.5078125, 0.9921875],
// 					[0.5078125, 1.50390625],
// 					[0.98046875, 1.50390625],
// 					[0, 0],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.03921568766236305,
// 					0.019607843831181526, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [0.5078125, 2.015625],
// 			},
// 			{
// 				id: "7zbE8GcyFFt0Z9eSbOWmi",
// 				type: "freedraw",
// 				x: 447.71484375,
// 				y: 281.5078125,
// 				width: 1.96875,
// 				height: 1.47265625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 635488743,
// 				version: 7,
// 				versionNonce: 683984489,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213112964,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.984375, 0.48046875],
// 					[1.49609375, 1.47265625],
// 					[1.96875, 1.47265625],
// 					[0, 0],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.09803921729326248, 0.10196078568696976,
// 					0.0313725508749485, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [1.96875, 0.9921875],
// 			},
// 		],
// 		"!": [
// 			{
// 				id: "88b7pNJlcveNx5D9cpxc2",
// 				type: "freedraw",
// 				x: 454.203125,
// 				y: 221.4921875,
// 				width: 4.0078125,
// 				height: 53.015625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1731395625,
// 				version: 14,
// 				versionNonce: 2089283687,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213114622,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[2.00390625, 0],
// 					[2.51171875, 0],
// 					[3.49609375, 0],
// 					[4.0078125, 2.0078125],
// 					[2.984375, 9.4921875],
// 					[1.4921875, 16.48828125],
// 					[0, 28.5078125],
// 					[0, 40.4921875],
// 					[0, 47.4921875],
// 					[0.5078125, 51.515625],
// 					[0.5078125, 52.5078125],
// 					[0, 53.015625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.08235294371843338, 0.08235294371843338,
// 					0.0941176488995552, 0.125490203499794, 0.1568627506494522, 0.16470588743686676,
// 					0.18039216101169586, 0.1764705926179886, 0.16470588743686676, 0.125490203499794,
// 					0.10588235408067703, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [0, 53.015625],
// 			},
// 			{
// 				id: "cj4ehU3JZHGSi6RdwOc-y",
// 				type: "freedraw",
// 				x: 450.703125,
// 				y: 291.00390625,
// 				width: 2.00390625,
// 				height: 5.49609375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 599151721,
// 				version: 12,
// 				versionNonce: 443837927,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213114922,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.984375, 2.4921875],
// 					[1.4921875, 3.99609375],
// 					[1.4921875, 4.984375],
// 					[2.00390625, 5.49609375],
// 					[2.00390625, 4.984375],
// 					[1.4921875, 3.484375],
// 					[1.4921875, 2.4921875],
// 					[0.984375, 1.98046875],
// 					[0, 0],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.0941176488995552, 0.14509804546833038,
// 					0.1882352977991104, 0.20392157137393951, 0.20000000298023224,
// 					0.15294118225574493, 0.07450980693101883, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [0.984375, 1.5],
// 			},
// 		],
// 		"?": [
// 			{
// 				id: "eBjThIBWrqa5xB4N58BXj",
// 				type: "freedraw",
// 				x: 441.19140625,
// 				y: 221.0078125,
// 				width: 20.515625,
// 				height: 65.515625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 820076583,
// 				version: 23,
// 				versionNonce: 802236969,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213116614,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0, -1.01953125],
// 					[0, -2.51953125],
// 					[0.51171875, -4.5078125],
// 					[2.515625, -7],
// 					[6.5234375, -8.01953125],
// 					[11.98828125, -6.515625],
// 					[16.5078125, -2.51953125],
// 					[20.515625, 5.98046875],
// 					[20.00390625, 14.48046875],
// 					[15.99609375, 21.9921875],
// 					[11.98828125, 28],
// 					[9, 33.9765625],
// 					[6.99609375, 39.984375],
// 					[6.99609375, 45.9921875],
// 					[6.99609375, 50.9765625],
// 					[7.5078125, 54.97265625],
// 					[8.4921875, 56.4765625],
// 					[9.51171875, 56.984375],
// 					[10.0234375, 56.984375],
// 					[10.49609375, 56.984375],
// 					[10.49609375, 57.49609375],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.09803921729326248, 0.13725490868091583,
// 					0.1725490242242813, 0.20392157137393951, 0.21176470816135406,
// 					0.2078431397676468, 0.21568627655506134, 0.23529411852359772,
// 					0.25882354378700256, 0.25882354378700256, 0.25882354378700256,
// 					0.25882354378700256, 0.24705882370471954, 0.25882354378700256,
// 					0.27450981736183167, 0.29019609093666077, 0.26274511218070984,
// 					0.22745098173618317, 0.16470588743686676, 0.06666667014360428, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [10.49609375, 57.49609375],
// 			},
// 			{
// 				id: "0bsOUIsueR_L-c03Xpi26",
// 				type: "freedraw",
// 				x: 450.19140625,
// 				y: 294.48828125,
// 				width: 2.00390625,
// 				height: 1.01953125,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 859108359,
// 				version: 7,
// 				versionNonce: 1970725449,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213116823,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.0234375, 0.51171875],
// 					[1.49609375, 1.01953125],
// 					[2.00390625, 1.01953125],
// 					[0, 0],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.10196078568696976, 0.12941177189350128,
// 					0.09803921729326248, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [1.49609375, 0.51171875],
// 			},
// 		],
// 		"'": [
// 			{
// 				id: "JkfWoI36YtjWymEtb2Cax",
// 				type: "freedraw",
// 				x: 459.19140625,
// 				y: 214.0078125,
// 				width: 8.01953125,
// 				height: 24.99609375,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1563927561,
// 				version: 8,
// 				versionNonce: 1038191559,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213118389,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.0234375, 4.48046875],
// 					[-0.98046875, 10.484375],
// 					[-3.49609375, 18.4765625],
// 					[-4.98828125, 21.9921875],
// 					[-6.484375, 24.99609375],
// 					[-6.99609375, 24.99609375],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.1725490242242813, 0.15294118225574493,
// 					0.15294118225574493, 0.1568627506494522, 0.11764705926179886, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-6.99609375, 24.99609375],
// 			},
// 		],
// 		'"': [
// 			{
// 				id: "xthcFi7tG-YNmrgV6ty9c",
// 				type: "freedraw",
// 				x: 458.2109375,
// 				y: 219.98828125,
// 				width: 6.99609375,
// 				height: 25.50390625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 675841543,
// 				version: 9,
// 				versionNonce: 2011820553,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213120148,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.4921875, 0.5078125],
// 					[0.98046875, 3.00390625],
// 					[-1.0234375, 9.01171875],
// 					[-3.02734375, 15.5],
// 					[-4.51953125, 21.5078125],
// 					[-5.03125, 25.50390625],
// 					[-5.50390625, 25.50390625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.09803921729326248, 0.10980392247438431, 0.125490203499794,
// 					0.125490203499794, 0.12156862765550613, 0.0941176488995552, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-5.50390625, 25.50390625],
// 			},
// 			{
// 				id: "wW2MEWcMT6BGuLPz6pztG",
// 				type: "freedraw",
// 				x: 447.71484375,
// 				y: 225.00390625,
// 				width: 6.01171875,
// 				height: 21.98828125,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 220943911,
// 				version: 9,
// 				versionNonce: 574263273,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213120422,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[-0.5078125, 0.98828125],
// 					[-2.51171875, 4.984375],
// 					[-4.0078125, 10.484375],
// 					[-5.5, 16.4921875],
// 					[-6.01171875, 21],
// 					[-6.01171875, 21.48046875],
// 					[-6.01171875, 21.98828125],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.10980392247438431, 0.12156862765550613,
// 					0.12156862765550613, 0.11372549086809158, 0.07058823853731155,
// 					0.0470588244497776, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-6.01171875, 21.98828125],
// 			},
// 		],
// 		"«": [
// 			{
// 				id: "laJL_Jqo84tBSOM0SSLu_",
// 				type: "freedraw",
// 				x: 444.69140625,
// 				y: 252.01171875,
// 				width: 19.4921875,
// 				height: 29.9765625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1776576937,
// 				version: 18,
// 				versionNonce: 948695911,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213122067,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[1.01953125, 0],
// 					[2.00390625, 0],
// 					[1.4921875, 0.9921875],
// 					[-2.00390625, 2.97265625],
// 					[-9.984375, 8.47265625],
// 					[-13.9921875, 11.98828125],
// 					[-15.99609375, 15.49609375],
// 					[-15.484375, 18.4765625],
// 					[-12.5, 20.99609375],
// 					[-7.98046875, 23.48828125],
// 					[-3.5, 25.47265625],
// 					[-0.984375, 26.97265625],
// 					[2.00390625, 28.4765625],
// 					[3.0234375, 29.49609375],
// 					[3.0234375, 29.9765625],
// 					[3.49609375, 29.9765625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.0784313753247261, 0.08235294371843338,
// 					0.10588235408067703, 0.11764705926179886, 0.14901961386203766,
// 					0.16862745583057404, 0.20392157137393951, 0.22745098173618317,
// 					0.23529411852359772, 0.24313725531101227, 0.24313725531101227,
// 					0.21176470816135406, 0.15294118225574493, 0.09019608050584793,
// 					0.05098039284348488, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [3.49609375, 29.9765625],
// 			},
// 			{
// 				id: "tx8tSmLQ5o0pPBBlvJ4rd",
// 				type: "freedraw",
// 				x: 466.1875,
// 				y: 259.0078125,
// 				width: 17.01953125,
// 				height: 18.4765625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 1533698409,
// 				version: 16,
// 				versionNonce: 1342489959,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213122473,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.51171875, 0.99609375],
// 					[0.51171875, 1.984375],
// 					[-0.46875, 3.99609375],
// 					[-6.99609375, 7.9921875],
// 					[-11.00390625, 9.9765625],
// 					[-11.984375, 10.484375],
// 					[-12.49609375, 13.48828125],
// 					[-9.47265625, 14.9921875],
// 					[-5.5, 16.4921875],
// 					[-1.4921875, 17.484375],
// 					[2.00390625, 17.99609375],
// 					[4.0078125, 17.99609375],
// 					[4.5234375, 18.4765625],
// 					[4.5234375, 18.4765625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.06666667014360428, 0.0784313753247261,
// 					0.08235294371843338, 0.12156862765550613, 0.125490203499794,
// 					0.13333334028720856, 0.1725490242242813, 0.1921568661928177, 0.2078431397676468,
// 					0.21176470816135406, 0.20392157137393951, 0.1725490242242813,
// 					0.10196078568696976, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [4.5234375, 18.4765625],
// 			},
// 		],
// 		"»": [
// 			{
// 				id: "DpXgD9RSnmdglY4dGoemT",
// 				type: "freedraw",
// 				x: 460.6875,
// 				y: 254.984375,
// 				width: 13.01171875,
// 				height: 28.50390625,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 417453991,
// 				version: 19,
// 				versionNonce: 171046697,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213124266,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[-0.984375, -1.5],
// 					[-0.47265625, -1.5],
// 					[0.5078125, -0.9921875],
// 					[5.03125, 1.50390625],
// 					[6.5234375, 2.51953125],
// 					[11.00390625, 7.51171875],
// 					[11.515625, 11.5078125],
// 					[10.4921875, 14.5078125],
// 					[7.50390625, 18.0234375],
// 					[4.51953125, 20.99609375],
// 					[2.00390625, 23.0078125],
// 					[0, 24.51171875],
// 					[-0.47265625, 25.0234375],
// 					[-0.47265625, 26.015625],
// 					[-0.47265625, 26.5234375],
// 					[-0.984375, 26.5234375],
// 					[-1.49609375, 27.00390625],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.07450980693101883, 0.1725490242242813, 0.1882352977991104,
// 					0.22745098173618317, 0.23529411852359772, 0.2549019753932953,
// 					0.2549019753932953, 0.2549019753932953, 0.24313725531101227,
// 					0.23529411852359772, 0.23137255012989044, 0.23529411852359772,
// 					0.23529411852359772, 0.21568627655506134, 0.125490203499794, 0.062745101749897,
// 					0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [-1.49609375, 27.00390625],
// 			},
// 			{
// 				id: "hsamVLEkf4IdEbXxPVZAa",
// 				type: "freedraw",
// 				x: 439.1875,
// 				y: 257.50390625,
// 				width: 10.0234375,
// 				height: 27.48828125,
// 				angle: 0,
// 				strokeColor: "#1e1e1e",
// 				backgroundColor: "transparent",
// 				fillStyle: "solid",
// 				strokeWidth: 2,
// 				strokeStyle: "solid",
// 				roughness: 1,
// 				opacity: 100,
// 				groupIds: [],
// 				frameId: null,
// 				roundness: null,
// 				seed: 353048327,
// 				version: 18,
// 				versionNonce: 268930793,
// 				isDeleted: false,
// 				boundElements: null,
// 				updated: 1751213124876,
// 				link: null,
// 				locked: false,
// 				points: [
// 					[0, 0],
// 					[0.51171875, 1.50390625],
// 					[1.0234375, 1.98828125],
// 					[2.00390625, 2.5],
// 					[3.5, 3.48828125],
// 					[4.51953125, 4.48046875],
// 					[8.01953125, 7],
// 					[9.51171875, 8.98828125],
// 					[10.0234375, 11.48046875],
// 					[9.51171875, 14.48046875],
// 					[7.5078125, 17.00390625],
// 					[4.0078125, 22.50390625],
// 					[2.00390625, 25.4765625],
// 					[1.0234375, 26.98046875],
// 					[1.0234375, 27.48828125],
// 					[1.49609375, 27.48828125],
// 					[1.49609375, 26.98046875],
// 				],
// 				pressures: [
// 					0.0784313753247261, 0.10980392247438431, 0.15294118225574493,
// 					0.1725490242242813, 0.18431372940540314, 0.19607843458652496,
// 					0.2235294133424759, 0.239215686917305, 0.239215686917305, 0.23137255012989044,
// 					0.22745098173618317, 0.22745098173618317, 0.2235294133424759,
// 					0.21568627655506134, 0.18431372940540314, 0.05098039284348488, 0,
// 				],
// 				simulatePressure: false,
// 				lastCommittedPoint: [1.49609375, 26.98046875],
// 			},
// 		],
// 		"„": [],
// 	},
// };

import { CHARS } from "./chars";

const CAP_HEIGHT = 70;
const X_HEIGHT = 50;
const SMALL_PUNCTUATION_HEIGHT = 8;
const LETTER_SPACING = 18;

const BASELINE_OFFSET_PERCENTS: Record<string, number> = {
	g: 0.2,
	j: 0.2,
	p: 0.2,
	q: 0.2,
	y: 0.2,
	",": 0.5,
	".": 0.2,
	";": 0.3,
	"'": -5,
	'"': -2.5,
	"-": -5,
	"=": -0.5,
};

const NO_SCALE_CHARS = new Set([",", ".", "'", "`"]);
const SMALL_SCALE_CHARS = new Set([":", ";", "=", '"']);

function getTargetHeight(char: string): number {
	if (NO_SCALE_CHARS.has(char)) return SMALL_PUNCTUATION_HEIGHT;
	if (SMALL_SCALE_CHARS.has(char)) return SMALL_PUNCTUATION_HEIGHT * 3;
	if (["à", "è", "é", "ì", "ò", "ù"].includes(char)) return CAP_HEIGHT * 0.9;
	if (char === "-") return 1.5;
	if ((char >= "A" && char <= "Z") || ["(", ")", "[", "]", "{", "}"].includes(char))
		return CAP_HEIGHT;
	if (["b", "d", "f", "h", "k", "l", "t"].includes(char)) return CAP_HEIGHT;
	return X_HEIGHT;
}

export async function drawText(
	api,
	text: string,
	originX: number,
	originY: number,
	scale = 0.5,
	maxXDisplacement = 1000,
) {
	const lines = text.split("\n");
	let currentX = originX;
	let currentY = originY;

	// You can adjust these constants as needed for proper spacing.
	const SPACE_WIDTH = 40 * scale;
	const TAB_SPACING = 4 * SPACE_WIDTH;
	const LINE_HEIGHT = 200 * scale;

	for (let i = 0; i < lines.length; i++) {
		// Handle tabs: split line by tab characters.
		const parts = lines[i].split("\t");
		for (let j = 0; j < parts.length; j++) {
			// Split on spaces without filtering out empty strings to preserve multiple spaces.
			const words = parts[j].split(" ");
			for (const word of words) {
				if (word === "") {
					// Extra space when encountering an empty token.
					currentX += SPACE_WIDTH;
				} else {
					const wordWidth = await drawWord(api, word, currentX, currentY, scale);
					currentX += wordWidth + SPACE_WIDTH;
				}
				if (currentX - originX > maxXDisplacement) {
					currentX = originX;
					currentY += LINE_HEIGHT;
				}
			}
			// If there was a tab, add extra spacing.
			if (j < parts.length - 1) {
				currentX += TAB_SPACING;
			}
		}
		// Newline: reset x and move y down.
		if (i < lines.length - 1) {
			currentX = originX;
			currentY += LINE_HEIGHT;
		}
	}
	return { finalX: currentX, finalY: currentY };
}

export async function drawWord(
	api,
	word: string,
	originX: number,
	originY: number,
	scale = 0.5,
) {
	let currentX = originX;
	for (const c of word) {
		const rawEls = CHARS[c];
		if (!rawEls) {
			console.warn(`Character "${c}" not found! Skipping.`);
			continue;
		}

		const metrics = getCharMetrics(c, rawEls, scale);
		await drawChar(api, c, currentX, originY, scale, metrics as any);

		currentX += metrics.advanceWidth + LETTER_SPACING * scale;
	}
	return currentX - originX;
}

function getCharMetrics(char: string, rawElements, userScale: number) {
	let charMinX = Infinity,
		charMaxX = -Infinity;
	let charMinY = Infinity,
		charMaxY = -Infinity;

	for (const el of rawElements) {
		for (const [px, py] of el.points) {
			const x = el.x + px;
			const y = el.y + py;
			if (x < charMinX) charMinX = x;
			if (x > charMaxX) charMaxX = x;
			if (y < charMinY) charMinY = y;
			if (y > charMaxY) charMaxY = y;
		}
	}

	const charHeight = charMaxY - charMinY;
	const charWidth = charMaxX - charMinX;
	const targetHeight = getTargetHeight(char);
	const normalizedScale = userScale * (targetHeight / charHeight);
	const advanceWidth = charWidth * normalizedScale;

	return {
		charMinX,
		charMinY,
		charHeight,
		normalizedScale,
		advanceWidth,
	};
}

export async function drawChar(
	api,
	char: string,
	originX: number,
	originY: number,
	userScale: number,
	metrics = null,
) {
	const rawElements = CHARS[char];
	if (!rawElements) throw new Error(`Character "${char}" not found!`);

	metrics = (metrics as any) || getCharMetrics(char, rawElements, userScale);
	const { charMinX, charMinY, charHeight, normalizedScale } = metrics as any;

	const allYs = rawElements.flatMap(el => el.points.map(([_, py]) => el.y + py));
	const sortedYs = [...allYs].sort((a, b) => a - b);
	const baselineY = sortedYs[Math.floor(sortedYs.length * 0.9)];

	const baselineOffset = originY - normalizedScale * (baselineY - charMinY);
	const descenderOffset =
		(BASELINE_OFFSET_PERCENTS[char] ?? 0) * charHeight * normalizedScale;

	for (const el of rawElements) {
		const offsetX = originX + normalizedScale * (el.x - charMinX);
		const offsetY =
			baselineOffset + normalizedScale * (el.y - charMinY) + descenderOffset;

		await performFreeDraw(api, el, offsetX, offsetY, normalizedScale);
		await new Promise(resolve => setTimeout(resolve, 0.5 + Math.random() * 0.5));
	}
}

async function performFreeDraw(api, rawElement, originX, originY, scale = 1) {
	const elementId = `live-freedraw-${Date.now()}`;
	const baseElement = {
		...rawElement,
		id: elementId,
		x: originX,
		y: originY,
		points: [],
		pressures: [],
		version: 1,
		isDeleted: false,
		lastCommittedPoint: null,
		updated: Date.now(),
	};

	for (let i = 0; i < rawElement.points.length; i++) {
		const [px, py] = rawElement.points[i];
		const pressure = rawElement.pressures?.[i] ?? 0.5;

		const scaledPoint: [number, number] = [px * scale, py * scale];
		baseElement.points.push(scaledPoint);
		baseElement.pressures.push(pressure);
		baseElement.lastCommittedPoint = scaledPoint;
		baseElement.version++;

		const xs = baseElement.points.map(p => p[0]);
		const ys = baseElement.points.map(p => p[1]);
		baseElement.width = Math.max(...xs) - Math.min(...xs);
		baseElement.height = Math.max(...ys) - Math.min(...ys);

		const cloned = {
			...baseElement,
			versionNonce: Math.floor(Math.random() * 1000000000),
			updated: Date.now(),
		};

		const existing = api.getSceneElements();
		const updated = [...existing.filter(e => e.id !== cloned.id), cloned];
		api.updateScene({ elements: updated });

		await new Promise(resolve => setTimeout(resolve, 0.5 + Math.random() * 0.5));
	}
}
